import React, { useState, useEffect, useLayoutEffect, useRef, useCallback } from "react";
import Parse from "../parseClient";
import "./WordHit.css";
import "./HeaderSquares.css";
import "./AuthModal.css";
import "./MenuModal.css";
import "./FaqModal.css";
import "./AboutModal.css";
// FEATURE: BATTLE_MODE
import "./BattleModeModal.css";
// END FEATURE: BATTLE_MODE
import mainLogo from "../assets/images/mainLogo.png"
import nextLogo from "../assets/images/nextin.png";
import doneImage from "../assets/images/done_center.png";
import exampleNL1 from "../assets/images/exampleNL1.png"
import exampleNL2 from "../assets/images/exampleNL2.png"
import exampleNL3 from "../assets/images/exampleNL3.png"
import exampleEN1 from "../assets/images/exampleEN1.png"
import exampleEN2 from "../assets/images/exampleEN2.png"
import exampleEN3 from "../assets/images/exampleEN3.png"
import profileDefault from "../assets/images/profile-default.png";

import { Share2, Share2Icon, Info, Trophy, Swords, Lightbulb } from "lucide-react";
import { Check, ListX, RotateCw, Pointer } from "lucide-react";
import CreateCustomWordHit from "./CreateCustomWordHit";
import AuthModal, { AuthModes } from "./AuthModal";
import { getBranchCustomGame } from "../utils/branchClient";
import { getAppSearchString, getPublisherId } from "../utils/publisher";
import { getStoredScores, updateScores, overwriteStoredScores, rewardForGuess } from "../utils/scores";
import {
  getCurrentUser,
  getUserScores,
  saveUserScores,
  getUserFinishedIds,
  addUserFinishedId,
  autoSignInWithApple,
  savePlaySequence,
  addFriend,
  fetchCompetitionLeaderboard,
  logOutUser,
} from "../utils/authService";
import {
  storePendingSave,
  setupNetworkListener,
  retryPendingSaves,
  getPendingSaves,
} from "../utils/pendingSaves";
import useCompetitionLeaderboard from "../hooks/useCompetitionLeaderboard";
import {
  initShareResultTracking,
  addShareResultAction,
  loadShareResultActions,
  getShareResultActions,
} from "../utils/shareResultTracker";
import {
  shouldShowTutorial,
  markTutorialAsShown,
  getTutorialLabel,
  isTutorialGame,
  TUTORIAL_GAME_ID,
  PRACTICE_GAME_ID_2,
  PRACTICE_GAME_ID_3,
  disableTutorialPermanently,
  isTutorialPermanentlyDisabled,
} from "../utils/tutorialManager";
import { ensureDictionaryLoaded, isDictionaryReady, isValidWord, MAX_GUESS_WORD_LENGTH } from "../utils/wordDictionary";
import { isDictionaryGuessEnabled } from "../utils/featureFlags";

export let globalCounter = "";
import Loader from "./Loader/Loader";
import ErrorScreen from "./ErrorScreen";
import * as amplitude from '@amplitude/unified';
import MenuModal from "./MenuModal";
import StatisticsModal from "./StatisticsModal";
import ProfileModal from "./ProfileModal";
import GameResultModal from "./GameResultModal";
import ScoreCompetitionsModal from "./ScoreCompetitionsModal";
import ConfettiOverlay from "./ConfettiOverlay";
import RemindersModal from "./RemindersModal";
import Banner from "./Banner";
import AboutModal from "./AboutModal";
import ShareLegendModal from "./ShareLegendModal";
// FEATURE: BATTLE_MODE
import BattleModeModal from "./BattleModeModal";
import WordHitBattle from "./WordHitBattle";
// END FEATURE: BATTLE_MODE
import { ActivityTypes } from '../utils/activityTypes';
import {
  requestNotificationPermission,
  ensureDailyNotificationScheduled,
  scheduleNotificationForTomorrow,
  logScheduledNotifications,
  rescheduleRepeatFromTomorrow,
  cancelTodaysNotification,
  hasAskedForPermission,
  hasPlayedToday,
  checkNotificationPermission,
  checkAppUpdateRequired,
  linkInstallationToUser,
  getLastKnownPushToken,
  getPendingBattleIdFromNotification,
  getPendingBattleIdFromNative,
  clearPendingBattleIdFromNative,
} from "../utils/notificationService";
import { isIOS, isNative, isAndroid, isWeb } from "../utils/platform";
import { LocalNotifications } from '@capacitor/local-notifications';
import { share as platformShare } from "../utils/share";
import { mapActivityTypeToPlatform } from "../utils/sharePlatformMapper";
// FEATURE: BATTLE_MODE
import { isBattleModeEnabled, isBattleModeAvailableOnPlatform } from "../utils/featureFlags";
import { loadAllBattleGames, restoreFromStorage, getBattleGameByIdNumber as getBattleGameByIdNumberFromCache } from "../utils/battleGamesCache";
// END FEATURE: BATTLE_MODE



// Import the functions you need from the SDKs you need
import { logEvent } from "firebase/analytics";
import { analytics } from "../utils/firebase";

// Check if prefill=qazx is in URL - if so, skip Amplitude initialization
const shouldSkipAmplitude = (() => {
  if (typeof window === 'undefined') return false;
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const prefill = urlParams.get("prefill");
    return prefill === "qazx";
  } catch (e) {
    return false;
  }
})();

if (!shouldSkipAmplitude) {
amplitude.initAll('6723f4fabad1562cbf204546e8235978', {"serverZone":"EU","analytics":{"autocapture":true}});
}

// Make Amplitude globally available so native iOS code can call it directly
if (typeof window !== 'undefined') {
  try {
    window.amplitude = amplitude;
  } catch (e) {
    console.warn("Failed to set window.amplitude:", e);
  }
  
  // SAFE: Only set up TO JS monitoring if we're in a browser environment
  // Don't override console methods as they can cause crashes
  // Instead, we'll rely on the native code to set global variables
  // and the share.js code to poll for them
}

const GRID_SIZE = 7;
const MAX_CLICKS = 7;
const LOADER_MIN_DISPLAY_MS = 3100;
// DEBUG: Set to true to keep loader visible for design/debugging
const DEBUG_KEEP_LOADER_VISIBLE = false;

/*
  getDailySeed()
  -> deterministic seed based on today's date (YYYYMMDD as number)
*/
function getDailySeed() {
  const d = new Date();
  const year = d.getFullYear();
  const month = d.getMonth() + 1;
  const day = d.getDate();
  return parseInt(
    `${year}${month.toString().padStart(2, "0")}${day
      .toString()
      .padStart(2, "0")}`,
    10
  );
}

/*
  mulberry32(seed)
  -> deterministic RNG. Same seed -> same sequence.
*/
function mulberry32(seed) {
  return function () {
    seed |= 0;
    seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967295;
  };
}

/*
  createEmptyBoard()
  -> returns GRID_SIZE x GRID_SIZE array filled with ""
*/
function createEmptyBoard() {
  return Array.from({ length: GRID_SIZE }, () =>
    Array.from({ length: GRID_SIZE }, () => "")
  );
}

/*
  placeWordDeterministic(board, word, rng)
  -> tries to place word horizontally OR vertically:
     - pick dir with rng()
     - gather all valid start positions
     - pick one with rng()
     - writes letters into board
     returns { word, r, c, dir } or false
*/
// function placeWordDeterministic(board, word, rng) {
//   const letters = word.split("");
//   const size = board.length;

//   const dir = rng() < 0.5 ? "H" : "V";
//   const possibleStarts = [];

//   for (let r = 0; r < size; r++) {
//     for (let c = 0; c < size; c++) {
//       let fits = true;
//       for (let i = 0; i < letters.length; i++) {
//         const rr = dir === "H" ? r : r + i;
//         const cc = dir === "H" ? c + i : c;

//         // out of bounds -> invalid
//         if (rr >= size || cc >= size) {
//           fits = false;
//           break;
//         }
//         // conflicting different letter -> invalid
//         if (board[rr][cc] && board[rr][cc] !== letters[i]) {
//           fits = false;
//           break;
//         }
//       }
//       if (fits) {
//         possibleStarts.push({ r, c, dir });
//       }
//     }
//   }

//   if (possibleStarts.length === 0) {
//     return false;
//   }

//   const startIndex = Math.floor(rng() * possibleStarts.length);
//   const start = possibleStarts[startIndex];

//   for (let i = 0; i < letters.length; i++) {
//     const rr = start.dir === "H" ? start.r : start.r + i;
//     const cc = start.dir === "H" ? start.c + i : start.c;
//     board[rr][cc] = letters[i];
//   }

//   return { word, ...start };
// }

//origineel
const DIRECTION_DELTAS = {
  H: { dr: 0, dc: 1 },
  V: { dr: 1, dc: 0 },
  DR: { dr: 1, dc: 1 },
  DL: { dr: 1, dc: -1 },
};

const ALL_DIRECTIONS = ["H", "V", "DR", "DL"];

function getDirectionDelta(dir) {
  return DIRECTION_DELTAS[dir] || null;
}

function cloneBoard(board) {
  return board.map((row) => row.slice());
}

function getValidStartsForDirection(board, letters, dir) {
  const size = board.length;
  const dirDelta = getDirectionDelta(dir);
  if (!dirDelta) return [];
  const starts = [];

  for (let r = 0; r < size; r++) {
    for (let c = 0; c < size; c++) {
      const positions = [];
      let fits = true;
      for (let i = 0; i < letters.length; i++) {
        const rr = r + dirDelta.dr * i;
        const cc = c + dirDelta.dc * i;
        if (rr < 0 || cc < 0 || rr >= size || cc >= size) { fits = false; break; }
        const cell = board[rr][cc];
        if (cell && cell !== letters[i]) { fits = false; break; }
        positions.push({ rr, cc, overlap: !!cell });
      }
      if (!fits) continue;

      const positionsSet = new Set(positions.map((p) => `${p.rr},${p.cc}`));

      for (const pos of positions) {
        if (pos.overlap) continue;
        for (let dr = -1; dr <= 1; dr++) {
          for (let dc = -1; dc <= 1; dc++) {
            if (dr === 0 && dc === 0) continue;
            const nr = pos.rr + dr;
            const nc = pos.cc + dc;
            if (nr < 0 || nc < 0 || nr >= size || nc >= size) continue;
            if (positionsSet.has(`${nr},${nc}`)) continue;
            if (board[nr][nc]) { fits = false; break; }
          }
          if (!fits) break;
        }
        if (!fits) break;
      }
      if (!fits) continue;

      const startPos = positions[0];
      const endPos = positions[positions.length - 1];
      const hasOverlap = positions.some((p) => p.overlap);

      // Check that words in the same line don't touch or cross each other
      // First, check if overlaps form a contiguous sequence in the same direction
      // (which would indicate another word in the same line)
      if (hasOverlap) {
        const overlappingPositions = positions.filter((p) => p.overlap);
        // Check if overlapping positions are contiguous in the same direction
        if (overlappingPositions.length > 1) {
          overlappingPositions.sort((a, b) => {
            const aIndex = positions.findIndex((p) => p.rr === a.rr && p.cc === a.cc);
            const bIndex = positions.findIndex((p) => p.rr === b.rr && p.cc === b.cc);
            return aIndex - bIndex;
          });
          // Check if they form a contiguous sequence
          let isContiguous = true;
          for (let i = 1; i < overlappingPositions.length; i++) {
            const prev = overlappingPositions[i - 1];
            const curr = overlappingPositions[i];
            const expectedR = prev.rr + dirDelta.dr;
            const expectedC = prev.cc + dirDelta.dc;
            if (curr.rr !== expectedR || curr.cc !== expectedC) {
              isContiguous = false;
              break;
            }
          }
          // If overlaps are contiguous in the same direction, it means we're overlapping
          // with another word in the same line - reject this placement
          if (isContiguous && overlappingPositions.length >= 2) {
            fits = false;
          }
        } else if (overlappingPositions.length === 1) {
          // Single overlap - check if there are occupied cells in the same direction
          // before or after it, which would indicate a word in the same line
          const overlapPos = overlappingPositions[0];
          const beforeR = overlapPos.rr - dirDelta.dr;
          const beforeC = overlapPos.cc - dirDelta.dc;
          const afterR = overlapPos.rr + dirDelta.dr;
          const afterC = overlapPos.cc + dirDelta.dc;
          
          const hasBefore = beforeR >= 0 && beforeC >= 0 && beforeR < size && beforeC < size &&
            !positionsSet.has(`${beforeR},${beforeC}`) && board[beforeR][beforeC];
          const hasAfter = afterR >= 0 && afterC >= 0 && afterR < size && afterC < size &&
            !positionsSet.has(`${afterR},${afterC}`) && board[afterR][afterC];
          
          // If there's an occupied cell before or after the overlap in the same direction,
          // it means there's another word in the same line - reject
          if (hasBefore || hasAfter) {
            fits = false;
          }
        }
      }
      if (!fits) continue;

      // Check backwards in the same direction to ensure no word is adjacent
      if (!startPos.overlap) {
        const prevR = startPos.rr - dirDelta.dr;
        const prevC = startPos.cc - dirDelta.dc;
        if (
          prevR >= 0 && prevC >= 0 && prevR < size && prevC < size &&
          !positionsSet.has(`${prevR},${prevC}`) &&
          board[prevR][prevC]
        ) {
          // Cell immediately before is occupied - word would touch another word
          fits = false;
        }
      }
      if (!fits) continue;

      // Check forwards in the same direction to ensure no word is adjacent
      if (!endPos.overlap) {
        const nextR = endPos.rr + dirDelta.dr;
        const nextC = endPos.cc + dirDelta.dc;
        if (
          nextR >= 0 && nextC >= 0 && nextR < size && nextC < size &&
          !positionsSet.has(`${nextR},${nextC}`) &&
          board[nextR][nextC]
        ) {
          // Cell immediately after is occupied - word would touch another word
          fits = false;
        }
      }
      if (!fits) continue;

      starts.push({ r, c, dir, hasOverlap });
    }
  }

  return starts;
}

function placeLettersOnBoard(board, letters, placement) {
  const dirDelta = getDirectionDelta(placement.dir);
  for (let i = 0; i < letters.length; i++) {
    const rr = placement.r + dirDelta.dr * i;
    const cc = placement.c + dirDelta.dc * i;
    board[rr][cc] = letters[i];
  }
}

function shuffleWithRng(arr, rng) {
  const copy = arr.slice();
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    const tmp = copy[i];
    copy[i] = copy[j];
    copy[j] = tmp;
  }
  return copy;
}

function placeWordDeterministic(board, word, rng, preferredDirs = null) {
  const letters = word.split("");
  const isBoardEmpty = board.every((row) => row.every((cell) => !cell));

  let dirs;
  if (preferredDirs && preferredDirs.length > 0) {
    dirs = preferredDirs.slice();
  } else if (isBoardEmpty) {
    const diag = shuffleWithRng(["DR", "DL"], rng);
    const others = shuffleWithRng(["H", "V"], rng);
    dirs = [...diag, ...others];
  } else {
    dirs = shuffleWithRng(["H", "V", "DR", "DL"], rng);
  }

  for (const dir of dirs) {
    const starts = getValidStartsForDirection(board, letters, dir);
    if (starts.length === 0) continue;
    const chosen = starts[Math.floor(rng() * starts.length)];
    placeLettersOnBoard(board, letters, chosen);
    return { word, ...chosen };
  }

  return false;
}

function buildDirectionOrder(priorityGroups, rng) {
  return priorityGroups.reduce((order, group) => {
    const normalized = Array.isArray(group) ? group : [group];
    return order.concat(shuffleWithRng(normalized, rng));
  }, []);
}

function attemptPlacementRecursive(
  words,
  lettersList,
  index,
  board,
  placements,
  rng,
  dirPlans,
  verticalPlaced,
  crossPlaced,
  diagonalPlaced,
  requireVertical,
  requireCross,
  requireDiagonal
) {
  if (index >= words.length) {
    if (requireVertical && !verticalPlaced) {
      return null;
    }
    if (requireCross && !crossPlaced) {
      return null;
    }
    if (requireDiagonal && !diagonalPlaced) {
      return null;
    }
    return { board, placements, verticalPlaced, crossPlaced, diagonalPlaced };
  }

  const planIndex = Math.min(index, dirPlans.length - 1);
  const priorityGroups = dirPlans[planIndex] || [ALL_DIRECTIONS];
  const directionOrder = buildDirectionOrder(priorityGroups, rng);
  const letters = lettersList[index];
  const word = words[index];

  for (const dir of directionOrder) {
    const starts = getValidStartsForDirection(board, letters, dir);
    if (starts.length === 0) continue;

    const overlapStarts = [];
    const nonOverlapStarts = [];
    for (const s of starts) {
      if (s.hasOverlap) {
        overlapStarts.push(s);
      } else {
        nonOverlapStarts.push(s);
      }
    }

    const startOrder = [
      ...shuffleWithRng(overlapStarts, rng),
      ...shuffleWithRng(nonOverlapStarts, rng),
    ];
    for (const start of startOrder) {
      const nextBoard = cloneBoard(board);
      placeLettersOnBoard(nextBoard, letters, start);
      const { hasOverlap, ...placementWithoutOverlap } = start;
      const result = attemptPlacementRecursive(
        words,
        lettersList,
        index + 1,
        nextBoard,
        placements.concat({ word, ...placementWithoutOverlap }),
        rng,
        dirPlans,
        verticalPlaced || dir === "V",
        crossPlaced || hasOverlap,
        diagonalPlaced || dir === "DR" || dir === "DL",
        requireVertical,
        requireCross,
        requireDiagonal
      );
      if (result) {
        return result;
      }
    }
  }

  return null;
}

function tryPlaceWordsWithPlans(words, rng, dirPlans, options = {}) {
  const {
    requireVertical = true,
    requireCross = false,
    requireDiagonal = false,
  } = options;
  const board = createEmptyBoard();
  const lettersList = words.map((w) => w.split(""));
  const result = attemptPlacementRecursive(
    words,
    lettersList,
    0,
    board,
    [],
    rng,
    dirPlans,
    false,
    false,
    false,
    requireVertical,
    requireCross,
    requireDiagonal
  );
  if (!result) return null;
  return {
    board: result.board,
    placements: result.placements,
    verticalPlaced: result.verticalPlaced,
    crossPlaced: result.crossPlaced,
    diagonalPlaced: result.diagonalPlaced,
  };
}

function expandPlans(basePlans, count) {
  if (!basePlans || basePlans.length === 0) {
    return Array.from({ length: count }, () => [ALL_DIRECTIONS]);
  }
  const expanded = [];
  for (let i = 0; i < count; i++) {
    expanded.push(basePlans[Math.min(i, basePlans.length - 1)]);
  }
  return expanded;
}


/*
  revealAllOfLetter(letter, revealed, board)
  -> reveal all cells with this letter
*/
function revealAllOfLetter(letter, revealed, board) {
  const newRev = revealed.map((row) => row.slice());
  for (let r = 0; r < GRID_SIZE; r++) {
    for (let c = 0; c < GRID_SIZE; c++) {
      if (board[r][c] === letter) {
        newRev[r][c] = true;
      }
    }
  }
  return newRev;
}

/*
  revealWord(word, placements, revealed)
  -> reveal all cells of that word placement
*/

function revealWord(word, placements, revealed) {

  const placement = placements.find((p) => p.word === word);
  if (!placement) return revealed;
  const newRev = revealed.map((row) => row.slice());
  for (let i = 0; i < placement.word.length; i++) {
    let rr = placement.r;
    let cc = placement.c;
    if (placement.dir === "H") {
      cc = placement.c + i;
    } else if (placement.dir === "V") {
      rr = placement.r + i;
    } else if (placement.dir === "DR") {
      rr = placement.r + i; cc = placement.c + i;
    } else if (placement.dir === "DL") {
      rr = placement.r + i; cc = placement.c - i;
    }
    newRev[rr][cc] = true;
  }
  return newRev;
}

/*
  getWordCells(word, placements)
  -> returns [{r,c}, ...] for the placed word
*/
function getWordCells(word, placements) {
  const placement = (placements || []).find((p) => p.word === word);
  if (!placement) return [];
  const cells = [];
  for (let i = 0; i < placement.word.length; i++) {
    let rr = placement.r;
    let cc = placement.c;
    if (placement.dir === "H") {
      cc = placement.c + i;
    } else if (placement.dir === "V") {
      rr = placement.r + i;
    } else if (placement.dir === "DR") {
      rr = placement.r + i;
      cc = placement.c + i;
    } else if (placement.dir === "DL") {
      rr = placement.r + i;
      cc = placement.c - i;
    }
    cells.push({ r: rr, c: cc });
  }
  return cells;
}

/** Returns all words whose placement includes cell (r, c). */
function getWordsForCell(r, c, placements) {
  const words = [];
  for (const p of placements || []) {
    for (let i = 0; i < p.word.length; i++) {
      let rr = p.r;
      let cc = p.c;
      if (p.dir === "H") cc = p.c + i;
      else if (p.dir === "V") rr = p.r + i;
      else if (p.dir === "DR") { rr = p.r + i; cc = p.c + i; }
      else if (p.dir === "DL") { rr = p.r + i; cc = p.c - i; }
      if (rr === r && cc === c) {
        words.push(String(p.word).toUpperCase());
        break;
      }
    }
  }
  return words;
}

/*
  isWordFullyVisible(word, placements, revealed)
  -> returns true if all cells of that placed word are revealed
*/
//origineel
function isWordFullyVisible(word, placements, revealed) {
  //const [foundWordCount, setFoundWordCount] = useState(0);

  const placement = placements.find((p) => p.word === word);
  if (!placement) return false;
  for (let i = 0; i < placement.word.length; i++) {
    let rr = placement.r;
    let cc = placement.c;
    if (placement.dir === "H") {
      cc = placement.c + i;
    } else if (placement.dir === "V") {
      rr = placement.r + i;
    } else if (placement.dir === "DR") {
      rr = placement.r + i; cc = placement.c + i;
    } else if (placement.dir === "DL") {
      rr = placement.r + i; cc = placement.c - i;
    }
    if (!revealed[rr][cc]) {
      return false;
    }
  }
  return true;
}

// /*
//   isCellInFullyVisibleWord(r,c,...)
//   -> for coloring: if this cell is part of a word
//      that is fully revealed, return true
// */
// const [visibleWords, setVisibleWords] = useState([]);
// function isCellInFullyVisibleWord(r, c, placements, revealed) {
//   for (const p of placements) {
//     for (let i = 0; i < p.word.length; i++) {
//       const rr = p.dir === "H" ? p.r : p.r + i;
//       const cc = p.dir === "H" ? p.c + i : p.c;
//       if (rr === r && cc === c) {
//         // this cell belongs to word p.word
//         if (isWordFullyVisible(p.word, placements, revealed)) {

//           console.log("isCellInFullyVisibleWord",p.word)
//           return true;
//         }
//       }
//     }
//   }
//   return false;
// }

  const fromDate = new Date(2022, 0, 1); // January is month 0
  const currentDate = new Date();
  const timeDiff = currentDate.getTime() - fromDate.getTime();
  // const [isLoading, setIsLoading] = useState(true);

  const utcCurrent = Date.UTC(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );

  const utcFrom = Date.UTC(
    fromDate.getFullYear(),
    fromDate.getMonth(),
    fromDate.getDate()
  );

  const diffInDays = Math.floor((utcCurrent - utcFrom) / (1000 * 60 * 60 * 24));
  let idNumber = diffInDays;

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let overruledId = urlParams.get("id");
  if (overruledId) {
    idNumber = parseInt(overruledId);
  }

/*
  isClassBattleGame()
  -> true if URL has class=battleGame (normale WH-pagina laadt dan uit BattleGame class met id uit URL)
*/
function isClassBattleGame() {
  if (typeof window === "undefined") return false;
  try {
    const urlParams = new URLSearchParams(getAppSearchString());
    return urlParams.get("class") === "battleGame";
  } catch {
    return false;
  }
}

/*
  fetchDailyPuzzleFromParse()
  -> read Theme (string) and Words (array) from Parse class "Game"
  -> fallback if Parse not ready or query fails
*/

/*
  fetchPuzzleFromBattleGame()
  -> when URL has class=battleGame: read Theme and Words from Parse class "BattleGame" by idNumber.
  -> returns same shape as fetchDailyPuzzleFromParse for buildGameForToday.
*/
async function fetchPuzzleFromBattleGame(langString, targetIdNumber) {
  if (targetIdNumber == null || isNaN(Number(targetIdNumber))) {
    throw new Error("idNumber is required for BattleGame.");
  }
  const idNum = Number(targetIdNumber);
  restoreFromStorage();
  let result = getBattleGameByIdNumberFromCache(idNum, langString);
  if (!result && Parse && Parse.Cloud) {
    try {
      const cloud = await Parse.Cloud.run("getBattleGameByIdNumberPublic", { idNumber: idNum });
      if (cloud && cloud.success) {
        const theme = langString === "nl" ? (cloud.themeNL ?? cloud.theme) : (cloud.theme ?? cloud.themeNL);
        const words = langString === "nl" ? (cloud.wordsNL ?? cloud.words) : (cloud.words ?? cloud.wordsNL);
        if (theme && Array.isArray(words)) {
          result = { theme, words, idNumber: cloud.idNumber ?? idNum };
        }
      }
    } catch (e) {
      console.warn("[WordHit] getBattleGameByIdNumberPublic failed:", e);
    }
  }
  if (!result || !result.theme || !Array.isArray(result.words)) {
    throw new Error(langString === "nl"
      ? "BattleGame niet gevonden voor dit idNumber."
      : "BattleGame not found for this idNumber.");
  }
  return {
    theme: result.theme,
    words: result.words.map((w) => String(w).toUpperCase()),
    guidedClicks: null,
    percentageOfWins: 0,
  };
}

async function fetchDailyPuzzleFromParse(langString, targetIdNumber = null) {
  // Use provided idNumber or fall back to global idNumber
  const puzzleIdNumber = targetIdNumber !== null ? targetIdNumber : idNumber;

  // FEATURE: SMART_DATA_CACHING - DISABLED
  // const cachedGameKey = `cachedGame_${puzzleIdNumber}_${langString}`;
  // const cachedGame = localStorage.getItem(cachedGameKey);
  // 
  // if (cachedGame) {
  //   try {
  //     const parsed = JSON.parse(cachedGame);
  //     console.log(`[Game] Using cached game data for idNumber ${puzzleIdNumber} (SMART_DATA_CACHING)`);
  //     return {
  //       theme: parsed.theme,
  //       words: parsed.words,
  //     };
  //   } catch (e) {
  //     console.warn("[Game] Failed to parse cached game data, fetching from Parse");
  //   }
  // }

  if (!Parse || !Parse.Object) {
    throw new Error("Parse is not ready. Cannot load game.");
  }

  const Game = Parse.Object.extend("Game");
  const query = new Parse.Query(Game);

   query.equalTo("idNumber", puzzleIdNumber);


  try {
    let result = await query.first();
    let actualIdNumber = puzzleIdNumber; // Track which idNumber was actually used

    // Backup: if puzzle doesn't exist, use current day of month (1-31) as idNumber
    if (!result) {
      const currentDay = new Date().getDate(); // Day of month (1-31)
      const backupIdNumber = currentDay;
      
      console.log(`[Backup] WordHit with idNumber ${puzzleIdNumber} not found, trying backup idNumber ${backupIdNumber} (day of month)`);
      
      // Retry query with backup idNumber
      const backupQuery = new Parse.Query(Game);
      backupQuery.equalTo("idNumber", backupIdNumber);
      result = await backupQuery.first();
      
      if (!result) {
        throw new Error(langString === "nl" 
          ? "Geen WordHit beschikbaar voor vandaag." 
          : "No WordHit available for today.");
      }
      
      // Update actualIdNumber to backup value for analytics and logging
      actualIdNumber = backupIdNumber;
      console.log(`[Backup] Using backup WordHit with idNumber ${actualIdNumber}`);
    }

    const lost = result.get("lost");
    const won = result.get("won");
    let percentageOfWins = 0;
    if (lost + won > 10) {
      percentageOfWins = Math.round((won / (lost + won)) * 100);
    }

    //Analytics - only call updateLoaded once per day per idNumber
    const loadedCalledKey = `loadedCalled_${actualIdNumber}`;
    const alreadyCalled = localStorage.getItem(loadedCalledKey);
    
    if (!alreadyCalled) {
      const publisherId = getPublisherId();
      Parse.Cloud.run("updateLoaded", {
            idNumber: actualIdNumber,
            publisherId: publisherId || null,
          })
            .then((result) => {
              console.log("Cloud Update successful");
              // Mark as called for this idNumber
              localStorage.setItem(loadedCalledKey, "true");
            })
            .catch((error) => {
              console.error("Cloud Error updating:", error);
            });
    }
    localStorage.setItem("loadedIdNummer", actualIdNumber);

    const theme = langString === "nl" ? result.get("ThemeNL") : result.get("Theme");
    const words = langString === "nl" ? result.get("WordsNL") : result.get("Words");
    // Get localized guidedClicks: guidedClicksNL for Dutch, guidedClicks for English
    const guidedClicks = langString === "nl" 
      ? result.get("guidedClicksNL") 
      : result.get("guidedClicks");

    if (!theme || !Array.isArray(words)) {
      throw new Error("Game data is incomplete (missing theme or words).");
    }

    const gameData = {
      theme,
      words: words.map((w) => String(w).toUpperCase()),
      guidedClicks: guidedClicks || null, // Include localized guidedClicks in returned data
      percentageOfWins,
    };
    
    // FEATURE: SMART_DATA_CACHING - DISABLED
    // try {
    //   localStorage.setItem(cachedGameKey, JSON.stringify(gameData));
    // } catch (e) {
    //   console.warn("[Game] Failed to cache game data:", e);
    // }

    return gameData;
  } catch (err) {
    console.error("Parse query error:", err);
    // Re-throw the error so it can be handled by the caller
    throw err;
  }
}

/*
  checkIfGameExists()
  -> Check if a game with the given idNumber exists in Parse
*/
async function checkIfGameExists(idNumber) {
  if (!Parse || !Parse.Object) {
    return false;
  }

  try {
    const Game = Parse.Object.extend("Game");
    const query = new Parse.Query(Game);
    query.equalTo("idNumber", idNumber);
    const result = await query.first();
    return !!result;
  } catch (err) {
    console.error("Error checking if game exists:", err);
    return false;
  }
}

/*
  buildGameForToday()
  -> 1) load puzzle from Parse
  -> 2) build deterministic board using today's seed
*/
async function buildGameForToday(langString, targetIdNumber = null) {
  // Calculate idNumber if not provided
  if (targetIdNumber === null) {
    const fromDate = new Date(2022, 0, 1);
    const currentDate = new Date();
    const utcCurrent = Date.UTC(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate()
    );
    const utcFrom = Date.UTC(
      fromDate.getFullYear(),
      fromDate.getMonth(),
      fromDate.getDate()
    );
    targetIdNumber = Math.floor((utcCurrent - utcFrom) / (1000 * 60 * 60 * 24));
    
    // Check for URL override
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const overruledId = urlParams.get("id");
    if (overruledId) {
      targetIdNumber = parseInt(overruledId);
    }
  }
  
  const branchCustom = await getBranchCustomGame();

  const sourcePuzzle = branchCustom || (isClassBattleGame()
    ? await fetchPuzzleFromBattleGame(langString, targetIdNumber)
    : await fetchDailyPuzzleFromParse(langString, targetIdNumber));
  
  // Custom Game Override:
  // If we found a branch custom game, we must NOT use the targetIdNumber if it was the tutorial ID.
  // We set it to null (or a distinct non-tutorial ID) to prevent tutorial logic from triggering.
  // This ensures first-time users clicking a custom link see the custom game, not the tutorial.
  let finalIdNumber = targetIdNumber;
  if (branchCustom) {
     finalIdNumber = null; 
  }

  if (branchCustom) {
    try {
      amplitude.track("custom_wordhit_loaded", {
        theme: branchCustom.theme,
        words: branchCustom.words,
        creator: branchCustom.creator,
      });
      if (analytics) {
        logEvent(analytics, "custom_wordhit_loaded", {
          theme: branchCustom.theme,
          word_count: branchCustom.words?.length || 0,
        });
      }
    } catch (eventError) {
      console.warn("custom WordHit load event failed", eventError);
    }
  }
  const puzzle = {
    theme: sourcePuzzle.theme,
    words: sourcePuzzle.words.map((w) => String(w).toUpperCase()),
    creator: sourcePuzzle.creator ? String(sourcePuzzle.creator) : "",
    guidedClicks: sourcePuzzle.guidedClicks || null, // Preserve guidedClicks from source
    percentageOfWins: sourcePuzzle.percentageOfWins ?? 0,
  };
  
  // Debug logging for guidedClicks
  if (puzzle.guidedClicks) {
    console.log(`[GuidedClicks] Found guidedClicks for idNumber ${finalIdNumber}:`, puzzle.guidedClicks);
  }
  // Use idNumber as seed for deterministic board generation
  // This ensures the same puzzle always has the same letter distribution, regardless of when it's loaded
  let seedNum = 1;
  if (finalIdNumber !== null && finalIdNumber !== undefined) {
    seedNum = finalIdNumber;
  } else if (puzzle.creator) {
    // For custom games without idNumber, hash creator + words for deterministic seed
    const seedString = puzzle.creator + puzzle.words.join('');
    let hash = 0;
    for (let i = 0; i < seedString.length; i++) {
      const char = seedString.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    seedNum = Math.abs(hash);
  }
  const rng = mulberry32(seedNum);

  let placementsResult = null;
  const sortedWords = [...puzzle.words].sort((a, b) => b.length - a.length);

  const planOptions = [
    [
      [["DR", "DL"], ["H"], ["V"]],
      [["V"], ["H"], ["DR", "DL"]],
      [["H"], ["DR", "DL"], ["V"]],
    ],
    [
      [["DR", "DL"], ["V"], ["H"]],
      [["V"], ["H"], ["DR", "DL"]],
      [[ALL_DIRECTIONS]],
    ],
    [
      [["V"], ["DR", "DL"], ["H"]],
      [["DR", "DL"], ["H"], ["V"]],
      [[ALL_DIRECTIONS]],
    ],
    [
      [[ALL_DIRECTIONS]],
    ],
  ];

  // First pass: require diagonal + vertical + cross when possible.
  for (const plan of planOptions) {
    const expandedPlans = expandPlans(plan, sortedWords.length);
    placementsResult = tryPlaceWordsWithPlans(sortedWords, rng, expandedPlans, {
      requireVertical: true,
      requireCross: true,
      requireDiagonal: true,
    });
    if (placementsResult) break;
  }

  // Second pass: require diagonal + vertical, cross optional.
  if (!placementsResult) {
    for (const plan of planOptions) {
      const expandedPlans = expandPlans(plan, sortedWords.length);
      placementsResult = tryPlaceWordsWithPlans(sortedWords, rng, expandedPlans, {
        requireVertical: true,
        requireCross: false,
        requireDiagonal: true,
      });
      if (placementsResult) break;
    }
  }

  // Third pass: require vertical + cross.
  if (!placementsResult) {
    for (const plan of planOptions) {
      const expandedPlans = expandPlans(plan, sortedWords.length);
      placementsResult = tryPlaceWordsWithPlans(sortedWords, rng, expandedPlans, {
        requireVertical: true,
        requireCross: true,
        requireDiagonal: false,
      });
      if (placementsResult) break;
    }
  }

  // Fourth pass: require vertical only.
  if (!placementsResult) {
    for (const plan of planOptions) {
      const expandedPlans = expandPlans(plan, sortedWords.length);
      placementsResult = tryPlaceWordsWithPlans(sortedWords, rng, expandedPlans, {
        requireVertical: true,
        requireCross: false,
        requireDiagonal: false,
      });
      if (placementsResult) break;
    }
  }

  const board = placementsResult ? placementsResult.board : createEmptyBoard();
  const placements = placementsResult ? placementsResult.placements : [];

  const builtGame = {
    board,
    theme: puzzle.theme,
    words: puzzle.words,
    placements,
    creator: puzzle.creator,
    idNumber: finalIdNumber,
    guidedClicks: puzzle.guidedClicks || null, // Array of cell coordinates like ["r1c6", "r2c5"]
    percentageOfWins: puzzle.percentageOfWins ?? 0,
  };
  
  // Debug logging
  if (builtGame.guidedClicks) {
    console.log(`[GuidedClicks] Built game with guidedClicks:`, builtGame.guidedClicks);
  }
  
  return builtGame;
}

// Helper function to normalize lang parameter (handles cases where extra text is appended)
function normalizeLangParam(lang) {
  if (!lang) return null;
  const normalized = lang.trim().toLowerCase();
  // Check if it starts with "nl" (Dutch) or "en" (English)
  if (normalized.startsWith("nl")) return "nl";
  if (normalized.startsWith("en")) return "en";
  // Default to "en" if unrecognized
  return "en";
}

export default function WordHit() {
  const [transitioningFromTutorial, setTransitioningFromTutorial] = useState(false);
  // Keep langString in state and update when URL changes
  const [langString, setLangString] = useState(() => {
    const urlParams = new URLSearchParams(getAppSearchString());
    const lang = urlParams.get("lang");
    
    // If URL has lang parameter, normalize it (handles cases with extra text)
    if (lang !== null) {
      return normalizeLangParam(lang);
    }
    
    // Otherwise, detect from browser/device language
    const browserLang = navigator.language || navigator.userLanguage || "en";
    // Check if language starts with "nl" (Dutch)
    return browserLang.toLowerCase().startsWith("nl") ? "nl" : "en";
  });

  const [customLoaderText, setCustomLoaderText] = useState(null);

  // Update langString when URL changes (e.g., navigation, back button)
  useEffect(() => {
    const handleLocationChange = () => {
      const urlParams = new URLSearchParams(getAppSearchString());
      const lang = urlParams.get("lang");
      
      let currentLang;
      if (lang !== null) {
        currentLang = normalizeLangParam(lang);
      } else {
        // Detect from browser/device language
        const browserLang = navigator.language || navigator.userLanguage || "en";
        currentLang = browserLang.toLowerCase().startsWith("nl") ? "nl" : "en";
      }
      
      setLangString((prevLang) => {
        // Only update if it actually changed
        if (prevLang !== currentLang) {
          return currentLang;
        }
        return prevLang;
      });
    };

    // Check on mount and when popstate occurs (back/forward button)
    handleLocationChange();
    window.addEventListener("popstate", handleLocationChange);
    
    // Also check periodically in case URL changes without popstate (e.g., programmatic navigation)
    const interval = setInterval(handleLocationChange, 500);

    return () => {
      window.removeEventListener("popstate", handleLocationChange);
      clearInterval(interval);
    };
  }, []); // Empty dependency array - only run once on mount

const [game, setGame] = useState(null);
const [countDownTimer, setCountDownTimer] = useState("");
const [explanationStep, setExplanationStep] = useState(1);
const [visibleWords, setVisibleWords] = useState([]);
let uniqueVisibleWordsCount = new Set(visibleWords).size;
const initialScores = getStoredScores();
const [scoreDictionary, setScoreDictionary] = useState(() => ({
  idNumber: null,
  clicksLeft: 0,
  wordsFound: 0,
  score: initialScores.score,
  streak: initialScores.streak,
  maxStreak: initialScores.maxStreak,
  numbersPlayed: initialScores.numbersPlayed,
}));
const [oldScore, setOldScore] = useState(initialScores.score);
const [ guessedWords, setGuessedWords] = useState([]);
const [wrongGuessedWords, setWrongGuessedWords] = useState([]);
const [guessShake, setGuessShake] = useState(false);
const [guessFeedback, setGuessFeedback] = useState("");
const guessFeedbackTimerRef = useRef(null);
// Track all actions (clicks and guesses) for playSequences in chronological order
const [playSequenceActions, setPlaySequenceActions] = useState([]);
const [showWrongWordsModal, setShowWrongWordsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);
  const [updateRequired, setUpdateRequired] = useState(false);
  const [updateRequiredVersion, setUpdateRequiredVersion] = useState(null);
const [authModalState, setAuthModalState] = useState({
  visible: false,
  mode: AuthModes.SIGN_UP,
});
const [currentUser, setCurrentUser] = useState(() => getCurrentUser());
const [showLandscapeWarning, setShowLandscapeWarning] = useState(false);
const landscapeWarningShownRef = useRef(false);
function getWinTierLabel(lang, rawClicksLeft) {
  const c = Math.max(0, Math.min(10, Math.floor(Number(rawClicksLeft) || 0)));
  if (lang === "nl") {
    if (c === 10) return "Perfect";
    if (c >= 8) return "Meesterlijk";
    if (c >= 6) return "Knap gespeeld";
    if (c >= 4) return "Erg netjes";
    if (c >= 2) return "Goed gedaan";
    return "Net gered";
  }
  // en
  if (c === 10) return "Perfect";
  if (c >= 8) return "Masterful";
  if (c >= 6) return "Well played";
  if (c >= 4) return "Solid";
  if (c >= 2) return "Nice work";
  return "Just made it";
}

useEffect(() => {
  if (isTutorialGame(game?.idNumber)) return;
  if (!isDictionaryGuessEnabled(game?.idNumber, {
    custom: Boolean(game?.creator),
  })) return;
  ensureDictionaryLoaded(langString).catch((error) => {
    console.warn("Failed to load word dictionary", error);
  });
}, [langString, game?.idNumber, game?.creator]);

// Hide initial loader when isLoading becomes false (fallback if Loader component doesn't render)
// The Loader component will hide it when isLoading is true
useEffect(() => {
  if (!isLoading) {
    // Small delay to ensure React has rendered the main content
    const timer = setTimeout(() => {
      if (window.hideInitialLoader) {
        window.hideInitialLoader();
      }
    }, 100);
    return () => clearTimeout(timer);
  }
}, [isLoading]);

// Set Amplitude user ID on initial load if user is already logged in
// For anonymous users, Amplitude will automatically track via device ID
useEffect(() => {
  const initialUser = getCurrentUser();
  if (initialUser) {
    try {
      // Use identify() to merge anonymous user (Device ID) with logged-in user (User ID)
      // This ensures events tracked before login are associated with the user
      amplitude.identify({ user_id: initialUser.id });
    } catch (amplitudeError) {
      console.warn('Failed to set Amplitude user ID on initial load:', amplitudeError);
    }
  }
  // If no user, don't set userId - let Amplitude use device ID for anonymous tracking
}, []); // Only run once on mount

// FEATURE: BATTLE_MODE - Preload all BattleGames (always; no login or battle-mode check)
useEffect(() => {
  restoreFromStorage();

  // When prefill=qazx is present in the URL, do NOT eagerly load all BattleGames.
  // This mimics the Game class behaviour: load per idNumber instead of loading the full BattleGame set once.
  try {
    const urlParams = new URLSearchParams(getAppSearchString());
    const prefill = urlParams.get("prefill");
    if (prefill === "qazx") {
      console.log("[WordHit] Skipping BattleGames preload because prefill=qazx");
      return;
    }
  } catch (e) {
    // If anything goes wrong while reading the URL, fall back to normal preload.
  }

  loadAllBattleGames().catch((err) => {
    console.warn("[WordHit] BattleGames cache preload failed:", err);
  });
}, [currentUser]);

// Auto sign in with Apple on iOS if user was previously signed in
useEffect(() => {
  const attemptAppleAutoSignIn = async () => {
    // Only try if no current user
    const existingUser = getCurrentUser();
    if (!existingUser) {
      try {
        const user = await autoSignInWithApple();
        if (user) {
          setCurrentUser(user);
        }
      } catch (error) {
        console.warn("Auto sign in with Apple failed:", error);
      }
    }
  };

  // Small delay to ensure Capacitor is ready
  const timer = setTimeout(attemptAppleAutoSignIn, 500);
  return () => clearTimeout(timer);
}, []); // Only run once on mount

// Check for app update requirement (iOS only)
useEffect(() => {
  const checkUpdate = async () => {
    try {
      const result = await checkAppUpdateRequired();
      if (result.updateRequired) {
        setUpdateRequired(true);
        setUpdateRequiredVersion(result.requiredVersion);
      }
    } catch (error) {
      console.error("Error checking app update requirement:", error);
      // On error, don't block the app
    }
  };
  
  // Small delay to ensure Capacitor is ready
  const timer = setTimeout(checkUpdate, 500);
  return () => clearTimeout(timer);
}, []); // Only run once on mount

// Check for prefill=qazx in URL and mark tutorial as shown if present
useEffect(() => {
  const urlParams = new URLSearchParams(getAppSearchString());
  const prefill = urlParams.get("prefill");
  
  if (prefill === "qazx") {
    markTutorialAsShown();
  }
}, []); // Only run once on mount

const [showProfileModal, setShowProfileModal] = useState(false);
const [profileAvatarUrl, setProfileAvatarUrl] = useState(profileDefault);
const [showScoreModal, setShowScoreModal] = useState(false);
const [showRemindersModal, setShowRemindersModal] = useState(false);
const [finishedIdNumbers, setFinishedIdNumbers] = useState([]);

// Helper to check if error is authentication-related and logout if so
const handleAuthError = useCallback((error) => {
  if (!error) return false;
  
  const errorCode = error?.code;
  const errorMessage = String(error?.message || '').toLowerCase();
  const statusCode = error?.status;
  
  // Check for Parse authentication errors (401, 209, or session-related errors)
  const isAuthError = 
    statusCode === 401 ||
    errorCode === 209 || // Invalid session token
    errorCode === 101 || // Object not found (can happen with invalid session)
    errorMessage.includes('invalid session') ||
    errorMessage.includes('session token') ||
    errorMessage.includes('unauthorized');
  
  if (isAuthError) {
    console.warn("Invalid session detected, logging out:", error);
    Parse.User.logOut().catch(() => {});
    setCurrentUser(null);
    setProfileAvatarUrl(profileDefault);
    try {
      amplitude.setUserId(null);
    } catch (e) {}
    return true;
  }
  return false;
}, []);
const finishedOutcomeCacheRef = useRef({});
const finishedClicksLeftCacheRef = useRef({});
const finishedWordsFoundCacheRef = useRef({});
const autoRevealFinishedRef = useRef(false);
const isReloadingGameRef = useRef(false);
const gameRef = useRef(null);
const playSequenceActionsRef = useRef([]);

useEffect(() => {
  if (!currentUser) {
    setFinishedIdNumbers([]);
    setProfileAvatarUrl(profileDefault);
    // For anonymous users, don't set userId - Amplitude will track via device ID
    // Only reset userId if we're transitioning from logged-in to logged-out
    // (This is handled in handleProfileLoggedOut)
    return;
  }
  
  // Set Amplitude user ID when user is logged in
  // Use identify() to merge anonymous user (Device ID) with logged-in user (User ID)
  // This ensures events tracked before login are associated with the user
  try {
    amplitude.identify({ user_id: currentUser.id });
  } catch (amplitudeError) {
    console.warn('Failed to set Amplitude user ID:', amplitudeError);
  }
  
  // FEATURE: SMART_DATA_CACHING - DISABLED
  // const lastUserFetchTime = localStorage.getItem("lastUserFetchTime");
  // const now = Date.now();
  // const fiveMinutesAgo = now - (5 * 60 * 1000);
  // 
  // if (lastUserFetchTime && parseInt(lastUserFetchTime) > fiveMinutesAgo) {
  //   console.log("[User] User data was recently fetched, skipping fetch (SMART_DATA_CACHING)");
  //   // Still update from local storage
  //   const stored = getStoredScores();
  //   setScoreDictionary((prev) => ({
  //     ...prev,
  //     score: stored.score ?? prev.score ?? 0,
  //     streak: stored.streak ?? prev.streak ?? 0,
  //     maxStreak: stored.maxStreak ?? prev.maxStreak ?? 0,
  //     numbersPlayed: stored.numbersPlayed ?? prev.numbersPlayed ?? 0,
  //   }));
  //   return;
  // }
  
  // Fetch fresh user data from server first, then sync scores
  console.log("[User] Fetching fresh user data from server");
  currentUser
    .fetch()
    .then((refreshed) => {
      // FEATURE: SMART_DATA_CACHING - DISABLED
      // localStorage.setItem("lastUserFetchTime", String(now));
      if (refreshed) {
        setCurrentUser(refreshed);
        // Fetch posibleCheater field for current user
        const possibleCheater = refreshed.get("possibleCheater") ?? false;
        // Sync scores from server to local storage (like signInUser does)
        const stored = getStoredScores();
        const serverLastWonId = Number.isFinite(refreshed.get("lastWonId")) ? Number(refreshed.get("lastWonId")) : null;
        const serverScores = {
          score: refreshed.get("score") ?? 0,
          streak: refreshed.get("streak") ?? 0,
          maxStreak: refreshed.get("maxStreak") ?? 0,
          numbersPlayed: refreshed.get("numbersPlayed") ?? 0,
          lastPlayedId: stored.lastPlayedId ?? null,
          // Use server lastWonId if available, otherwise fall back to local (for backward compatibility)
          lastWonId: serverLastWonId !== null ? serverLastWonId : (stored.lastWonId ?? null),
          playedMonthOdd: currentUser.get("playedMonthOdd") ?? 0,
          playedMonthEven: currentUser.get("playedMonthEven") ?? 0,
        };
        overwriteStoredScores(serverScores);
        // Update score dictionary with fresh server scores
        setScoreDictionary((prev) => ({
          ...prev,
          score: serverScores.score ?? prev.score ?? 0,
          streak: serverScores.streak ?? prev.streak ?? 0,
          maxStreak: serverScores.maxStreak ?? prev.maxStreak ?? 0,
          numbersPlayed: serverScores.numbersPlayed ?? prev.numbersPlayed ?? 0,
        }));
        // Update finished IDs
        const remoteFinished = getUserFinishedIds();
        if (remoteFinished) {
          setFinishedIdNumbers(remoteFinished);
        }
        // Update avatar
        const avatarFile = refreshed.get("avatar");
        if (avatarFile && typeof avatarFile.url === "function") {
          const remoteUrl = avatarFile.url();
          setProfileAvatarUrl(remoteUrl || profileDefault);
        } else {
          setProfileAvatarUrl(profileDefault);
        }
        
        // NOTE: Installation linking is handled when push permission is granted
        // We do NOT link Installation on app restart - it should already be linked
      }
    })
    .catch((error) => {
      if (!handleAuthError(error)) {
        console.warn("Failed to refresh user on mount", error);
      }
    });
}, [currentUser]);

// Helper function to check if a game is already finished on the server
// This prevents race conditions when playing on multiple devices
// Returns true if the game is already finished on another device
async function checkIfGameAlreadyFinished(gameIdNumber) {
  if (!currentUser) {
    console.log("[Sync] No current user, skipping check");
    return false;
  }
  
  // Double-check: make sure we're checking the correct game ID
  if (typeof gameIdNumber !== "number" || !Number.isFinite(gameIdNumber)) {
    console.warn("[Sync] Invalid gameIdNumber for check:", gameIdNumber);
    return false;
  }
  
  try {
    // Fetch fresh user data to get the latest finished IDs
    const refreshed = await currentUser.fetch();
    if (refreshed) {
      // Read finished IDs directly from the refreshed user object
      const FINISHED_IDS_KEY = "finishedIdNumbers";
      const finished = refreshed.get(FINISHED_IDS_KEY);
      const remoteFinished = Array.isArray(finished) ? finished : [];
      
      // Update local state with latest finished IDs
      setFinishedIdNumbers(remoteFinished);
      
      // Check if this game is already in the finished list
      const isAlreadyFinished = remoteFinished.includes(gameIdNumber);
      
      console.log("[Sync] Check if game already finished:", {
        gameIdNumber,
        remoteFinished,
        isAlreadyFinished,
        currentGameId: game?.idNumber,
      });
      
      if (isAlreadyFinished) {
        console.log("[Sync] ⚠️ Game already finished on another device:", gameIdNumber);
      }
      
      return isAlreadyFinished;
    }
  } catch (error) {
    // Check if it's an auth error - if so, user will be logged out
    if (handleAuthError(error)) {
      return false; // Return false to allow game to continue, logout already handled
    }
    console.warn("[Sync] Failed to check if game is already finished:", error);
    // On error, assume not finished (fail open) to allow user to play
    // This prevents false positives when there's a network error
    return false;
  }
  
  return false;
}

// Session persistence check - validate and restore Parse session periodically
// This helps prevent users from being logged out unexpectedly across all browsers:
// - Safari: May clear localStorage after 7 days of inactivity or due to privacy settings
// - Chrome/Firefox: Users may clear browsing data or use privacy modes
// - Mobile browsers: May clear storage when low on space or due to OS settings
// - All browsers: Sessions may expire on the server side
useEffect(() => {
  if (!currentUser) {
    return;
  }

  // Check if Parse session is still valid by attempting to fetch user data
  const validateAndRestoreSession = async () => {
    try {
      const user = Parse.User.current();
      if (!user) {
        // Session lost - Parse should auto-restore from localStorage, but browser may have cleared it
        console.warn("Parse session lost - browser may have cleared localStorage");
        return;
      }

      // Validate session by attempting a lightweight fetch with timeout
      // This helps catch expired sessions early before user actions fail
      try {
        const refreshed = await Promise.race([
          user.fetch(),
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error("Session validation timeout")), 5000)
          ),
        ]);
        
        if (refreshed) {
          setCurrentUser(refreshed);
          // Fetch posibleCheater field for current user
          const possibleCheater = refreshed.get("possibleCheater") ?? false;
        }
      } catch (fetchError) {
        // Check if it's an auth error first
        if (handleAuthError(fetchError)) {
          return; // Already logged out
        }
        
        // Fetch failed - session might be expired or network issue
        // Try to restore by getting current user again (Parse might have auto-restored)
        const restored = Parse.User.current();
        if (restored && restored.id === user.id) {
          // Same user still in Parse's cache, try updating state
          setCurrentUser(restored);
          // Fetch posibleCheater field for current user
          const possibleCheater = restored.get("possibleCheater") ?? false;
        } else {
          console.warn("Parse session expired or invalid:", fetchError);
        }
      }
    } catch (error) {
      // Unexpected error during validation
      console.warn("Parse session validation error:", error);
      // Try to get current user from Parse's cache
      const cachedUser = Parse.User.current();
      if (cachedUser) {
        setCurrentUser(cachedUser);
      }
    }
  };

  // Validate session immediately on mount
  validateAndRestoreSession();

  // Check session every 5 minutes to catch localStorage clearing or expired sessions
  const intervalId = setInterval(validateAndRestoreSession, 5 * 60 * 1000);

  // Also check when window regains focus (user returns to tab/app)
  // Browser may have cleared storage while tab was inactive or app was in background
  const handleFocus = () => {
    validateAndRestoreSession();
  };
  window.addEventListener("focus", handleFocus);

  // Check on visibility change (tab becomes visible)
  // Helps catch session loss when user switches back to the tab
  // Also check for new day when tab becomes visible (web)
  const handleVisibilityChange = () => {
    if (!document.hidden) {
      validateAndRestoreSession();
      // Check if new day when tab becomes visible (web)
      if (game && !isLoading) {
        checkAndReloadGameIfNewDay();
      }
    }
  };
  document.addEventListener("visibilitychange", handleVisibilityChange);

  return () => {
    clearInterval(intervalId);
    window.removeEventListener("focus", handleFocus);
    document.removeEventListener("visibilitychange", handleVisibilityChange);
  };
}, [currentUser]);

// Retry pending saves function - defined here so it can be used in useEffect below
const retryPendingScoreSaves = useCallback(async () => {
  if (!currentUser) return;
  
  try {
    const successCount = await retryPendingSaves(saveUserScores);
    if (successCount > 0) {
      console.log(`Successfully retried ${successCount} pending save(s)`);
      // Refresh user data to get latest scores
      try {
        const refreshed = await currentUser.fetch();
        if (refreshed) {
          setCurrentUser(refreshed);
          // Fetch posibleCheater field for current user
          const possibleCheater = refreshed.get("possibleCheater") ?? false;
        }
      } catch (fetchError) {
        if (!handleAuthError(fetchError)) {
          console.warn("Failed to refresh user after retry:", fetchError);
        }
      }
    }
  } catch (error) {
    console.error("Error retrying pending saves:", error);
  }
}, [currentUser]);

// Retry pending saves when connection is restored and on mount
useEffect(() => {
  if (!currentUser) return;

  // Retry pending saves on mount if online
  retryPendingScoreSaves();

  // Set up network listener to retry when connection is restored
  const cleanup = setupNetworkListener(() => {
    // Wait a bit for connection to stabilize
    setTimeout(() => {
      retryPendingScoreSaves();
    }, 1000);
  });

  // Also retry periodically (every 5 minutes) if there are pending saves
  const retryInterval = setInterval(() => {
    const pending = getPendingSaves();
    if (pending.length > 0) {
      retryPendingScoreSaves();
    }
  }, 5 * 60 * 1000); // Every 5 minutes

  return () => {
    cleanup();
    clearInterval(retryInterval);
  };
}, [currentUser, retryPendingScoreSaves]);

useEffect(() => {
  autoRevealFinishedRef.current = false;
}, [idNumber]);

// Keep gameRef in sync with game state
useEffect(() => {
  gameRef.current = game;
}, [game]);

// Check for red dots when game is loaded (separate effect to ensure game state is ready)
useEffect(() => {
  if (!game || isLoading) {
    console.log("[RedDot] Skipping check - game:", !!game, "isLoading:", isLoading);
    return;
  }
  
  const gameIdNumber = game?.idNumber;
  console.log("[RedDot] Checking game:", gameIdNumber, "isTutorial:", isTutorialGame(gameIdNumber), "hasCreator:", !!game?.creator);
  
  // Only for non-tutorial, non-custom games
  if (gameIdNumber !== undefined && gameIdNumber !== null && 
      !isTutorialGame(gameIdNumber) && !game?.creator) {
    try {
      const key = `wordhitSeen_${gameIdNumber}`;
      const hasBeenSeen = localStorage.getItem(key) === "true";
      console.log("[RedDot] Key:", key, "hasBeenSeen:", hasBeenSeen);
      if (!hasBeenSeen) {
        // First time seeing this WordHit - show red dots
        console.log("[RedDot] First time! Showing red dots");
        setShowMenuRedDot(true);
        setShowRemindersRedDot(true);
        // Mark as seen
        localStorage.setItem(key, "true");
      } else {
        // Already seen, hide red dots
        console.log("[RedDot] Already seen, hiding red dots");
        setShowMenuRedDot(false);
        setShowRemindersRedDot(false);
      }
    } catch (error) {
      console.warn("[RedDot] Failed to check if WordHit was seen before:", error);
    }
  } else {
    // Tutorial or custom game - hide red dots
    console.log("[RedDot] Tutorial or custom game, hiding red dots");
    setShowMenuRedDot(false);
    setShowRemindersRedDot(false);
  }
}, [game, isLoading]);

// Simple function to check and reload game if idNumber has changed
async function checkAndReloadGameIfNewDay() {
  // Use ref to get current game state (avoids stale closure issues)
  const currentGame = gameRef.current;
  
  // Only check if game is already loaded (not during initial load)
  if (!currentGame || isLoading) {
    return;
  }
  
  // Prevent multiple simultaneous reloads
  if (isReloadingGameRef.current) {
    console.log("Reload already in progress, skipping...");
    return;
  }
  
  // Calculate current idNumber based on today's date
  const fromDate = new Date(2022, 0, 1);
  const currentDate = new Date();
  const utcCurrent = Date.UTC(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );
  const utcFrom = Date.UTC(
    fromDate.getFullYear(),
    fromDate.getMonth(),
    fromDate.getDate()
  );
  const diffInDays = Math.floor((utcCurrent - utcFrom) / (1000 * 60 * 60 * 24));
  let currentIdNumber = diffInDays;
  
  // Check for URL override (id parameter) - if present, don't auto-reload
  const urlParams = new URLSearchParams(getAppSearchString());
  const overruledId = urlParams.get("id");
  if (overruledId) {
    currentIdNumber = parseInt(overruledId);
    console.log(`[CheckNewDay] URL override detected (id=${overruledId}), skipping auto-reload`);
    return; // Don't auto-reload when URL has specific id parameter
  }
  
  // Check if idNumber has changed from the loaded game
  const loadedIdNumber = currentGame?.idNumber;
  
  // Skip reload if currently in tutorial mode
  if (isTutorialGame(loadedIdNumber)) {
    console.log("Currently in tutorial (9999), skipping daily game reload.");
    return;
  }
  
  // Skip reload for custom games (games with a creator)
  if (currentGame?.creator) {
    console.log("Custom game detected, skipping daily game reload.");
    return;
  }
  
  console.log(`Checking new day: loaded=${loadedIdNumber}, current=${currentIdNumber}`);
  
    // If idNumber has increased (new day), reload the game
    if (loadedIdNumber !== undefined && currentIdNumber > loadedIdNumber) {
      console.log(`New day detected: idNumber changed from ${loadedIdNumber} to ${currentIdNumber}, reloading game...`);
      
      // Set flag to prevent multiple simultaneous reloads
      isReloadingGameRef.current = true;
      
      // CRITICAL: Fetch latest finished IDs from server before reloading game
      // This prevents race conditions when playing on multiple devices
      const currentUser = Parse.User.current();
      if (currentUser) {
        try {
          const refreshed = await currentUser.fetch();
          if (refreshed) {
            const remoteFinished = getUserFinishedIds();
            if (remoteFinished && Array.isArray(remoteFinished)) {
              setFinishedIdNumbers(remoteFinished);
              console.log("[Sync] Updated finished IDs before reload:", remoteFinished);
            }
          }
        } catch (error) {
          if (!handleAuthError(error)) {
            console.warn("[Sync] Failed to fetch finished IDs before reload:", error);
          }
        }
      }
      
      // Reload the game with the new idNumber
      const loadStart = Date.now();
      try {
        setIsLoading(true);
        const built = await buildGameForToday(langString, currentIdNumber);
      setGame(built); // idNumber is now included in built object
      gameRef.current = built; // Update ref immediately
      
      // Clear old game state from localStorage
      if (loadedIdNumber !== undefined) {
        clearGameState(loadedIdNumber);
      }
      
      // Reset game state for new game
      setRevealed(Array.from({ length: GRID_SIZE }, () =>
        Array.from({ length: GRID_SIZE }, () => false)
      ));
      setClicksLeft(MAX_CLICKS);
      setGuessedWords([]);
      setWrongGuessedWords([]);
      setPlaySequenceActions([]);
      playSequenceActionsRef.current = [];
      setHasWon(false);
      setHasLost(false);
      setShowWinPopup(false);
      setShowLosePopup(false);
      // Reset autoRevealFinishedRef for new game
      autoRevealFinishedRef.current = false;
      // Reset guess input field
      setGuess("");
      
      // Initialize share result tracking for new game
      if (built?.idNumber !== undefined && built?.idNumber !== null) {
        initShareResultTracking(built.idNumber);
      }
      
      const elapsed = Date.now() - loadStart;
      const remaining = Math.max(LOADER_MIN_DISPLAY_MS - elapsed, 0);
      await new Promise((r) => setTimeout(r, remaining));
      if (!DEBUG_KEEP_LOADER_VISIBLE) {
        setIsLoading(false);
      }
    } catch (err) {
      console.error("Error reloading game for new day:", err);
      // Parse errors have a code property (100 = network error, etc.)
      const isNetworkError = err?.code === 100 || 
        (err?.message && (
          err.message.toLowerCase().includes("load failed") ||
          err.message.toLowerCase().includes("network") ||
          err.message.toLowerCase().includes("fetch") ||
          err.message.toLowerCase().includes("connection")
        ));
      
      const errorMessage = isNetworkError
        ? (langString === "nl" 
            ? "Geen internetverbinding. Controleer je internet en probeer het opnieuw." 
            : "No internet connection. Check your connection and try again.")
        : (err?.message && !err.message.toLowerCase().includes("load failed"))
          ? err.message
          : (langString === "nl" 
              ? "WordHit kon niet geladen worden." 
              : "Unable to load the WordHit.");
      setLoadError(errorMessage);
      if (!DEBUG_KEEP_LOADER_VISIBLE) {
        setIsLoading(false);
      }
    } finally {
      // Reset flag after reload is complete
      isReloadingGameRef.current = false;
    }
  }
}

// Check periodically (every minute) to catch date changes
useEffect(() => {
  const interval = setInterval(() => {
    checkAndReloadGameIfNewDay();
  }, 60000); // Check every minute
  
  return () => clearInterval(interval);
}, [game, isLoading, langString]);

// iOS: Listen for app entering foreground (via AppDelegate)
useEffect(() => {
  if (typeof window === "undefined" || !window.Capacitor) {
    return;
  }
  
  const platform = window.Capacitor.getPlatform();
  if (platform !== "ios") {
    return;
  }
  
  // Listen for custom event from AppDelegate (triggered via Capacitor bridge)
  const handleForeground = async () => {
    console.log("iOS: App entered foreground (from AppDelegate), checking for new day...");
    
    // Check if there are delivered notifications (notifications that were shown)
    // If there are, set badge to 1 before resetting (in case notification was missed)
    if (isIOS()) {
      try {
        const { LocalNotifications } = await import('@capacitor/local-notifications');
        const delivered = await LocalNotifications.getDeliveredNotifications();
        const wordHitNotification = delivered.notifications.find(n => n.id === 999);
        
        if (wordHitNotification) {
          console.log('[Notification] 📬 Found delivered WordHit notification, badge was already set by iOS');
        }
      } catch (error) {
        console.warn('[Notification] Failed to check delivered notifications:', error);
      }
    }
    
    // Reset app badge to 0 when app enters foreground
    if (isIOS()) {
      import("@capacitor/app").then(({ App }) => {
        App.setBadgeCount({ count: 0 }).catch((error) => {
          console.warn("Failed to reset badge:", error);
        });
      }).catch(() => {});
    }
    
    // Reconcile daily reminder (language/time) when app returns to foreground
    ensureDailyNotificationScheduled('foreground').catch((error) => {
      console.warn("Failed to reconcile notification on foreground:", error);
    });

    // Log scheduled notifications when app comes to foreground
    logScheduledNotifications().catch((error) => {
      console.warn("Failed to log scheduled notifications:", error);
    });
    
    setTimeout(() => {
      checkAndReloadGameIfNewDay();
    }, 300);
  };
  
  // Listen to Capacitor's custom event from AppDelegate
  window.addEventListener("appWillEnterForeground", handleForeground);
  
  // Also use Capacitor App plugin as fallback
  let listenerRef = null;
  import("@capacitor/app").then(({ App }) => {
    App.addListener("appStateChange", ({ isActive }) => {
      if (isActive) {
        console.log("iOS: App state changed to active, checking for new day...");
        
        // Reset app badge to 0 when app becomes active
        if (isIOS()) {
          App.setBadgeCount({ count: 0 }).catch((error) => {
            console.warn("Failed to reset badge:", error);
          });
        }
        
        // Reconcile daily reminder (language/time) when app returns to foreground
        ensureDailyNotificationScheduled('foreground').catch((error) => {
          console.warn("Failed to reconcile notification on foreground:", error);
        });

        // Log scheduled notifications when app comes to foreground
        logScheduledNotifications().catch((error) => {
          console.warn("Failed to log scheduled notifications:", error);
        });
        
        setTimeout(() => {
          checkAndReloadGameIfNewDay();
        }, 300);
      }
    }).then((listener) => {
      listenerRef = listener;
    }).catch(() => {});
  }).catch(() => {});
  
  return () => {
    window.removeEventListener("appWillEnterForeground", handleForeground);
    if (listenerRef) {
      listenerRef.remove().catch(() => {});
    }
  };
}, [game, isLoading, langString]);

// iOS: Listen for notification triggers and set badge
useEffect(() => {
  if (!isIOS()) {
    return;
  }

  // Listen for when notifications are received/triggered (when app is in foreground)
  // Note: This only fires when app is in foreground. For background notifications,
  // the badge should be set by the notification itself, but we'll also set it here as backup.
  const notificationListener = LocalNotifications.addListener('localNotificationReceived', async (notification) => {
    console.log('[Notification] 📬 Notification received (app in foreground):', notification);
    
    // Check if this is our WordHit notification (ID 999)
    if (notification.notification?.id === 999) {
      console.log('[Notification] 🎯 WordHit notification received, setting badge to 1');
      
      // Set badge to 1 when notification is triggered
      try {
        const { App } = await import('@capacitor/app');
        await App.setBadgeCount({ count: 1 });
        console.log('[Notification] ✅ Badge set to 1');
      } catch (error) {
        console.warn('[Notification] ❌ Failed to set badge:', error);
      }
    }
  });

  // Listen for when notifications are actioned (user taps on notification)
  const actionListener = LocalNotifications.addListener('localNotificationActionPerformed', async (action) => {
    console.log('[Notification] 👆 Notification action performed:', action);
    
    // Check if this is our WordHit notification (ID 999)
    if (action.notification?.id === 999) {
      console.log('[Notification] 🎯 WordHit notification action performed, badge will be reset when app opens');
      // Badge will be reset when app comes to foreground (already handled above)
    }
  });

  return () => {
    notificationListener.remove();
    actionListener.remove();
  };
}, []); // Only run once on mount

// iOS: Schedule daily notification on app load (if not played yet and permission granted)
// Also ask for permission if user has played before but permission was never asked
useEffect(() => {
  if (!isNative() || !game || isLoading) return;

  const scheduleNotification = async () => {
    try {
      await ensureDailyNotificationScheduled('automatic');
    } catch (error) {
      console.warn("Failed to schedule notification on load:", error);
    }
  };

  // Check if user has played before but permission was never asked
  const finishedId = localStorage.getItem("finishedGameidNummer");
  const hasPlayedBefore = !!finishedId;
  const permissionAsked = hasAskedForPermission();

  // Only ask for permission if it's a regular daily game (not tutorial games 9999, 9998, 9997)
  const isRegularGame = game && !isTutorialGame(game.idNumber) && !game.creator;

  if (hasPlayedBefore && !permissionAsked && isRegularGame) {
    // User has played before but permission was never asked - ask now
    setTimeout(() => {
      requestNotificationPermission().then((result) => {
        if (result.granted) {
          // Schedule for tomorrow at current time + 1 hour when permission is first granted
          scheduleNotificationForTomorrow(undefined, true).catch((error) => {
            console.warn("Failed to schedule notification for tomorrow:", error);
          });
        }
      });
    }, 1000);
  } else if (permissionAsked) {
    // Permission was already asked - just schedule if granted
    scheduleNotification();
  }
}, [game, isLoading]);

useEffect(() => {
  if (!game) return;
  if (game.creator) return;

  // Use game.idNumber instead of local idNumber variable to ensure we check the correct game
  const gameIdNumber = game.idNumber;
  if (gameIdNumber === undefined || gameIdNumber === null) {
    return;
  }

  const finishedLocal =
    typeof window !== "undefined" &&
    String(localStorage.getItem("finishedGameidNummer")) === String(gameIdNumber);
  const finishedRemote = finishedIdNumbers.includes(gameIdNumber);

  if (!finishedLocal && !finishedRemote) {
    // Game is not finished, try to restore in-progress state
    const storedState = getStoredGameState(gameIdNumber);
    if (storedState && storedState.revealed && storedState.clicksLeft !== undefined && storedState.guessedWords) {
      // Restore game state
      setRevealed(storedState.revealed);
      setClicksLeft(storedState.clicksLeft);
      setGuessedWords(storedState.guessedWords);
      // Restore wrong guessed words if available
      if (storedState.wrongGuessedWords && Array.isArray(storedState.wrongGuessedWords)) {
        setWrongGuessedWords(storedState.wrongGuessedWords);
      }
      if (storedState.letterRevealGuesses && Array.isArray(storedState.letterRevealGuesses)) {
        setWrongGuessedWords((prev) => {
          const merged = [...prev];
          for (const word of storedState.letterRevealGuesses) {
            if (!merged.includes(word)) merged.push(word);
          }
          return merged;
        });
      }
      // Sync visibleWords with restored revealed state
      syncGuessedWithVisibility(storedState.revealed);
      console.log("Restored in-progress game state for idNumber:", gameIdNumber);
    }
    
    // Restore playSequence from local storage if available
    const storedPlaySequence = getStoredPlaySequence(gameIdNumber);
    if (storedPlaySequence && Array.isArray(storedPlaySequence) && storedPlaySequence.length > 0) {
      // Restore playSequence to both state and ref
      setPlaySequenceActions(storedPlaySequence);
      playSequenceActionsRef.current = storedPlaySequence;
      console.log("Restored local play sequence for idNumber:", gameIdNumber, "actions:", storedPlaySequence.length);
    }
    
    // Restore share result actions from local storage if available
    const restoredShareActions = loadShareResultActions(gameIdNumber);
    if (restoredShareActions && restoredShareActions.length > 0) {
      console.log("Restored share result actions for idNumber:", gameIdNumber, "actions:", restoredShareActions.length);
    } else {
      // Initialize share result tracking if no existing actions found
      initShareResultTracking(gameIdNumber);
    }
    return;
  }

  if (!autoRevealFinishedRef.current) {
    setRevealed(revealEntireBoard(game.board));
    autoRevealFinishedRef.current = true;
  }

  const outcome = getStoredFinishedOutcomeValue(gameIdNumber);
  if (outcome === "lose") {
    setHasLost(true);
    setHasWon(false);
  } else if (outcome === "win") {
    setHasWon(true);
    setHasLost(false);
  }

  // Restore clicksLeft from storage if available
  const storedClicksLeft = getStoredFinishedClicksLeft(gameIdNumber);
  if (storedClicksLeft !== null && typeof storedClicksLeft === "number") {
    setClicksLeft(storedClicksLeft);
  }

  // Restore wordsFound from storage if available
  const storedWordsFound = getStoredFinishedWordsFound(gameIdNumber);
  if (storedWordsFound !== null && typeof storedWordsFound === "number") {
      setScoreDictionary((prev) => ({
        ...prev,
        wordsFound: storedWordsFound,
      }));
  }
}, [game, finishedIdNumbers]);


  const FAQ_URL =
    langString === "nl"
      ? "https://smartfriendsapp.com/wordhit/faq-nl"
      : "https://smartfriendsapp.com/wordhit/faq";
  const menuTexts = {
    primaryCreate:
      langString === "nl" ? "MAAK JE EIGEN WORDHIT!" : "CREATE YOUR OWN WORDHIT!",
    introduction: langString === "nl" ? "UITLEG" : "HOW TO PLAY",
    faq:
      langString === "nl"
        ? "VEELGESTELDE VRAGEN"
        : "FREQUENTLY ASKED QUESTIONS",
    contact:
      langString === "nl"
        ? "CONTACT"
        : "CONTACT",
    signIn: langString === "nl" ? "INLOGGEN" : "SIGN IN",
  };
  const profileTexts =
    langString === "nl"
      ? {
          title: "Profiel",
          nameLabel: "Naam",
          emailLabel: "E-mailadres",
          save: "Opslaan",
          saving: "Opslaan...",
          logout: "Uitloggen",
          close: "Sluiten",
          emptyNameError: "Vul je naam in.",
          saveSuccess: "Profiel opgeslagen.",
          genericError: "Opslaan mislukt. Probeer het later opnieuw.",
          logoutError: "Uitloggen mislukt. Probeer opnieuw.",
          changeAvatarLabel: "Wijzig",
          deleteAccount: "Account verwijderen",
          deleteAccountConfirm: "Weet je het zeker?",
          deleteAccountError: "Account verwijderen mislukt. Probeer opnieuw.",
          avatarUploadSuccess: "Foto geüpload.",
          avatarUploadError: "Foto uploaden mislukt. Probeer opnieuw.",
        }
      : {
          title: "Profile",
          nameLabel: "Name",
          emailLabel: "Email",
          save: "Save",
          saving: "Saving...",
          logout: "Log out",
          close: "Close",
          emptyNameError: "Please enter your name.",
          saveSuccess: "Profile saved.",
          genericError: "Could not save profile. Please try again.",
          logoutError: "Log out failed. Please try again.",
          changeAvatarLabel: "Change",
          deleteAccount: "Delete account",
          deleteAccountConfirm: "Are you sure?",
          deleteAccountError: "Failed to delete account. Please try again.",
          avatarUploadSuccess: "Photo uploaded.",
          avatarUploadError: "Failed to upload photo. Please try again.",
        };

  const avatarCropLabels =
    langString === "nl"
      ? {
          zoomLabel: "Zoom",
          cancelLabel: "Annuleren",
          confirmLabel: "Opslaan",
          processingLabel: "Opslaan...",
          selectAreaMessage: "Selecteer eerst een gebied.",
          errorMessageText: "Kon de afbeelding niet verwerken. Probeer een andere foto.",
        }
      : {
          zoomLabel: "Zoom",
          cancelLabel: "Cancel",
          confirmLabel: "Save",
          processingLabel: "Saving...",
          selectAreaMessage: "Please select an area first.",
          errorMessageText: "Could not process the image. Please try another photo.",
        };

  const closeMenuModal = () => {
    setShowMenuModal(false);
  };

  const handleDebugPushClick = async () => {
    try {
      const [data, currentToken] = await Promise.all([
        Parse.Cloud.run("getMyInstallations"),
        Promise.resolve(getLastKnownPushToken()),
      ]);
      const prefixLen = 30;
      const currentPrefix = currentToken ? currentToken.substring(0, prefixLen) : null;
      let matchesThisDevice = null;
      if (currentPrefix && Array.isArray(data)) {
        for (const inst of data) {
          const storedPrefix = (inst.deviceTokenPrefix || "").replace(/\.\.\.$/, "").substring(0, prefixLen);
          if (storedPrefix && currentPrefix === storedPrefix) {
            matchesThisDevice = inst.objectId;
            break;
          }
        }
      }
      const summary = {
        tokenVanDitDevice: currentToken
          ? `${currentToken.substring(0, 40)}... (${currentToken.length} tekens)`
          : null,
        komtOvereenMetInstallatie: matchesThisDevice !== null,
        matchingInstallationId: matchesThisDevice,
        hint: !currentToken
          ? (langString === "nl"
            ? "Token nog niet ontvangen deze sessie. Open push-permissies of herstart de app."
            : "Token not received this session. Open push permissions or restart the app.")
          : null,
      };
      setDebugPushResult(JSON.stringify({ summary, installations: data }, null, 2));
    } catch (err) {
      setDebugPushResult("Error: " + (err?.message || String(err)));
    }
  };

  const openScoreModal = () => {
    setShowMenuModal(false);
    setShowScoreModal(true);
  };

  const openResultModal = () => {
    // If state is already set, use it
    if (hasWon) {
      setResultModalOpenedByScoreButton(true);
      setShowWinPopup(true);
      return;
    }
    
    if (hasLost) {
      setResultModalOpenedByScoreButton(true);
      setShowLosePopup(true);
      return;
    }
    
    // Fallback: check if game is finished and get outcome from storage
    // This handles the case when app restarts and hasWon/hasLost haven't been set yet
    // Use the same logic as the button visibility check
    const gameIdNumber = game?.idNumber ?? idNumber;
    
    if (gameIdNumber === undefined || gameIdNumber === null) {
      // No game ID available, default to win popup
      setResultModalOpenedByScoreButton(true);
      setShowWinPopup(true);
      return;
    }
    
    const finishedLocal =
      typeof window !== "undefined" &&
      String(localStorage.getItem("finishedGameidNummer")) === String(gameIdNumber);
    const finishedRemote = finishedIdNumbers.includes(gameIdNumber);
    const isAlreadyFinishedToday =
      !game?.creator && (finishedLocal || finishedRemote);
    
    // If button is visible, game must be finished, so always show modal
    // Get outcome from storage to determine which modal to show
    if (isAlreadyFinishedToday || finishedLocal || finishedRemote) {
      const outcome = getStoredFinishedOutcomeValue(gameIdNumber);
      const wordsFound = getStoredFinishedWordsFound(gameIdNumber) ?? scoreDictionary.wordsFound ?? 0;
      setResultWordsFound(wordsFound);
      if (outcome === "lose") {
        setResultModalOpenedByScoreButton(true);
        setShowLosePopup(true);
        // Also set state for consistency
        setHasLost(true);
        setHasWon(false);
    } else {
        // Default to win popup (either outcome === "win" or outcome is null/undefined)
        setResultModalOpenedByScoreButton(true);
        setShowWinPopup(true);
        // Also set state for consistency
        setHasWon(true);
        setHasLost(false);
      }
    } else {
      // Fallback: if somehow button is visible but game not marked as finished
      // Still show modal (shouldn't happen, but be safe)
      setResultModalOpenedByScoreButton(true);
      setShowWinPopup(true);
    }
  };

  const closeScoreModal = () => {
    setShowScoreModal(false);
    // Don't reopen menu modal - close everything when subpage closes
    setShowMenuModal(false);
  };

  const closeAuthModal = () => {
    setAuthModalState((prev) => ({ ...prev, visible: false }));
    // Show pending balloon if there is one
    if (pendingBalloonRef.current) {
      const { type, text } = pendingBalloonRef.current;
      setTimeout(() => {
        showBalloon(type, text);
        pendingBalloonRef.current = null;
      }, 250);
    }
  };

  const openAuthModal = (mode = AuthModes.SIGN_UP) => {
    // ===== CHANGE: iOS users now use standard account creation/login (like web) =====
    // Removed iOS-specific logic that forced SIGN_IN mode
    // iOS users now see the same modal as web users with standard form + Apple Sign-In option
    // ===== END CHANGE =====
    setAuthModalState({ visible: true, mode: mode });
  };


  const handleIntroductionClick = () => {
    setShowRules(true);
    closeMenuModal();
  };

  const handleRemindersClick = () => {
    closeMenuModal();
    setShowRemindersModal(true);
    // Remove red dot when reminders is clicked
    if (showRemindersRedDot) {
      setShowRemindersRedDot(false);
    }
  };

  const handleAboutClick = () => {
    closeMenuModal();
    setShowAboutModal(true);
    
    // Track Amplitude event for opening about/contact page
    try {
      const platform = isIOS() ? "ios" : isAndroid() ? "android" : "web";
      amplitude.track("about_page_opened", {
        platform: platform,
        lang: langString,
      });
    } catch (amplitudeError) {
      console.warn('Failed to track about page opened event:', amplitudeError);
    }
  };

  const handleFaqClick = async () => {
    closeMenuModal();
    setFaqError("");
    setShowFaqModal(true);
    if (faqItems.length > 0 || isFaqLoading) {
      return;
    }
    setIsFaqLoading(true);
    try {
      const FAQ = Parse.Object.extend("FAQ");
      const query = new Parse.Query(FAQ);
      query.ascending("orderNumber");
      const results = await query.find();
      const mapped = results.map((item) => ({
        question: item.get("question") || "",
        answer: item.get("answer") || "",
        questionNL: item.get("questionNL") || "",
        answerNL: item.get("answerNL") || "",
        orderNumber: item.get("orderNumber") || 0,
        ignoreForPublishers: item.get("ignoreForPublishers") || [],
      }));
      setFaqItems(mapped);
    } catch (error) {
      console.error("FAQ fetch error", error);
      setFaqError(
        langString === "nl"
          ? "FAQ kon niet geladen worden. Probeer het later opnieuw."
          : "Unable to load FAQs right now. Please try again later."
      );
    } finally {
      setIsFaqLoading(false);
    }
  };

  const handleShareClick = async () => {
    closeMenuModal();
    
    // Track Amplitude event for general share button click
    try {
      const platform = isIOS() ? "ios" : isAndroid() ? "android" : "web";
      amplitude.track("general_share_clicked", {
        platform: platform,
        lang: langString,
      });
    } catch (amplitudeError) {
      console.warn('Failed to track general share clicked event:', amplitudeError);
    }
    
    // Share website link for all platforms (we don't know if receiver has iOS or Android)
    const shareUrl = langString === "nl" 
      ? "https://wordhit.app/nederlands" 
      : "https://wordhit.app";
    const shareText = langString === "nl" 
      ? "Speel WordHit! - het nieuwste dagelijkse woordspel." 
      : "Play WordHit! - the newest daily word game.";
    
    try {
      // Use platform-specific share implementation
      // Set event name globally so TO JS listener knows which event to track
      if (typeof window !== 'undefined') {
        window.__currentShareEventName = "general_share_clicked";
        window.__shareAmplitudeLogged = false;
      }
      
      const shareOptions = {
        title: "WordHit",
        text: shareText,
        url: shareUrl,
        dialogTitle: langString === "nl" ? "Deel WordHit" : "Share WordHit",
        amplitudeEventName: "general_share_clicked", // Tell native code which event to track
      };
      
      // Add iOS-specific excludedActivityTypes
      if (isIOS()) {
        shareOptions.excludedActivityTypes = [
          ActivityTypes.PRINT,
          ActivityTypes.ASSIGN_TO_CONTACT,
          ActivityTypes.ADD_TO_READING_LIST,
          ActivityTypes.OPEN_IN_IBOOKS,
          ActivityTypes.MARKUP_AS_PDF,
        ];
      }
      
      console.log("[Share] Attempting to share with options:", shareOptions);
      
      // Debug platform detection
      const detectedIOS = isIOS();
      const detectedAndroid = isAndroid();
      const detectedNative = isNative();
      const capacitorPlatform = typeof window !== "undefined" && window.Capacitor 
        ? window.Capacitor.getPlatform() 
        : "unknown";
      
      console.log("[Share] Platform detection:");
      console.log("  - isIOS():", detectedIOS);
      console.log("  - isAndroid():", detectedAndroid);
      console.log("  - isNative():", detectedNative);
      console.log("  - Capacitor.getPlatform():", capacitorPlatform);
      console.log("  - window.Capacitor exists:", typeof window !== "undefined" && !!window.Capacitor);
      
      const shareResult = await platformShare(shareOptions);
      console.log("[Share] Share completed successfully, result:", shareResult);
      console.log("[Share] activityType:", shareResult?.activityType);
      
      // Check if user cancelled
      if (shareResult && shareResult.cancelled) {
        console.log("[Share] User cancelled share dialog");
        // Track cancellation
        try {
          const platform = detectedIOS ? "ios" : detectedAndroid ? "android" : "web";
          console.log("[Share] Tracking cancelled event with platform:", platform);
          amplitude.track("general_share_clicked", {
            platform: platform,
            lang: langString,
            status: "cancelled",
          });
        } catch (amplitudeError) {
          console.warn('Failed to track general share cancelled event:', amplitudeError);
        }
        return; // User cancelled, exit silently
      }
      
      // Track successful share
      try {
        // Check if Amplitude was already logged by native code or share.js
        // This prevents double logging
        const alreadyLogged = shareResult?.__amplitudeLogged || 
                             (typeof window !== 'undefined' && window.__shareAmplitudeLogged);
        
        if (alreadyLogged) {
          console.log("[Share] ⏭️ Skipping Amplitude log (already logged by native/share.js)");
        } else {
          // If activityType exists, we're definitely on iOS (only iOS CustomShare plugin returns it)
          // Use activityType as the primary indicator, then fall back to platform detection
          let sharePlatform;
          if (shareResult && shareResult.activityType && shareResult.activityType.trim() !== "") {
            // We're on iOS and have activityType - use iOS as platform
            sharePlatform = "ios";
            console.log("[Share] Detected iOS via activityType:", shareResult.activityType);
          } else {
            // Fall back to platform detection
            sharePlatform = detectedIOS ? "ios" : detectedAndroid ? "android" : "web";
          }
          
          console.log("[Share] Tracking success event with platform:", sharePlatform);
          const eventData = {
            platform: sharePlatform,
            lang: langString,
            status: "success",
          };
          // Only include activityType if it exists and is not empty (iOS with CustomShare plugin only)
          if (shareResult?.activityType && shareResult.activityType.trim() !== "") {
            eventData.activityType = shareResult.activityType;
            console.log("[Share] Tracking with activityType:", shareResult.activityType);
          } else {
            console.log("[Share] No activityType available (platform:", sharePlatform + ")");
          }
          amplitude.track("general_share_clicked", eventData);
        }
      } catch (amplitudeError) {
        console.warn('Failed to track general share success event:', amplitudeError);
      }
      
      return; // Success, exit early
    } catch (error) {
      console.error("[Share] Share error:", error);
      console.error("[Share] Error name:", error.name);
      console.error("[Share] Error message:", error.message);
      console.error("[Share] Error stack:", error.stack);
      
      // User cancelled or error occurred
      if (error.name === 'AbortError' || error.message?.includes('cancel') || error.message?.includes('cancelled')) {
        // User cancelled, don't show error
        console.log("[Share] User cancelled share");
        // Track cancellation
        try {
          amplitude.track("general_share_clicked", {
            platform: isIOS() ? "ios" : isAndroid() ? "android" : "web",
            lang: langString,
            status: "cancelled",
          });
        } catch (amplitudeError) {
          console.warn('Failed to track general share cancelled event:', amplitudeError);
        }
        return;
      }
      
      // Fallback: Copy to clipboard
      console.log("[Share] Falling back to clipboard");
      try {
        await navigator.clipboard.writeText(shareUrl);
        // Don't show alert on Android - clipboard copy is silent
        if (!isAndroid()) {
          alert(langString === "nl" 
            ? "Link gekopieerd naar klembord!" 
            : "Link copied to clipboard!");
        }
        // Track clipboard fallback
        try {
          amplitude.track("general_share_clicked", {
            platform: isIOS() ? "ios" : isAndroid() ? "android" : "web",
            lang: langString,
            status: "clipboard_fallback",
          });
        } catch (amplitudeError) {
          console.warn('Failed to track general share clipboard fallback event:', amplitudeError);
        }
      } catch (clipboardError) {
        console.error("Error copying to clipboard:", clipboardError);
        // Track failure
        try {
          amplitude.track("general_share_clicked", {
            platform: isIOS() ? "ios" : isAndroid() ? "android" : "web",
            lang: langString,
            status: "failed",
          });
        } catch (amplitudeError) {
          console.warn('Failed to track general share failed event:', amplitudeError);
        }
      }
    }
  };

  const handleContactClick = async () => {
    closeMenuModal();
    
    const emailAddress = "info@smartfriendsapp.com";
    const subject = "WordHit Question";
    let emailBody = "";
    
    // Detect platform
    const isIOS = typeof window !== "undefined" && window.Capacitor 
      ? window.Capacitor.getPlatform() === "ios"
      : false;
    const isAndroid = typeof window !== "undefined" && window.Capacitor
      ? window.Capacitor.getPlatform() === "android"
      : false;
    const isNative = isIOS || isAndroid;
    
    // If user is logged in, include all Parse data in the email body
    if (currentUser) {
      try {
        // Get app version info for iOS and Android
        let appVersion = "";
        let appBuild = "";
        if (isNative && typeof window !== "undefined" && window.Capacitor) {
          try {
            const { App } = await import("@capacitor/app");
            const info = await App.getInfo();
            appVersion = info.version || "";
            appBuild = info.build || "";
          } catch (versionError) {
            console.warn("Could not get app version info:", versionError);
          }
        }
        
        // Collect all Parse user data
        const platform = isIOS ? "iOS" : isAndroid ? "Android" : "Web";
        const userData = {
          id: currentUser.id,
          username: currentUser.get("username") || "",
          name: currentUser.get("name") || "",
          email: currentUser.get("email") || "",
          score: currentUser.get("score") ?? 0,
          streak: currentUser.get("streak") ?? 0,
          maxStreak: currentUser.get("maxStreak") ?? 0,
          numbersPlayed: currentUser.get("numbersPlayed") ?? 0,
          lastWonId: currentUser.get("lastWonId") || null,
          createdAt: currentUser.get("createdAt") ? currentUser.get("createdAt").toISOString() : "",
          updatedAt: currentUser.get("updatedAt") ? currentUser.get("updatedAt").toISOString() : "",
          platform: platform,
          appVersion: appVersion ? `v${appVersion}` : "",
          appBuild: appBuild ? ` (${appBuild})` : "",
        };
        
        // Format user data as text
        const versionText = userData.appVersion 
          ? (langString === "nl" ? `App Versie: ${userData.appVersion}${userData.appBuild}\n` : `App Version: ${userData.appVersion}${userData.appBuild}\n`)
          : "";
        
        emailBody = langString === "nl"
          ? `\n\n--- Gebruikersgegevens ---\n` +
            versionText +
            `User ID: ${userData.id}\n` +
            `Gebruikersnaam: ${userData.username}\n` +
            `Naam: ${userData.name}\n` +
            `E-mail: ${userData.email}\n` +
            `Platform: ${userData.platform}\n` +
            `Score: ${userData.score}\n` +
            `Reeks: ${userData.streak}\n` +
            `Max reeks: ${userData.maxStreak}\n` +
            `Aantal gespeeld: ${userData.numbersPlayed}\n` +
            `Laatste gewonnen ID: ${userData.lastWonId || "Geen"}\n` +
            `Aangemaakt: ${userData.createdAt}\n` +
            `Bijgewerkt: ${userData.updatedAt}`
          : `\n\n--- User Data ---\n` +
            versionText +
            `User ID: ${userData.id}\n` +
            `Username: ${userData.username}\n` +
            `Name: ${userData.name}\n` +
            `Email: ${userData.email}\n` +
            `Platform: ${userData.platform}\n` +
            `Score: ${userData.score}\n` +
            `Streak: ${userData.streak}\n` +
            `Max Streak: ${userData.maxStreak}\n` +
            `Numbers Played: ${userData.numbersPlayed}\n` +
            `Last Won ID: ${userData.lastWonId || "None"}\n` +
            `Created: ${userData.createdAt}\n` +
            `Updated: ${userData.updatedAt}`;
      } catch (error) {
        console.error("Error collecting user data for contact email:", error);
        // Continue with empty body if data collection fails
      }
    }
    
    // Store email data for fallback
    setContactEmailData({ email: emailAddress, subject: subject, body: emailBody });
    
    // Try to open mail composer
    let mailOpened = false;
    
    try {
      // On iOS, try native mail composer first
      if (isIOS && typeof window !== "undefined" && window.Capacitor) {
        try {
          const { default: MailComposer } = await import('../utils/mailComposer');
          
          if (MailComposer) {
            console.log("[Contact] MailComposer plugin found, attempting to open...");
            await MailComposer.composeMail({
              recipients: [emailAddress],
              subject: subject,
              body: emailBody
            });
            console.log("[Contact] MailComposer opened successfully");
            mailOpened = true;
            return;
          }
        } catch (pluginError) {
          console.error("[Contact] Native mail composer error:", pluginError);
          // Fall through to mailto: link
        }
      }
      
      // For all platforms (iOS, Android, Web), try mailto: link
      const encodedBody = encodeURIComponent(emailBody);
      const encodedSubject = encodeURIComponent(subject);
      const mailtoLink = `mailto:${emailAddress}?subject=${encodedSubject}&body=${encodedBody}`;
      
      // Try window.location.href first (works better on mobile)
      try {
        window.location.href = mailtoLink;
        // Assume it worked - if not, user can manually use fallback
        mailOpened = true;
        return;
      } catch (hrefError) {
        console.warn("[Contact] window.location.href failed, trying window.open:", hrefError);
      }
      
      // Fallback to window.open
      const mailWindow = window.open(mailtoLink, "_blank");
      
      if (!mailWindow) {
        // window.open returned null - no handler available
        console.warn("[Contact] window.open returned null, no mail handler available");
        mailOpened = false;
      } else {
        // window.open succeeded, assume mail app will open
        // Note: We can't reliably detect if mail app actually opened,
        // so we assume success. User can use fallback manually if needed.
        mailOpened = true;
        return;
      }
    } catch (error) {
      console.error("[Contact] Error opening mail:", error);
      mailOpened = false;
    }
    
    // If mail couldn't be opened, show fallback popup
    // Note: We show fallback if window.open returns null (definitive failure)
    if (!mailOpened) {
      setShowContactFallback(true);
    }
  };

  const handleCreateCustomClick = () => {
    closeMenuModal();
    setShowCustomCreator(true);
  };

  const closeProfileModal = () => {
    setShowProfileModal(false);
  };

  const handleProfileButtonClick = () => {
    closeMenuModal();
    if (currentUser) {
      setShowProfileModal(true);
      return;
    }
    openAuthModal(AuthModes.SIGN_UP);
  };

  const handleProfileUpdated = (updatedUser) => {
    if (updatedUser) {
      setCurrentUser(updatedUser);
      // Update avatar URL to show new avatar immediately in menu
      const avatarFile = updatedUser.get("avatar");
      if (avatarFile && typeof avatarFile.url === "function") {
        const remoteUrl = avatarFile.url();
        setProfileAvatarUrl(remoteUrl || profileDefault);
      } else {
        setProfileAvatarUrl(profileDefault);
      }
    }
  };

  const handleProfileLoggedOut = () => {
    setCurrentUser(null);
    setProfileAvatarUrl(profileDefault);
    setShowProfileModal(false);
    // Clear Amplitude user ID when user logs out
    // After logout, Amplitude will automatically track via device ID again
    try {
      amplitude.setUserId(null);
      // Note: identify() is not needed here - setUserId(null) is sufficient
    } catch (amplitudeError) {
      console.warn('Failed to clear Amplitude user ID on logout:', amplitudeError);
    }
  };

  const handlePrimaryCreateClick = () => {
    handleCreateCustomClick();
  };

  // revealed[r][c] true -> player can see that cell
  const [revealed, setRevealed] = useState(
    Array.from({ length: GRID_SIZE }, () =>
      Array.from({ length: GRID_SIZE }, () => false)
    )
  );

  // clicksLeft: can now go negative
  const [clicksLeft, setClicksLeft] = useState(MAX_CLICKS);
  const [displayClicksLeft, setDisplayClicksLeft] = useState(MAX_CLICKS); // getal in UI; wisselt halverwege flip
  const [animateClicks, setAnimateClicks] = useState(false);
  const [animateClicksDirection, setAnimateClicksDirection] = useState('decrease'); // 'decrease' | 'increase' for flip direction
  const prevClicksLeftRef = useRef(MAX_CLICKS);

  // Hint feature: temporary highlight of unrevealed letter cells
  const [isHintActive, setIsHintActive] = useState(false);
  const hintTimeoutRef = useRef(null);
  const [hasHintIntroPlayed, setHasHintIntroPlayed] = useState(false);
  const [hasShownHintBalloon, setHasShownHintBalloon] = useState(false);

  // Flip/miss animatie bij klik: delays per cel (alleen bij click, niet bij guess)
  const [localRevealDelays, setLocalRevealDelays] = useState(null);
  // Tutorial: cellen met letter die nog moeten flippen pas "active" (heldere border) wanneer hun flip begint
  const [cellsWithFlipStarted, setCellsWithFlipStarted] = useState(() => new Set());
  const flipStartedTimeoutsRef = useRef([]);
  // Bij correcte word guess: houd woord blauw tot laatste flip klaar is
  const [pendingSolvedWords, setPendingSolvedWords] = useState([]);
  const pendingSolvedWordTimersRef = useRef({});
  const guessFlipEndTimerRef = useRef(null);
  // Totale duur van de laatst gestarte grid-animatie (klik of guess),
  // zodat de result-popup pas na de animatie verschijnt.
  const gridAnimationDelayRef = useRef(0);
  const [isGridAnimating, setIsGridAnimating] = useState(false);
  const gridAnimationTimeoutRef = useRef(null);

  function startGridAnimation(durationMs) {
    const d = Math.max(0, durationMs || 0);

    if (gridAnimationTimeoutRef.current) {
      clearTimeout(gridAnimationTimeoutRef.current);
      gridAnimationTimeoutRef.current = null;
    }

    if (d === 0) {
      gridAnimationDelayRef.current = 0;
      setIsGridAnimating(false);
      return;
    }

    gridAnimationDelayRef.current = d;
    setIsGridAnimating(true);
    gridAnimationTimeoutRef.current = setTimeout(() => {
      setIsGridAnimating(false);
      gridAnimationDelayRef.current = 0;
      gridAnimationTimeoutRef.current = null;
    }, d);
  }

  // Clear hint timeout on unmount
  useEffect(() => {
    return () => {
      if (hintTimeoutRef.current) {
        clearTimeout(hintTimeoutRef.current);
        hintTimeoutRef.current = null;
      }
    };
  }, []);

  // Play intro flash for hint button once per game when it first appears (clicksLeft goes to <= 3)
  useEffect(() => {
    if (!hasHintIntroPlayed && clicksLeft <= 3) {
      setHasHintIntroPlayed(true);
    }
  }, [clicksLeft, hasHintIntroPlayed]);

  // Show one-time hint explanation balloon the very first time the hint button appears (any game)
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (clicksLeft > 4) return;
    if (isGridAnimating) return;

    const id = game?.idNumber;
    const isTutorialLikeGame = id === 9999 || id === 9998 || id === 9997;
    if (isTutorialLikeGame) return;

    // Only show hint feature for players with 5 games or fewer
    const numbersPlayed = scoreDictionary.numbersPlayed ?? 0;
    if (numbersPlayed > 5) return;

    if (hasShownHintBalloon) return;
    if (localStorage.getItem("hasSeenHintBalloon") === "true") return;

    // Wait a tick so the button is in the DOM
    const timer = setTimeout(() => {
      showBalloonAt(
        ".hint-button",
        langString === "nl" ? "Hint nodig?" : "Need a hint?"
      );
      localStorage.setItem("hasSeenHintBalloon", "true");
      setHasShownHintBalloon(true);
    }, 100);

    return () => clearTimeout(timer);
  }, [clicksLeft, game, hasShownHintBalloon, langString, isGridAnimating, scoreDictionary.numbersPlayed]);

  // Tutorial: zodra de flip-animatie van een cel begint (delay verstreken), markeer die cel als "active"
  useEffect(() => {
    flipStartedTimeoutsRef.current.forEach(clearTimeout);
    flipStartedTimeoutsRef.current = [];
    if (!localRevealDelays) {
      setCellsWithFlipStarted(new Set());
      return;
    }
    const initialStarted = new Set();
    const timeouts = [];
    for (let rr = 0; rr < GRID_SIZE; rr++) {
      for (let cc = 0; cc < GRID_SIZE; cc++) {
        const delay = localRevealDelays[rr]?.[cc];
        if (delay == null) continue;
        const key = `${rr},${cc}`;
        if (delay === 0) {
          initialStarted.add(key);
          continue;
        }
        const id = setTimeout(() => {
          setCellsWithFlipStarted((prev) => {
            const next = new Set(prev);
            next.add(key);
            return next;
          });
        }, delay);
        timeouts.push(id);
      }
    }
    setCellsWithFlipStarted(initialStarted);
    flipStartedTimeoutsRef.current = timeouts;
    return () => {
      timeouts.forEach(clearTimeout);
      flipStartedTimeoutsRef.current = [];
    };
  }, [localRevealDelays]);

  // Animate clicksLeft when it changes
  useEffect(() => {
    // Only animate if clicksLeft actually changed (skip initial render)
    if (prevClicksLeftRef.current !== clicksLeft) {
      // Skip animation on initial mount
      const isInitialMount = prevClicksLeftRef.current === MAX_CLICKS && clicksLeft === MAX_CLICKS;
      if (!isInitialMount) {
        const prev = prevClicksLeftRef.current;
        const next = clicksLeft;
        setDisplayClicksLeft(prev); // toon oud getal tijdens hele flip
        setAnimateClicksDirection(next < prev ? 'decrease' : 'increase');
        setAnimateClicks(true);
        const endTimer = setTimeout(() => {
          setAnimateClicks(false);
          setDisplayClicksLeft(next); // pas getal aan na animatie
        }, 1600);
        const numberUpdateTimer = setTimeout(() => {
          setDisplayClicksLeft(next); // wijzig getal net vóór einde flip (animatie 1.4s)
        }, 1320); // fractie voor einde
        prevClicksLeftRef.current = next;
        return () => {
          clearTimeout(endTimer);
          clearTimeout(numberUpdateTimer);
        };
      }
    }
    prevClicksLeftRef.current = clicksLeft;
    setDisplayClicksLeft(clicksLeft); // sync wanneer we niet animeren (bv. initial mount)
  }, [clicksLeft]);

  // guess: text input for guessing a whole word
  const [guess, setGuess] = useState("");

  // message: feedback like "Fout woord." / "Dat woord had je al!"
  // const [message, setMessage] = useState("");

  // modal with uitleg
  const [showRules, setShowRules] = useState(false);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 430);
  const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
  const [imagesLoaded, setImagesLoaded] = useState(false);
  
  // First time intro modal (replaces Rules modal for first-time users)
  const [showFirstTimeIntroModal, setShowFirstTimeIntroModal] = useState(false);
  
  // Tutorial tooltips (only shown during first-time tutorial)
  const [showTutorialTooltip1, setShowTutorialTooltip1] = useState(false);
  const [showTutorialTooltip2, setShowTutorialTooltip2] = useState(false);
  const [tutorialClickCount, setTutorialClickCount] = useState(0);
  const [totalTutorialClicks, setTotalTutorialClicks] = useState(0); // Total clicks including guided clicks
  const [isFirstTimeTutorial, setIsFirstTimeTutorial] = useState(false);
  const [tutorialTooltip1Shown, setTutorialTooltip1Shown] = useState(false); // Track if tooltip 1 was already shown
  
  // Track if next practice game exists
  const [nextPracticeGameExists, setNextPracticeGameExists] = useState(false);
  
  // Advanced tutorial: guided clicks
  const [currentGuidedClickIndex, setCurrentGuidedClickIndex] = useState(0);
  const [showGuidedHand, setShowGuidedHand] = useState(false);
  const [guidedHandPosition, setGuidedHandPosition] = useState({ left: 0, top: 0, visible: false });
  const guidedHandPositionRef = useRef({ left: 0, top: 0, visible: false });
  const guidedAdvanceScheduledRef = useRef(false); // true = wacht op flip-animatie voor volgende hand

  // Keep ref in sync with state
  useEffect(() => {
    guidedHandPositionRef.current = guidedHandPosition;
  }, [guidedHandPosition]);

  // ✅ overlay flash after correct guess
  const [showCheckOverlay, setShowCheckOverlay] = useState(false);
  const [clicksToShow, setClicksToShow] = useState(1);

  const [showCustomCreator, setShowCustomCreator] = useState(false);
  const [showMenuModal, setShowMenuModal] = useState(false);
  const [debugPushResult, setDebugPushResult] = useState(null);
  const [showMenuRedDot, setShowMenuRedDot] = useState(false);
  const [showRemindersRedDot, setShowRemindersRedDot] = useState(false);
  const [showStatisticsModal, setShowStatisticsModal] = useState(false);
  const [showFaqModal, setShowFaqModal] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showShareLegendModal, setShowShareLegendModal] = useState(false);
  // FEATURE: BATTLE_MODE
  const [showBattleModeModal, setShowBattleModeModal] = useState(false);
  const [selectedBattleGameId, setSelectedBattleGameId] = useState(null);
  const [selectedBattleInfo, setSelectedBattleInfo] = useState(null);
  const refreshBattleListRef = useRef(null); // set by BattleModeModal; call when closing WordHitBattle so list updates (green → not green)

  // Swipe left/right to open/close battle menu; swipe down to close menu modal (touch gestures)
  const swipeTouchRef = useRef({ startX: 0, startY: 0 });
  const SWIPE_MIN_DISTANCE = 60;
  const handleSwipeTouchStart = useCallback((e) => {
    const t = e.touches?.[0];
    if (t) {
      swipeTouchRef.current = { startX: t.clientX, startY: t.clientY };
    }
  }, []);
  const handleSwipeTouchEnd = useCallback((e) => {
    const t = e.changedTouches?.[0];
    if (!t) return;
    const { startX, startY } = swipeTouchRef.current;
    const deltaX = t.clientX - startX;
    const deltaY = t.clientY - startY;

    // Vertical swipe: menu modal (swipe down = close, swipe up = no-op)
    if (Math.abs(deltaY) >= SWIPE_MIN_DISTANCE && Math.abs(deltaY) > Math.abs(deltaX)) {
      if (deltaY > 0) {
        setShowMenuModal(false);
      }
      return;
    }

    // Horizontal swipe: battle menu (when battle available on platform)
    if (!isBattleModeEnabled() || !isBattleModeAvailableOnPlatform()) return;
    if (Math.abs(deltaX) < SWIPE_MIN_DISTANCE) return;
    if (Math.abs(deltaY) > Math.abs(deltaX)) return;
    if (deltaX > 0) {
      setShowBattleModeModal(false);
    } else {
      setShowBattleModeModal(true);
    }
  }, [currentUser]);

  // Open battle when user tapped a battle turn notification (banner or from background)
  useEffect(() => {
    console.log("[WordHit] Notification-open effect run", { battleMode: isBattleModeEnabled(), hasUser: !!currentUser });
    if (!isBattleModeEnabled()) return;

    const openBattleById = async (battleId) => {
      if (!battleId || !Parse?.Cloud) return;
      try {
        const result = await Parse.Cloud.run("getUserBattles");
        if (!result?.success || !Array.isArray(result.battles)) {
          console.warn("[WordHit] Open from notification: getUserBattles failed or empty", result?.success, result?.battles?.length);
          return;
        }
        const battle = result.battles.find(
          (b) => (b.id && String(b.id) === String(battleId)) || (b.objectId && String(b.objectId) === String(battleId))
        );
        if (battle) {
          // Same as BattleModeModal: pass battleGameId (current game's BattleGame objectId) and full battle info
          const gameId = battle.battleGameId || battle.id;
          setSelectedBattleGameId(gameId);
          setSelectedBattleInfo(battle);
        } else {
          console.warn("[WordHit] Open from notification: battle not found in list, battleId:", battleId, "battles count:", result.battles?.length);
        }
      } catch (e) {
        console.warn("[WordHit] Failed to open battle from notification:", e);
      }
    };

    const handleOpenBattleFromNotification = (e) => {
      let battleId = e?.detail?.battleId;
      if (!battleId && typeof e?.detail === "string") {
        try {
          const parsed = JSON.parse(e.detail);
          battleId = parsed?.battleId;
        } catch (_) {}
      }
      if (battleId) {
        openBattleById(battleId);
        clearPendingBattleIdFromNative(); // so we don't reopen same battle on next app launch
      }
    };
    window.addEventListener("wordhit-open-battle-from-notification", handleOpenBattleFromNotification);

    // When app comes to foreground (e.g. user tapped notification): event may have been sent before listener existed, so also check plugin
    const handleAppForeground = async () => {
      if (!currentUser || !isBattleModeEnabled()) return;
      const id = await getPendingBattleIdFromNative();
      if (id) {
        console.log("[WordHit] App foreground: opening battle from plugin, battleId:", id);
        openBattleById(id);
      }
    };
    window.addEventListener("appWillEnterForeground", handleAppForeground);

    // App opened from notification tap: check native UserDefaults then sessionStorage. Only after user is logged in.
    (async () => {
      if (!currentUser) {
        console.log("[WordHit] Pending notification check skipped: no currentUser yet");
        return;
      }
      console.log("[WordHit] Checking pending notification battle id (native + sessionStorage)...");
      await new Promise((r) => setTimeout(r, 500));
      let pendingId = await getPendingBattleIdFromNative();
      if (!pendingId) pendingId = getPendingBattleIdFromNotification();
      console.log("[WordHit] Pending battle id:", pendingId || "(none)");
      if (pendingId) {
        console.log("[WordHit] Opening battle from pending notification, battleId:", pendingId);
        openBattleById(pendingId);
      }
    })();

    return () => {
      window.removeEventListener("wordhit-open-battle-from-notification", handleOpenBattleFromNotification);
      window.removeEventListener("appWillEnterForeground", handleAppForeground);
    };
  }, [currentUser]);
  // END FEATURE: BATTLE_MODE
  const [faqItems, setFaqItems] = useState([]);
  const [isFaqLoading, setIsFaqLoading] = useState(false);
  const [faqError, setFaqError] = useState("");
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

   // ❌ overlay flash after wrong guess
  const [showCrossOverlay, setShowCrossOverlay] = useState(false);

  // win/lose popups
const [hasWon, setHasWon] = useState(false);
const [hasLost, setHasLost] = useState(false);

// Zodra het spel afgelopen is: grid-animatie direct opheffen zodat het grid niet geblokkeerd blijft (o.a. tutorial)
useEffect(() => {
  if (!hasWon && !hasLost) return;
  if (gridAnimationTimeoutRef.current) {
    clearTimeout(gridAnimationTimeoutRef.current);
    gridAnimationTimeoutRef.current = null;
  }
  gridAnimationDelayRef.current = 0;
  setIsGridAnimating(false);
  guidedAdvanceScheduledRef.current = false;
}, [hasWon, hasLost]);

// Check if next practice game exists when tutorial game is finished
useEffect(() => {
  async function checkNextPracticeGame() {
    if (!game || !isTutorialGame(game.idNumber)) {
      setNextPracticeGameExists(false);
      return;
    }
    
    const gameIdNumber = game.idNumber;
    const finishedLocal =
      typeof window !== "undefined" &&
      String(localStorage.getItem("finishedGameidNummer")) === String(gameIdNumber);
    const finishedRemote = finishedIdNumbers.includes(gameIdNumber);
    const isFinished = finishedLocal || finishedRemote || hasWon || hasLost;
    
    if (!isFinished) {
      setNextPracticeGameExists(false);
      return;
    }
    
    // Check if next practice game exists
    let nextPracticeId = null;
    if (gameIdNumber === TUTORIAL_GAME_ID) {
      nextPracticeId = PRACTICE_GAME_ID_2;
    } else if (gameIdNumber === PRACTICE_GAME_ID_2) {
      nextPracticeId = PRACTICE_GAME_ID_3;
    }
    
    if (nextPracticeId) {
      const exists = await checkIfGameExists(nextPracticeId);
      setNextPracticeGameExists(exists);
    } else {
      setNextPracticeGameExists(false);
    }
  }
  
  checkNextPracticeGame();
}, [game, finishedIdNumbers, hasWon, hasLost]);

// iOS: Ask for notification permission when "tomorrow" balloon is closed
// This happens after the user finishes a game and sees the "Morgen staat een nieuwe..." message

const [showWinPopup, setShowWinPopup] = useState(false);
const [showLosePopup, setShowLosePopup] = useState(false);
/** Alleen true nadat tutorial result-popup (OK of klik erbuiten) is gesloten; voorkomt dat "Nog een tutorial" / "Dagelijkse WordHit" vóór de popup verschijnen */
const [tutorialResultPopupDismissed, setTutorialResultPopupDismissed] = useState(false);
/** Words found at the moment we showed win/lose popup (avoids race with scoreDictionary update) */
const [resultWordsFound, setResultWordsFound] = useState(null);
const [resultModalOpenedByScoreButton, setResultModalOpenedByScoreButton] = useState(false);
const [showRatePopup, setShowRatePopup] = useState(false);
const [isFirstTimeShowingResult, setIsFirstTimeShowingResult] = useState(false);
const [showConfetti, setShowConfetti] = useState(false);
const confettiTimeoutRef = useRef(null);
const [pulseShareScoreButton, setPulseShareScoreButton] = useState(false);
const pulseShareScoreTimeoutRef = useRef(null);
  const [pulseTutorialButton, setPulseTutorialButton] = useState(false);
  const pulseTutorialTimeoutRef = useRef(null);
const [showContactFallback, setShowContactFallback] = useState(false);
const [contactEmailData, setContactEmailData] = useState({ email: "", subject: "", body: "" });

// % of users who did worse on this id (lower lastScore, incl. non-wins as 0)
const [worseUsersPct, setWorseUsersPct] = useState(null);

useEffect(() => {
  let cancelled = false;
  async function loadWorseUsersPct() {
    setWorseUsersPct(null);
    if (!hasWon || !showWinPopup) return;
    const idNumber = game?.idNumber;
    if (!Number.isFinite(idNumber)) return;
    if (!Number.isFinite(clicksLeft)) return;
    const myScore = Math.max(0, Math.min(10, Math.floor(clicksLeft)));
    try {
      const res = await Parse.Cloud.run("getScoreDistributionForId", { idNumber });
      if (cancelled) return;
      const total = Number(res?.total) || 0;
      const counts = res?.counts || {};
      if (total <= 0) return;
      let topCount = 0;
      for (let s = myScore; s <= 10; s++) {
        topCount += Number(counts?.[s]) || 0;
      }
      const pct = Math.round((topCount / total) * 100);
      setWorseUsersPct(pct);
    } catch (e) {
      // fail open: no comparison text
    }
  }
  loadWorseUsersPct();
  return () => {
    cancelled = true;
  };
}, [hasWon, showWinPopup, game?.idNumber, clicksLeft]);

// Track window width for responsive modal sizing
useEffect(() => {
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };
  
  // Set initial width
  if (typeof window !== 'undefined') {
    setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
  }
  
  return () => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', handleResize);
    }
  };
}, []);

// Show landscape warning (one-time only, only on small screens)
useEffect(() => {
  let warningTimer = null;
  
  const checkOrientation = () => {
    const isLandscape = window.innerWidth > window.innerHeight;
    const isSmallScreen = window.innerWidth < 768; // Don't show on iPads (768px and larger)
    
    if (isLandscape && isSmallScreen && !landscapeWarningShownRef.current && !isLoading) {
      landscapeWarningShownRef.current = true;
      setShowLandscapeWarning(true);
      
      // Hide after 3 seconds
      warningTimer = setTimeout(() => {
        setShowLandscapeWarning(false);
      }, 3000);
    }
  };
  
  // Check on mount and on resize
  checkOrientation();
  
  if (typeof window !== 'undefined') {
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);
  }
  
  return () => {
    if (warningTimer) {
      clearTimeout(warningTimer);
    }
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    }
  };
}, [isLoading]);

// Swipe-down hook for FaqModal - must be called with other hooks
useEffect(() => {
  return () => {
    if (confettiTimeoutRef.current) {
      clearTimeout(confettiTimeoutRef.current);
      confettiTimeoutRef.current = null;
    }
    if (pulseShareScoreTimeoutRef.current) {
      clearTimeout(pulseShareScoreTimeoutRef.current);
      pulseShareScoreTimeoutRef.current = null;
    }
    if (pulseTutorialTimeoutRef.current) {
      clearTimeout(pulseTutorialTimeoutRef.current);
      pulseTutorialTimeoutRef.current = null;
    }
  };
}, []);

// Effect to trigger pulse 10s after tutorial game finishes
useEffect(() => {
  const gameIdNumber = game?.idNumber ?? idNumber;
  
  if (!isTutorialGame(gameIdNumber)) {
    setPulseTutorialButton(false);
    if (pulseTutorialTimeoutRef.current) {
      clearTimeout(pulseTutorialTimeoutRef.current);
      pulseTutorialTimeoutRef.current = null;
    }
    return;
  }
  
  const finishedLocal =
    typeof window !== "undefined" &&
    String(localStorage.getItem("finishedGameidNummer")) === String(gameIdNumber);
  const isAlreadyFinishedToday =
    !game?.creator && (finishedLocal || finishedIdNumbers.includes(gameIdNumber));

  if (hasWon || hasLost || isAlreadyFinishedToday) {
     if (!pulseTutorialTimeoutRef.current && !pulseTutorialButton) {
        pulseTutorialTimeoutRef.current = setTimeout(() => {
           setPulseTutorialButton(true);
        }, 5000);
     }
  } else {
      setPulseTutorialButton(false);
      if (pulseTutorialTimeoutRef.current) {
        clearTimeout(pulseTutorialTimeoutRef.current);
        pulseTutorialTimeoutRef.current = null;
      }
  }
}, [game, hasWon, hasLost, finishedIdNumbers, idNumber, pulseTutorialButton]);

function triggerShareScoreButtonPulse(durationMs = 3200) {
  setPulseShareScoreButton(true);
  if (pulseShareScoreTimeoutRef.current) {
    clearTimeout(pulseShareScoreTimeoutRef.current);
    pulseShareScoreTimeoutRef.current = null;
  }
  pulseShareScoreTimeoutRef.current = setTimeout(() => {
    setPulseShareScoreButton(false);
    pulseShareScoreTimeoutRef.current = null;
  }, durationMs);
}

const {
  competitionEntries,
  competitionOppositeMonthTop3,
  competitionLoading,
  competitionError,
  competitionMonthLabel,
  competitionMessageLines,
  competitionTexts,
  competitionTableLabels,
  refreshCompetitionLeaderboard,
} = useCompetitionLeaderboard({
  enabled: true,
  lang: langString,
  modalVisible: showScoreModal || showWinPopup || showLosePopup,
});

const [balloon, setBalloon] = useState({ visible: false, x: 0, y: 0, text: "", type: null });
const [shownNoClicksBalloon, setShownNoClicksBalloon] = useState(false);
const [shownIntroMenuBalloon, setShownIntroMenuBalloon] = useState(false);
const menuButtonRef = useRef(null);
const boardRef = useRef(null);
const prevShowRulesRef = useRef(false);
const prevBalloonVisibleRef = useRef(false);
const pendingBalloonRef = useRef(null); // Store balloon to show after auth modal closes
const countCellRef = useRef(null); // Ref for first count cell (tooltip 1)
const colCountsRowRef = useRef(null); // Ref for bottom row with column counts (tooltip 1)
const guessInputRef = useRef(null); // Ref for guess input (tooltip 2)
const guessFormRowRef = useRef(null); // Ref for guess form row (input + button) for tooltip 2 positioning
const wordhitWrapperRef = useRef(null);

function scrollGameViewToTopAfterGuess() {
  guessInputRef.current?.blur();
  const scrollToTop = () => {
    const wrapper = wordhitWrapperRef.current;
    if (wrapper) wrapper.scrollTop = 0;
    window.scrollTo(0, 0);
  };
  scrollToTop();
  requestAnimationFrame(scrollToTop);
  window.setTimeout(scrollToTop, 100);
  window.setTimeout(scrollToTop, 300);
}

// Track showRules changes (for other purposes, menu balloon removed)
useEffect(() => {
  prevShowRulesRef.current = showRules;
}, [showRules]);

// Tooltip 1: Show after tutorial grid loads (wait 1 second)
useEffect(() => {
  if (!game || !isTutorialGame(game.idNumber) || isLoading) {
    return;
  }
  
  // Don't show tooltips for 9997
  if (game.idNumber === PRACTICE_GAME_ID_3) {
    return;
  }
  
  // For 9999, only show if first time tutorial
  // For 9998, always show (but with different text)
  if (game.idNumber === TUTORIAL_GAME_ID && !isFirstTimeTutorial) {
    return;
  }
  
  // Only show if first-time intro modal is dismissed (not visible) - only for 9999
  if (game.idNumber === TUTORIAL_GAME_ID && showFirstTimeIntroModal) {
    return;
  }
  
  // Only show if we haven't shown tooltip 1 yet (and it hasn't been shown before)
  if (!showTutorialTooltip1 && !showTutorialTooltip2 && !tutorialTooltip1Shown) {
    const timeoutId = setTimeout(() => {
      setShowTutorialTooltip1(true);
      setTutorialTooltip1Shown(true); // Mark as shown
    }, 1000); // Wait 1 second
    
    return () => clearTimeout(timeoutId);
  }
}, [game, isLoading, showTutorialTooltip1, showTutorialTooltip2, isFirstTimeTutorial, tutorialTooltip1Shown, showFirstTimeIntroModal]);

// Tooltip 2 does not auto-close (user must click to close)

// Close tooltip 1 on first click
useEffect(() => {
  if (showTutorialTooltip1 && tutorialClickCount > 0) {
    setShowTutorialTooltip1(false);
  }
}, [showTutorialTooltip1, tutorialClickCount]);

// Reset guided click index when game changes (useLayoutEffect zodat index al goed staat vóór paint, anders kan eerste klik op 9998 geblokkeerd zijn)
useLayoutEffect(() => {
  guidedAdvanceScheduledRef.current = false;
  if (gridAnimationTimeoutRef.current) {
    clearTimeout(gridAnimationTimeoutRef.current);
    gridAnimationTimeoutRef.current = null;
  }
  gridAnimationDelayRef.current = 0;
  setIsGridAnimating(false);

  setShowGuidedHand(false);
  setGuidedHandPosition({ left: 0, top: 0, visible: false });
  
  // For tutorial 9999: Find first non-revealed guided click
  if (game?.idNumber === TUTORIAL_GAME_ID && game?.guidedClicks && Array.isArray(game.guidedClicks)) {
    let firstNonRevealedIndex = 0;
    for (let i = 0; i < game.guidedClicks.length; i++) {
      const guidedClick = game.guidedClicks[i];
      const match = guidedClick.match(/^r(\d+)c(\d+)$/);
      if (match) {
        const row = parseInt(match[1], 10) - 1; // Convert to 0-indexed
        const col = parseInt(match[2], 10) - 1; // Convert to 0-indexed
        // Check if this cell is already revealed
        if (!revealed[row] || !revealed[row][col]) {
          firstNonRevealedIndex = i;
          break;
        }
      }
      // If we reach the end, all guided clicks are revealed
      if (i === game.guidedClicks.length - 1) {
        firstNonRevealedIndex = game.guidedClicks.length; // All done
      }
    }
    setCurrentGuidedClickIndex(firstNonRevealedIndex);
  } else {
    setCurrentGuidedClickIndex(0);
  }
  
  // Reset tooltip states when switching to a practice game (9998 or 9997)
  // Only reset when game ID changes, not on every revealed change
  if (game?.idNumber === PRACTICE_GAME_ID_2 || game?.idNumber === PRACTICE_GAME_ID_3) {
    setShowTutorialTooltip1(false);
    setShowTutorialTooltip2(false);
    setTutorialTooltip1Shown(false);
    setTutorialClickCount(0);
  }
}, [game?.idNumber]); // Alleen bij game-wissel resetten; guidedClicks weglaten zodat timeout niet telkens wordt geannuleerd en guess weer werkt

// Separate effect for 9999: Update guided click index when revealed changes
useEffect(() => {
  // Niet overschrijven als we een vertraagde advance hebben gepland (wacht op flip-animatie)
  if (guidedAdvanceScheduledRef.current) return;
  // Only for tutorial 9999: Find first non-revealed guided click when revealed changes
  if (game?.idNumber === TUTORIAL_GAME_ID && game?.guidedClicks && Array.isArray(game.guidedClicks)) {
    let firstNonRevealedIndex = 0;
    for (let i = 0; i < game.guidedClicks.length; i++) {
      const guidedClick = game.guidedClicks[i];
      const match = guidedClick.match(/^r(\d+)c(\d+)$/);
      if (match) {
        const row = parseInt(match[1], 10) - 1; // Convert to 0-indexed
        const col = parseInt(match[2], 10) - 1; // Convert to 0-indexed
        // Check if this cell is already revealed
        if (!revealed[row] || !revealed[row][col]) {
          firstNonRevealedIndex = i;
          break;
        }
      }
      // If we reach the end, all guided clicks are revealed
      if (i === game.guidedClicks.length - 1) {
        firstNonRevealedIndex = game.guidedClicks.length; // All done
      }
    }
    setCurrentGuidedClickIndex(firstNonRevealedIndex);
  }
}, [revealed, game?.idNumber, game?.guidedClicks]);

// Advanced tutorial: Show guided hand icon and update position
useEffect(() => {
  if (!game?.guidedClicks || !Array.isArray(game.guidedClicks) || game.guidedClicks.length === 0) {
    setShowGuidedHand(false);
    setGuidedHandPosition({ left: 0, top: 0, visible: false });
    return;
  }
  
  // For tutorial 9999, only show hand after tooltip 1 is dismissed
  const shouldShow = game.idNumber === TUTORIAL_GAME_ID
    ? (!showTutorialTooltip1 && tutorialTooltip1Shown)
    : true;
  
  if (!shouldShow) {
    setShowGuidedHand(false);
    setGuidedHandPosition({ left: 0, top: 0, visible: false });
    return;
  }

  // Wacht op flip-animatie: hand niet verplaatsen tot de timeout heeft afgelopen
  if (guidedAdvanceScheduledRef.current) {
    setShowGuidedHand(false);
    setGuidedHandPosition({ left: 0, top: 0, visible: false });
    return;
  }
  
  // For tutorial 9999: Skip already revealed guided clicks
  let effectiveIndex = currentGuidedClickIndex;
  if (game.idNumber === TUTORIAL_GAME_ID) {
    // Find the first guided click that is not yet revealed
    for (let i = currentGuidedClickIndex; i < game.guidedClicks.length; i++) {
      const guidedClick = game.guidedClicks[i];
      const match = guidedClick.match(/^r(\d+)c(\d+)$/);
      if (match) {
        const row = parseInt(match[1], 10) - 1; // Convert to 0-indexed
        const col = parseInt(match[2], 10) - 1; // Convert to 0-indexed
        // Check if this cell is already revealed
        if (!revealed[row] || !revealed[row][col]) {
          effectiveIndex = i;
          break;
        }
      }
      // If we reach the end, all remaining guided clicks are revealed
      if (i === game.guidedClicks.length - 1) {
        effectiveIndex = game.guidedClicks.length; // All done
      }
    }
  }
  
  // Check if all guided clicks are completed
  if (effectiveIndex >= game.guidedClicks.length) {
    setShowGuidedHand(false);
    setGuidedHandPosition({ left: 0, top: 0, visible: false });
    return;
  }
  
  // Get current guided click position (use effectiveIndex for 9999)
  const currentGuidedClick = game.guidedClicks[effectiveIndex];
  if (!currentGuidedClick) {
    setShowGuidedHand(false);
    setGuidedHandPosition({ left: 0, top: 0, visible: false });
    return;
  }
  
  const match = currentGuidedClick.match(/^r(\d+)c(\d+)$/);
  if (!match) {
    setShowGuidedHand(false);
    setGuidedHandPosition({ left: 0, top: 0, visible: false });
    return;
  }
  
  // guidedClicks uses 1-indexed format (like playSequence), convert to 0-indexed
  const guidedRow = parseInt(match[1], 10) - 1;
  const guidedCol = parseInt(match[2], 10) - 1;
  
  // Simple function to update position - called after delay
  const updatePosition = () => {
    if (!boardRef.current) return;
    
    const boardRows = boardRef.current.querySelectorAll('.board-row:not(.board-row-counts)');
    if (!boardRows || boardRows.length <= guidedRow) return;
    
    const targetRow = boardRows[guidedRow];
    if (!targetRow) return;
    
    const cells = Array.from(targetRow.children).filter(child => 
      child.classList.contains('cell') && !child.classList.contains('count-cell')
    );
    
    if (!cells || cells.length <= guidedCol) return;
    
    const targetCell = cells[guidedCol];
    if (!targetCell) return;
    
    const cellRect = targetCell.getBoundingClientRect();
    const boardRect = boardRef.current.getBoundingClientRect();
    
    if (!cellRect || !boardRect || cellRect.width === 0 || cellRect.height === 0) return;
    
    const left = cellRect.left - boardRect.left + cellRect.width / 2;
    const top = cellRect.top - boardRect.top + cellRect.height / 2;
    
    const newPosition = { left, top, visible: true };
    guidedHandPositionRef.current = newPosition;
    setGuidedHandPosition(newPosition);
    setShowGuidedHand(true);
  };
  
  // Wait until grid is loaded, then show hand immediately (no delay to match highlight)
  if (isLoading) {
    // If still loading, wait and retry
    const timeoutId = setTimeout(() => {
      // Re-trigger effect when loading is done
      if (!isLoading && game?.board) {
        // Force re-evaluation
        setShowGuidedHand(prev => !prev);
        setTimeout(() => setShowGuidedHand(prev => !prev), 10);
      }
    }, 100);
    return () => clearTimeout(timeoutId);
  }
  
  // Grid is loaded, show hand immediately (same timing as highlight)
  const timeoutId = setTimeout(() => {
    updatePosition();
  }, 50); // Very short delay just to ensure DOM is ready
  
  return () => {
    clearTimeout(timeoutId);
  };
}, [game?.guidedClicks, game?.idNumber, game?.board, currentGuidedClickIndex, showTutorialTooltip1, tutorialTooltip1Shown, TUTORIAL_GAME_ID, isLoading, revealed]);

// Preload images when modal is about to open to prevent layout shift
useEffect(() => {
  if (!showRules) {
    setImagesLoaded(false);
    setImageDimensions({ width: 0, height: 0 });
    return;
  }

  // Determine which images to load based on current language
  const imagesToLoad = langString === "nl" 
    ? [exampleNL1, exampleNL2, exampleNL3]
    : [exampleEN1, exampleEN2, exampleEN3];

  // Preload all images and get dimensions
  const loadImages = async () => {
    try {
      const imagePromises = imagesToLoad.map((src) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            resolve({ width: img.naturalWidth, height: img.naturalHeight });
          };
          img.onerror = () => {
            // Fallback dimensions if image fails to load
            resolve({ width: 340, height: 200 });
          };
          img.src = src;
        });
      });

      const dimensions = await Promise.all(imagePromises);
      // Use the dimensions from the first image (they should all be similar)
      // Account for max-width: 340px and width: 90% styling
      // Modal width is 90% of window (or 85% on small screens), max 360px
      const modalWidth = Math.min(windowWidth <= 430 ? windowWidth * 0.85 : windowWidth * 0.9, 360);
      // Image width is 90% of modal width, max 340px
      const maxDisplayWidth = Math.min(340, modalWidth * 0.9);
      // Calculate height based on aspect ratio
      const aspectRatio = dimensions[0].height / dimensions[0].width;
      const displayHeight = maxDisplayWidth * aspectRatio;

      setImageDimensions({ 
        width: maxDisplayWidth, 
        height: displayHeight 
      });
      setImagesLoaded(true);
    } catch (error) {
      console.warn("Failed to preload images:", error);
      // Set fallback dimensions
      setImageDimensions({ width: 340, height: 200 });
      setImagesLoaded(true);
    }
  };

  loadImages();
}, [showRules, langString, windowWidth]);

// Track balloon visibility changes
useEffect(() => {
  prevBalloonVisibleRef.current = balloon.visible;
}, [balloon.visible]);

// Detect when "tomorrow" balloon is closed and ask for notification permission
useEffect(() => {
  // Check if balloon was just closed (went from visible to not visible)
  const wasVisible = prevBalloonVisibleRef.current;
  const isNowVisible = balloon.visible;
  const wasTomorrowType = balloon.type === "tomorrow";
  
  // Only ask for permission if it's a regular daily game (not tutorial games 9999, 9998, 9997)
  const isRegularGame = game && !isTutorialGame(game.idNumber) && !game.creator;
  
  // If "tomorrow" balloon was just closed (was visible, now not visible, and was tomorrow type)
  if (wasVisible && !isNowVisible && wasTomorrowType && isNative() && !hasAskedForPermission() && isRegularGame) {
    console.log('[WordHit] Tomorrow balloon closed, requesting notification permission...');
    requestNotificationPermission().then((result) => {
      if (result.granted) {
        // Schedule for tomorrow at current time + 1 hour when permission is first granted
        scheduleNotificationForTomorrow(undefined, true).catch((error) => {
          console.warn("Failed to schedule notification for tomorrow:", error);
        });
      }
    });
  }
  
  // Update ref for next check (must be at the end, always executed)
  prevBalloonVisibleRef.current = balloon.visible;
}, [balloon.visible, balloon.type, game]);

const [isCheatRevealActive, setIsCheatRevealActive] = useState(false);
const cheatRevealedSnapshotRef = useRef(null);

const [errorText, setErrorText] = useState("");

// Check if running in Capacitor iOS
function isCapacitorIOS() {
  if (typeof window === "undefined" || !window.Capacitor) return false;
  return window.Capacitor.getPlatform() === 'ios';
}

// Check if running in Capacitor Android
function isCapacitorAndroid() {
  if (typeof window === "undefined" || !window.Capacitor) return false;
  return window.Capacitor.getPlatform() === 'android';
}

// Helper function to open App Store review page (iOS only)
// Uses Capacitor's Browser plugin to open URL properly
async function requestAppleReviewIfNeeded() {
  if (typeof window === "undefined" || !window.Capacitor) {
    return;
  }
  
  const platform = window.Capacitor.getPlatform();
  if (platform !== 'ios') {
    return;
  }
  
  const appStoreId = '6755532039';
  
  // Use HTTPS URL - iOS will automatically open in App Store app
  const reviewUrl = `https://apps.apple.com/app/id${appStoreId}?action=write-review`;
  
  console.log("[Review] Opening App Store review page:", reviewUrl);
  
  // Use Capacitor's Browser plugin (most reliable method)
  if (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.Browser) {
    try {
      await window.Capacitor.Plugins.Browser.open({ url: reviewUrl });
      console.log("[Review] ✅ Opened via Browser plugin");
      return;
    } catch (error) {
      console.error("[Review] Browser.open failed:", error);
    }
  }
  
  // Fallback: Create a hidden anchor and click it
  const link = document.createElement('a');
  link.href = reviewUrl;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  console.log("[Review] Opened via anchor click (fallback)");
}

// Helper function to open Play Store review page (Android only)
// Uses Capacitor's Browser plugin to open URL properly
async function requestAndroidReviewIfNeeded() {
  if (typeof window === "undefined" || !window.Capacitor) {
    return;
  }
  
  const platform = window.Capacitor.getPlatform();
  if (platform !== 'android') {
    return;
  }
  
  const packageName = 'com.wordhit.app';
  
  // Use HTTPS URL - Android will automatically open in Play Store app
  const reviewUrl = `https://play.google.com/store/apps/details?id=${packageName}`;
  
  console.log("[Review] Opening Play Store review page:", reviewUrl);
  
  // Use Capacitor's Browser plugin (most reliable method)
  if (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.Browser) {
    try {
      await window.Capacitor.Plugins.Browser.open({ url: reviewUrl });
      console.log("[Review] ✅ Opened via Browser plugin");
      return;
    } catch (error) {
      console.error("[Review] Browser.open failed:", error);
    }
  }
  
  // Fallback: Create a hidden anchor and click it
  const link = document.createElement('a');
  link.href = reviewUrl;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  console.log("[Review] Opened via anchor click (fallback)");
}

// Handle rate button click
function handleRateClick() {
  // Don't show review request if user is marked as possible cheater
  if (currentUser && currentUser.get("possibleCheater") === true) {
    setShowRatePopup(false);
    return;
  }
  
  // Track Amplitude event
  try {
    amplitude.track("review_button_clicked", {});
  } catch (amplitudeError) {
    console.warn('Failed to track review button clicked event:', amplitudeError);
  }
  
  localStorage.setItem('hasRatedApp', 'true');
  setShowRatePopup(false);
  requestAppleReviewIfNeeded();
  requestAndroidReviewIfNeeded();
}

// Handle close/dismiss rate popup
function handleRateDismiss() {
  localStorage.setItem('ratePopupDismissed', 'true');
  setShowRatePopup(false);
}

// Show rate popup when result modal is closed (iOS and Android)
// Review_1_Trigger: Show when numbersPlayed > 2 and review1TriggerDisplayed is false/nil
// Review_2_Trigger: Show when numbersPlayed = 10 and review2TriggerDisplayed is false/nil
function showRatePopupOnModalClose() {
  // Only show on iOS or Android
  if (!isCapacitorIOS() && !isCapacitorAndroid()) {
    return;
  }
  
  // Don't show review request if user is marked as possible cheater
  if (currentUser && currentUser.get("possibleCheater") === true) {
    return;
  }
  
  const numbersPlayed = scoreDictionary.numbersPlayed ?? 0;
  
  // Review_1_Trigger: Check if numbersPlayed > 2
  const Review_1_Trigger = numbersPlayed > 1;
  const review1TriggerDisplayed = localStorage.getItem('review1TriggerDisplayed');
  const shouldShowReview1 = Review_1_Trigger && (review1TriggerDisplayed === null || review1TriggerDisplayed === 'false');
  
  // Review_2_Trigger: Check if numbersPlayed = 10
  const Review_2_Trigger = numbersPlayed === 10;
  const review2TriggerDisplayed = localStorage.getItem('review2TriggerDisplayed');
  const shouldShowReview2 = Review_2_Trigger && (review2TriggerDisplayed === null || review2TriggerDisplayed === 'false');
  
  // Show popup if either trigger condition is met
  if (shouldShowReview1) {
    // Show popup when modal closes
    setShowRatePopup(true);
    // Mark that review trigger has been displayed
    localStorage.setItem('review1TriggerDisplayed', 'true');
  } else if (shouldShowReview2) {
    // Show popup when modal closes
    setShowRatePopup(true);
    // Mark that review trigger has been displayed
    localStorage.setItem('review2TriggerDisplayed', 'true');
  }
}


const [languageString, setLanguageString] = useState({
      textGuessWord:"",
      textUnknownWord:"",
      textMaxGuessLength:"",
      textClicks:"",
      textTheme:"",
      textWon: "",
      textLost:"",
      textExplanation1:"",
      textExplanation2:"",
      textExplanation3:"",
      textExplanationTitle:"",
      textShareTodayScore:""

});

   
  useEffect(() => {

    if (langString === "nl") {
      setLanguageString({
         textGuessWord: "Raad een woord...",
         textUnknownWord: "Onbekend woord",
         textMaxGuessLength: "Max. 7 letters",
         textClick: "klik",
         textClicks: "kliks",
         textTheme:"Thema: ",
         textWon: "Goed gedaan!",
         textLost:"Helaas...!",
         textExplanationTitle:"",
         textShareTodayScore: "Deel",

        textExplanation1:`
Vind de 3 verborgen woorden.<br/><br/>Ze staan horizontaal, verticaal of diagonaal en passen bij het thema bovenaan het letterveld.<br/><br/>
`,
textExplanation2:`
De cijfers naast en onder het veld tonen hoeveel letters in elke rij of kolom zitten.<br/><br/>
Letters van verschillende woorden kunnen in dezelfde rij of kolom staan.<br/><br/>
`,

textExplanation3:`
Klik op een vakje om een letter te onthullen. Je mag 7 keer klikken.<br/><br/>
Weet je een woord? Typ het in. Een fout woord kost 1 klik, een goed woord levert 1 klik op.<br/><br/>
`
      });
    } else {

      setLanguageString({
       textGuessWord: "Guess a word...",
       textUnknownWord: "Unknown word",
       textMaxGuessLength: "Max 7 letters",
       textClick:"click",
       textClicks:"clicks",
       textTheme:"Theme: ",
      textWon: "Well done! ",
      textLost:"Unfortunately...",
      textExplanationTitle:"",
      textShareTodayScore: "Share",
    textExplanation1: `
Find the 3 hidden words.<br/><br/>They appear horizontally, vertically, or diagonally and match the theme above the letter grid.<br/><br/>
`,

textExplanation2:`
The numbers next to and below the grid show how many letters are hidden in each row or column.<br/><br/>
Letters from different words can appear in the same row or column.<br/><br/>
`,

textExplanation3:`
Click a square to reveal a letter. You have 7 clicks.<br/><br/>
Know a word? Type it in. A wrong word costs 1 click, a correct word gives 1 click back.<br/><br/>
`,
      });
    }

  }, []);



function isCellInFullyVisibleWord(r, c, placements, revealed) {
  for (const p of placements) {
    for (let i = 0; i < p.word.length; i++) {
      let rr = p.r;
      let cc = p.c;
      if (p.dir === "H") {
        cc = p.c + i;
      } else if (p.dir === "V") {
        rr = p.r + i;
      } else if (p.dir === "DR") {
        rr = p.r + i; cc = p.c + i;
      } else if (p.dir === "DL") {
        rr = p.r + i; cc = p.c - i;
      } else if (p.dir === "UR") {
        rr = p.r - i; cc = p.c + i;
      } else if (p.dir === "UL") {
        rr = p.r - i; cc = p.c - i;
      }
      if (rr === r && cc === c) {
        // this cell belongs to word p.word

        //ADD TO VISIBLEWORDS, NOT WHEN POPUP IS OPEN BECAUSE THAN EVERYTHING IS VISIBLE
        if (isWordFullyVisible(p.word, placements, revealed)) {
          if (!showWinPopup && !showLosePopup && visibleWords.includes(p.word) == false) {
            setVisibleWords((prev) => [...prev, p.word]);


          }
          return true;
        }
      }
    }
  }
  return false;
}


  const WidgetHeaderDate = () => {

    if (game && isTutorialGame(game.idNumber)) {
      return getTutorialLabel(langString);
    }

    const date = new Date();

    if (langString === "nl") {
      const month = date.toLocaleString("nl-NL", { month: "long" });
      const day = date.toLocaleString("nl-NL", { day: "numeric" });

      return `${day} ${month}`;
    } else {
      const month = date.toLocaleString("en-EN", { month: "long" });
      const day = date.toLocaleString("en-EN", { day: "numeric" });

      return `${month} ${day}`;
    }
  };

  // Function to load tutorial game (WEB ONLY - called from "Let's start" button)
  const loadTutorial = async () => {
    // Extra safety: if tutorial is permanently disabled (e.g. after user chose daily WordHit),
    // immediately load the normal daily game instead of tutorial/practice IDs.
    if (isTutorialPermanentlyDisabled()) {
      skipTutorial();
      return;
    }

    // Show loader with custom text
    setCustomLoaderText(langString === "nl" ? "We laden de tutorial..." : "Loading tutorial...");
    setIsLoading(true);
    setGame(null); // Reset game to force reload
    
    const loadStart = Date.now();
    
    try {
      console.log("[Tutorial] Loading tutorial game 9999 from 'Let's start' button");
      const built = await buildGameForToday(langString, TUTORIAL_GAME_ID);
      setGame(built);
      gameRef.current = built;
      
      // Reset game state
      setRevealed(Array.from({ length: GRID_SIZE }, () =>
        Array.from({ length: GRID_SIZE }, () => false)
      ));
      setClicksLeft(MAX_CLICKS);
      setGuessedWords([]);
      setWrongGuessedWords([]);
      setPlaySequenceActions([]);
      playSequenceActionsRef.current = [];
      setHasWon(false);
      setHasLost(false);
      setShowWinPopup(false);
      setShowLosePopup(false);
      autoRevealFinishedRef.current = false;
      setGuess("");
      
      // Hide red dots for tutorial
      setShowMenuRedDot(false);
      setShowRemindersRedDot(false);
      
      // Ensure loader is visible for minimum time to avoid flash
      const elapsed = Date.now() - loadStart;
      const remaining = Math.max(LOADER_MIN_DISPLAY_MS - elapsed, 0);
      await new Promise((r) => setTimeout(r, remaining));
      
      setIsLoading(false);
      setCustomLoaderText(null);
      
      // Reset tutorial tooltip states when tutorial loads (only if first-time tutorial)
      if (isFirstTimeTutorial) {
        setTutorialClickCount(0);
        setTotalTutorialClicks(0);
        setShowTutorialTooltip1(false);
        setShowTutorialTooltip2(false);
        setTutorialTooltip1Shown(false); // Reset flag when tutorial loads
      }
      
    } catch (err) {
      console.error("Error loading tutorial game:", err);
      setIsLoading(false);
      setCustomLoaderText(null);
    }
  };

  // Function to skip tutorial and load normal game
  const skipTutorial = () => {
    // Mark tutorial as shown in localStorage
    markTutorialAsShown();
    // Extra safety: once user explicitly chooses the daily WordHit,
    // permanently disable loading tutorial/practice IDs on this device.
    disableTutorialPermanently();
    
    // Close the balloon immediately
    closeBalloon();
    
    setTransitioningFromTutorial(true);
    setCustomLoaderText(langString === "nl" ? "WordHit van vandaag laden..." : "Loading today's WordHit...");
    setIsLoading(true);
    setGame(null); // Reset game to force reload
    
    // Force reload logic (similar to new day check)
    const loadStart = Date.now();
    async function loadNormalGame() {
      try {
        const fromDate = new Date(2022, 0, 1);
        const currentDate = new Date();
        const utcCurrent = Date.UTC(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate()
        );
        const utcFrom = Date.UTC(
          fromDate.getFullYear(),
          fromDate.getMonth(),
          fromDate.getDate()
        );
        const currentIdNumber = Math.floor((utcCurrent - utcFrom) / (1000 * 60 * 60 * 24));
        
        console.log(`[Tutorial] Skipping tutorial, loading normal game ${currentIdNumber}`);
        const built = await buildGameForToday(langString, currentIdNumber);
        setGame(built);
        gameRef.current = built;
        
        // Reset game state
        setRevealed(Array.from({ length: GRID_SIZE }, () =>
          Array.from({ length: GRID_SIZE }, () => false)
        ));
        setClicksLeft(MAX_CLICKS);
        setGuessedWords([]);
        setWrongGuessedWords([]);
        setPlaySequenceActions([]);
        playSequenceActionsRef.current = [];
        setHasWon(false);
        setHasLost(false);
        setShowWinPopup(false);
        setShowLosePopup(false);
        autoRevealFinishedRef.current = false;
        setGuess("");
        
        const elapsed = Date.now() - loadStart;
        const remaining = Math.max(LOADER_MIN_DISPLAY_MS - elapsed, 0);
        await new Promise((r) => setTimeout(r, remaining));
        setIsLoading(false);
      } catch (err) {
        console.error("Error loading normal game after skipping tutorial:", err);
        setIsLoading(false);
      }
    }
    loadNormalGame();
  };

  useEffect(() => {
    //localStorage.removeItem("hasSeenExplanation"); //FOR TESTING PURPOSES ONLY
    // Only show first-time intro when user has never played (numbersPlayed === 0)
    const storedScores = getStoredScores();
    const neverPlayed = (storedScores.numbersPlayed ?? 0) === 0;
    const noIntro = new URLSearchParams(getAppSearchString()).get("noIntro") === "true";
    if (!localStorage.getItem("hasSeenExplanation") && neverPlayed && !noIntro) {
       // Show new first-time intro modal instead of Rules modal
       setShowFirstTimeIntroModal(true);
       setIsFirstTimeTutorial(true); // Mark that this is the first-time tutorial
       // Don't set hasSeenExplanation here - only set it when user actually interacts with the modal
    }

  }, []);

  const updateCountdown = () => {
    let now = new Date();
    let midnight = new Date();
    midnight.setHours(24, 0, 0, 0);

    let timeDiff = midnight - now;

    let hours = Math.floor(timeDiff / (1000 * 60 * 60));
    let minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    seconds = seconds < 10 ? `0${seconds}` : seconds;

    setCountDownTimer(`${hours + ":"}${minutes + ":"}${seconds}`);

    globalCounter = `${hours + ":"}${minutes + ":"}${seconds}`;

    if (langString === "nl") {
      globalCounter = `${hours + "u"}${` ` + minutes + "m"}${
        ` en ` + seconds + `s`
      }`;
    } else {
      globalCounter = `${hours + "h"}${` ` + minutes + "m"}${
        ` and ` + seconds + `s`
      }`;
    }

     //console.log('countDownTimer',countDownTimer);
     //console.log('globalCounter',globalCounter);
  };

 useEffect(() => {

      const timerInterval = setInterval(() => {

        updateCountdown();
      }, 1000);

      return () => {
        clearInterval(timerInterval);
      };

  }, []);


  useEffect(() => {
    const loadStart = Date.now();
    async function loadGame() {
      try {
        // Calculate current idNumber
        const fromDate = new Date(2022, 0, 1);
        const currentDate = new Date();
        const utcCurrent = Date.UTC(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate()
        );
        const utcFrom = Date.UTC(
          fromDate.getFullYear(),
          fromDate.getMonth(),
          fromDate.getDate()
        );
        let currentIdNumber = Math.floor((utcCurrent - utcFrom) / (1000 * 60 * 60 * 24));

        // Determine if tutorial/practice games are permanently disabled on this device
        const tutorialDisabled = isTutorialPermanentlyDisabled();

        // Check for URL override (id parameter)
        const urlParams = new URLSearchParams(getAppSearchString());
        const overruledId = urlParams.get("id");
        const pubID = urlParams.get("pubID");
        if (overruledId) {
          const parsedOverride = parseInt(overruledId);
          if (Number.isFinite(parsedOverride)) {
            // Extra safety: ignore overrides to tutorial/practice IDs once tutorial is permanently disabled
            if (!tutorialDisabled || !isTutorialGame(parsedOverride)) {
              currentIdNumber = parsedOverride;
              console.log(`[Load] URL override: using idNumber ${currentIdNumber} from URL parameter`);
            } else {
              console.log(`[Tutorial] Ignoring URL override to tutorial/practice ID ${parsedOverride} because tutorial is permanently disabled.`);
            }
          }
        }

        // Tutorial Check (only if no URL override that we actually used)
        // - iOS/Android first install: always load tutorial 9999
        // - pubID=adv: always load tutorial 9999 (any platform)
        // - On web (no adv): tutorial only when user clicks "Let's start" in explanation modal
        const isNativeFirstTime = !isWeb() && (() => {
          const storedScores = getStoredScores();
          return shouldShowTutorial(storedScores.numbersPlayed);
        })();
        const forceTutorialForAdv = pubID === "adv";
        if (!overruledId && !tutorialDisabled && (isNativeFirstTime || forceTutorialForAdv)) {
          console.log("[Tutorial] Loading tutorial game 9999", isNativeFirstTime ? "(first install native)" : `(pubID=${pubID})`);
          currentIdNumber = TUTORIAL_GAME_ID;
        }
        
        // FEATURE: SMART_DATA_CACHING - DISABLED
        // const loadedIdNummer = localStorage.getItem("loadedIdNummer");
        // const gameAlreadyLoaded = loadedIdNummer && String(loadedIdNummer) === String(currentIdNumber);
        // 
        // if (gameAlreadyLoaded) {
        //   console.log(`[Load] Game for idNumber ${currentIdNumber} already loaded today, skipping download (SMART_DATA_CACHING)`);
        //   // Still need to build the game object (it's deterministic, so we can rebuild from cached data)
        //   // But we can skip the Parse fetch
        //   const built = await buildGameForToday(langString, currentIdNumber);
        //   setGame(built);
        //   gameRef.current = built;
        //   
        //   // Skip loader animation since we're using cached data
        //   setIsLoading(false);
        //   return;
        // }
        
        // New day or first load - download game data
        console.log(`[Load] Loading game for idNumber ${currentIdNumber} (new day or first load)`);
        const built = await buildGameForToday(langString, currentIdNumber);
        setGame(built); // idNumber is now included in built object
        gameRef.current = built; // Update ref immediately
        
        // Initialize share result tracking for new game (will be restored if in-progress game exists)
        if (built?.idNumber !== undefined && built?.idNumber !== null) {
          // Check if there's existing tracking data, if not initialize
          const existingActions = loadShareResultActions(built.idNumber);
          if (existingActions.length === 0) {
            initShareResultTracking(built.idNumber);
          }
        }

        // Start preloading intro images while loader is visible
        const introImages = [
          exampleNL1, exampleNL2, exampleNL3,
          exampleEN1, exampleEN2, exampleEN3,
          mainLogo, nextLogo, profileDefault,
        ];
        // Kick off preloading, but don't let it shorten the loader animation duration
        preloadImages(introImages, 900).catch(() => {});

        const elapsed = Date.now() - loadStart;
        const remaining = Math.max(LOADER_MIN_DISPLAY_MS - elapsed, 0);
        await new Promise((r) => setTimeout(r, remaining));
        if (!DEBUG_KEEP_LOADER_VISIBLE) {
          setIsLoading(false);
          setTransitioningFromTutorial(false); // Reset transition state
        }
        
        // Note: Red dot check is handled in a separate useEffect that triggers when game state is ready
        // This ensures the check happens after the game is fully loaded and isLoading is false
      } catch (err) {
        console.error("Fatal load error:", err);
        // Parse errors have a code property (100 = network error, etc.)
        const isNetworkError = err?.code === 100 || 
          (err?.message && (
            err.message.toLowerCase().includes("load failed") ||
            err.message.toLowerCase().includes("network") ||
            err.message.toLowerCase().includes("fetch") ||
            err.message.toLowerCase().includes("connection")
          ));
        
        const errorMessage = isNetworkError
          ? (langString === "nl" 
              ? "Geen internetverbinding. Controleer je internet en probeer het opnieuw." 
              : "No internet connection. Check your connection and try again.")
          : (err?.message && !err.message.toLowerCase().includes("load failed"))
            ? err.message
            : (langString === "nl" 
                ? "WordHit kon niet geladen worden." 
                : "Unable to load the WordHit.");
        setLoadError(errorMessage);
        const elapsed = Date.now() - loadStart;
        const remaining = Math.max(LOADER_MIN_DISPLAY_MS - elapsed, 0);
        setTimeout(() => {
          if (!DEBUG_KEEP_LOADER_VISIBLE) {
            setIsLoading(false);
          }
        }, remaining);
      }
    }
    loadGame();
  }, [langString]);

  // Check for prefill URL parameter and enable cheat mode if prefill=qazx
  // This must be before early returns to avoid "Rendered more hooks" error
  useEffect(() => {
    if (!game) return;
    if (isCheatRevealActive) return; // Already active, don't do anything
    if (cheatRevealedSnapshotRef.current) return; // Already processed
    
    const urlParams = new URLSearchParams(getAppSearchString());
    const prefill = urlParams.get("prefill");
    
    if (prefill === "qazx") {
      // Inline the enableCheatMode logic to avoid dependency issues
      // We need to get the current revealed state via a function to avoid dependency
      setRevealed((currentRevealed) => {
        cheatRevealedSnapshotRef.current = currentRevealed.map((row) => row.slice());
        return revealEntireBoard(game.board);
      });
      setIsCheatRevealActive(true);
    }
  }, [game, isCheatRevealActive]);

  // Show update required screen if update is required (iOS only)
  if (updateRequired) {
    const updateErrorMessage = langString === "nl"
      ? `Je app versie is verouderd. Update naar versie ${updateRequiredVersion || ''} om door te gaan.`
      : `Your app version is outdated. Update to version ${updateRequiredVersion || ''} to continue.`;
    
    return (
      <ErrorScreen
        errorMessage={updateErrorMessage}
        showUpdateButton={true}
        langString={langString}
      />
    );
  }

  // Show error screen if there's a load error
  if (loadError) {
    const handleReload = () => {
      setLoadError(null);
      setIsLoading(true);
      // Reload the game
      const loadStart = Date.now();
      async function reloadGame() {
        try {
          const fromDate = new Date(2022, 0, 1);
          const currentDate = new Date();
          const utcCurrent = Date.UTC(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate()
          );
          const utcFrom = Date.UTC(
            fromDate.getFullYear(),
            fromDate.getMonth(),
            fromDate.getDate()
          );
          let currentIdNumber = Math.floor((utcCurrent - utcFrom) / (1000 * 60 * 60 * 24));
          
          // Check for URL override (id parameter)
          const urlParams = new URLSearchParams(getAppSearchString());
          const overruledId = urlParams.get("id");
          if (overruledId) {
            currentIdNumber = parseInt(overruledId);
            console.log(`[Load] Reload: URL override: using idNumber ${currentIdNumber} from URL parameter`);
          }
          
          console.log(`[Load] Reloading game for idNumber ${currentIdNumber}`);
          const built = await buildGameForToday(langString, currentIdNumber);
          setGame(built);
          gameRef.current = built;
          
          // Initialize share result tracking for reloaded game
          if (built?.idNumber !== undefined && built?.idNumber !== null) {
            const existingActions = loadShareResultActions(built.idNumber);
            if (existingActions.length === 0) {
              initShareResultTracking(built.idNumber);
            }
          }

          const introImages = [
            exampleNL1, exampleNL2, exampleNL3,
            exampleEN1, exampleEN2, exampleEN3,
            mainLogo, nextLogo, profileDefault,
          ];
          preloadImages(introImages, 900).catch(() => {});

      const elapsed = Date.now() - loadStart;
      const remaining = Math.max(LOADER_MIN_DISPLAY_MS - elapsed, 0);
      await new Promise((r) => setTimeout(r, remaining));
      if (!DEBUG_KEEP_LOADER_VISIBLE) {
        setIsLoading(false);
      }
        } catch (err) {
          console.error("Fatal load error on reload:", err);
          // Parse errors have a code property (100 = network error, etc.)
          const isNetworkError = err?.code === 100 || 
            (err?.message && (
              err.message.toLowerCase().includes("load failed") ||
              err.message.toLowerCase().includes("network") ||
              err.message.toLowerCase().includes("fetch") ||
              err.message.toLowerCase().includes("connection")
            ));
          
          const errorMessage = isNetworkError
            ? (langString === "nl" 
                ? "Geen internetverbinding. Controleer je internet en probeer het opnieuw." 
                : "No internet connection. Check your connection and try again.")
            : (err?.message && !err.message.toLowerCase().includes("load failed"))
              ? err.message
              : (langString === "nl" 
                  ? "WordHit kon niet geladen worden." 
                  : "Unable to load the WordHit.");
          setLoadError(errorMessage);
          const elapsed = Date.now() - loadStart;
          const remaining = Math.max(LOADER_MIN_DISPLAY_MS - elapsed, 0);
          setTimeout(() => {
            if (!DEBUG_KEEP_LOADER_VISIBLE) {
              setIsLoading(false);
            }
          }, remaining);
        }
      }
      reloadGame();
    };

    return (
      <ErrorScreen
        errorMessage={loadError}
        onReload={handleReload}
        langString={langString}
      />
    );
  }

  if (isLoading) {
    return (
      <Loader 
        debugMode={DEBUG_KEEP_LOADER_VISIBLE} 
        customText={customLoaderText}
      />
    );
  }

  const menuButtonTitle =
    langString === "nl" ? "Menu & uitleg" : "Menu & help";
  const statsButtonTitle =
    langString === "nl" ? "Statistieken" : "Statistics";

  if (!game) {
    return (
      <div className="wordhit-wrapper">
        <div className="top-header">
          <div className="title-row">

    <img
      src={mainLogo}
      alt="Today"
      className="game-logo"
      style={{ width: "187px", height: "35px" }}
    />
    <div className="widget-header">
      <div className="green-line-thin"></div>
      <div className="green-line-thick"></div>
      <div className="yellow-block"></div>
      <div className="blue-square"></div>
      <div className="red-square"></div>
      <div className="green-outline-left"></div>
      <div className="yellow-outline-right"></div>
      <div className="blue-outline-right"></div>
      {WidgetHeaderDate()}
      </div>
      <div className="dashes-line">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div style={{ position: "absolute", top: "-45px", left: "8px", zIndex: 1 }}>
      <button
        ref={menuButtonRef}
        onClick={() => {
          setShowMenuModal(true);
        }}
        className="explanation-button"
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        aria-label="Menu"
        title={menuButtonTitle}
      >
        {/* Custom menu icon: three circles with rectangles */}
        <svg
          width="28"
          height="28"
          viewBox="-2 0 30 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Top circle with rectangle */}
          <circle cx="0" cy="8" r="1.5" fill="#194093" />
          <rect x="3" y="6.5" width="25" height="3" rx="0.5" fill="#194093" />
          {/* Middle circle with rectangle */}
          <circle cx="0" cy="16" r="1.5" fill="#194093" />
          <rect x="3" y="14.5" width="25" height="3" rx="0.5" fill="#194093" />
          {/* Bottom circle with rectangle */}
          <circle cx="0" cy="24" r="1.5" fill="#194093" />
          <rect x="3" y="22.5" width="25" height="3" rx="0.5" fill="#194093" />
        </svg>
      </button>
    </div>
</div>

          {errorText ? (
            <div className="feedback-message" style={{ color: "red" }}>
              {errorText}
            </div>
          ) : (
            <div className="feedback-message"></div>
          )}
        </div>
        {showCustomCreator && (
          <CreateCustomWordHit
            onClose={() => {
              setShowCustomCreator(false);
              // Don't reopen menu modal - close everything when subpage closes
              setShowMenuModal(false);
            }}
            langString={langString}
          />
        )}
      </div>
    );
  }

  // onthult elke cel in het raster (alle letters en lege vakken worden zichtbaar)
function revealEntireBoard(board) {

  return board.map(row => row.map(() => true));
}

  function getStoredFinishedOutcomeValue(id) {
    if (typeof window === "undefined") return null;
    try {
      const cached = finishedOutcomeCacheRef.current[String(id)];
      if (cached) {
        return cached;
      }
      const raw = localStorage.getItem("finishedGameOutcomes");
      if (!raw) {
        return null;
      }
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") {
        finishedOutcomeCacheRef.current = parsed;
        return parsed[String(id)] ?? null;
      }
    } catch (error) {
      console.warn("Failed to read finished game outcomes", error);
    }
    return null;
  }

  function storeFinishedOutcomeValue(id, outcome) {
    if (typeof window === "undefined") return;
    try {
      const raw = localStorage.getItem("finishedGameOutcomes");
      let parsed = {};
      if (raw) {
        try {
          parsed = JSON.parse(raw) || {};
        } catch (parseError) {
          console.warn("Failed to parse finished game outcomes", parseError);
          parsed = {};
        }
      }
      parsed[String(id)] = outcome;
      localStorage.setItem("finishedGameOutcomes", JSON.stringify(parsed));
      finishedOutcomeCacheRef.current = parsed;
    } catch (error) {
      console.warn("Failed to persist finished game outcome", error);
    }
  }

  function getStoredFinishedClicksLeft(id) {
    if (typeof window === "undefined") return null;
    try {
      const cached = finishedClicksLeftCacheRef.current[String(id)];
      if (cached !== undefined) {
        return cached;
      }
      const raw = localStorage.getItem("finishedGameClicksLeft");
      if (!raw) {
        return null;
      }
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") {
        finishedClicksLeftCacheRef.current = parsed;
        return parsed[String(id)] ?? null;
      }
    } catch (error) {
      console.warn("Failed to read finished game clicksLeft", error);
    }
    return null;
  }

  function storeFinishedClicksLeft(id, clicksLeft) {
    if (typeof window === "undefined") return;
    try {
      const raw = localStorage.getItem("finishedGameClicksLeft");
      let parsed = {};
      if (raw) {
        try {
          parsed = JSON.parse(raw) || {};
        } catch (parseError) {
          console.warn("Failed to parse finished game clicksLeft", parseError);
          parsed = {};
        }
      }
      parsed[String(id)] = clicksLeft;
      localStorage.setItem("finishedGameClicksLeft", JSON.stringify(parsed));
      finishedClicksLeftCacheRef.current = parsed;
    } catch (error) {
      console.warn("Failed to persist finished game clicksLeft", error);
    }
  }

  function getStoredFinishedWordsFound(id) {
    if (typeof window === "undefined") return null;
    try {
      const cached = finishedWordsFoundCacheRef.current[String(id)];
      if (cached !== undefined) {
        return cached;
      }
      const raw = localStorage.getItem("finishedGameWordsFound");
      if (!raw) {
        return null;
      }
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") {
        finishedWordsFoundCacheRef.current = parsed;
        return parsed[String(id)] ?? null;
      }
    } catch (error) {
      console.warn("Failed to read finished game wordsFound", error);
    }
    return null;
  }

  function storeFinishedWordsFound(id, wordsFound) {
    if (typeof window === "undefined") return;
    try {
      const raw = localStorage.getItem("finishedGameWordsFound");
      let parsed = {};
      if (raw) {
        try {
          parsed = JSON.parse(raw) || {};
        } catch (parseError) {
          console.warn("Failed to parse finished game wordsFound", parseError);
          parsed = {};
        }
      }
      parsed[String(id)] = wordsFound;
      localStorage.setItem("finishedGameWordsFound", JSON.stringify(parsed));
      finishedWordsFoundCacheRef.current = parsed;
    } catch (error) {
      console.warn("Failed to persist finished game wordsFound", error);
    }
  }

  // Functions to save/load current game state (for games in progress)
  function getStoredGameState(id) {
    if (typeof window === "undefined") return null;
    try {
      const raw = localStorage.getItem("currentGameState");
      if (!raw) {
        return null;
      }
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") {
        return parsed[String(id)] ?? null;
      }
    } catch (error) {
      console.warn("Failed to read current game state", error);
    }
    return null;
  }

  function storeGameState(id, state) {
    if (typeof window === "undefined") return;
    try {
      const raw = localStorage.getItem("currentGameState");
      let parsed = {};
      if (raw) {
        try {
          parsed = JSON.parse(raw) || {};
        } catch (parseError) {
          console.warn("Failed to parse current game state", parseError);
          parsed = {};
        }
      }
      parsed[String(id)] = state;
      localStorage.setItem("currentGameState", JSON.stringify(parsed));
    } catch (error) {
      console.warn("Failed to persist current game state", error);
    }
  }

  function clearGameState(id) {
    if (typeof window === "undefined") return;
    try {
      const raw = localStorage.getItem("currentGameState");
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") {
        delete parsed[String(id)];
        localStorage.setItem("currentGameState", JSON.stringify(parsed));
      }
    } catch (error) {
      console.warn("Failed to clear current game state", error);
    }
  }

  // Functions to save/load playSequence locally (for games in progress)
  function getStoredPlaySequence(id) {
    if (typeof window === "undefined") return null;
    try {
      const raw = localStorage.getItem("playSequenceLocal");
      if (!raw) {
        return null;
      }
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") {
        return parsed[String(id)] ?? null;
      }
    } catch (error) {
      console.warn("Failed to read local play sequence", error);
    }
    return null;
  }

  function storePlaySequenceLocal(id, actions) {
    if (typeof window === "undefined") return;
    try {
      const raw = localStorage.getItem("playSequenceLocal");
      let parsed = {};
      if (raw) {
        try {
          parsed = JSON.parse(raw) || {};
        } catch (parseError) {
          console.warn("Failed to parse local play sequence", parseError);
          parsed = {};
        }
      }
      parsed[String(id)] = actions;
      localStorage.setItem("playSequenceLocal", JSON.stringify(parsed));
    } catch (error) {
      console.warn("Failed to persist local play sequence", error);
    }
  }

  function clearPlaySequenceLocal(id) {
    if (typeof window === "undefined") return;
    try {
      const raw = localStorage.getItem("playSequenceLocal");
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") {
        delete parsed[String(id)];
        localStorage.setItem("playSequenceLocal", JSON.stringify(parsed));
      }
    } catch (error) {
      console.warn("Failed to clear local play sequence", error);
    }
  }

  const enableCheatMode = () => {
    if (!game || cheatRevealedSnapshotRef.current) {
      return;
    }
    cheatRevealedSnapshotRef.current = revealed.map((row) => row.slice());
    setRevealed(revealEntireBoard(game.board));
    setIsCheatRevealActive(true);
  };

  const disableCheatMode = () => {
    const previousState = cheatRevealedSnapshotRef.current;
    if (!previousState) {
      return;
    }
    setRevealed(previousState.map((row) => row.slice()));
    cheatRevealedSnapshotRef.current = null;
    setIsCheatRevealActive(false);
  };

  const handleClicksCounterClick = () => {
    if (!isCheatRevealActive) {
      return;
    }
    if (!game || game.creator) {
      return;
    }
    try {
      const params = new URLSearchParams(getAppSearchString());
      params.set("id", String(idNumber + 1));
      // Preserve lang parameter if it exists
      if (langString && langString !== "en") {
        params.set("lang", langString);
      }
      const searchString = params.toString();
      const newUrl =
        window.location.origin +
        window.location.pathname +
        (searchString ? `?${searchString}` : "");
      window.location.assign(newUrl);
    } catch (error) {
      console.warn("Failed to navigate to next puzzle", error);
    }
  };

  /*
    Utility: check if all placed words are fully visible.
    This defines "won".
  */
  function allWordsSolved(nextRevealed = revealed) {

    return game.words.every((w) =>
      isWordFullyVisible(w, game.placements, nextRevealed)
    );
  }

  function countSolvedWords(nextRevealed = revealed) {
    if (!game) return 0;
    return game.words.reduce((total, word) => {
      return isWordFullyVisible(word, game.placements, nextRevealed)
        ? total + 1
        : total;
    }, 0);
  }

  /*
    After any action (click or guess), call this with nextRevealed + nextClicksLeft
    -> decides win / lose popup
  */
function evaluateEndConditions(nextRevealed, nextClicksLeft) {
  // Use game.idNumber instead of local idNumber to ensure we use the correct game ID
  const gameIdNumber = game?.idNumber ?? idNumber;

  const solved = allWordsSolved(nextRevealed);
  const solvedWordCount = countSolvedWords(nextRevealed);

  // Winst voor het eerst gedetecteerd
  if (solved && !hasWon && !hasLost) {
    const isDailyPuzzle = !game?.creator;
    
    if (isDailyPuzzle) {
      const publisherId = getPublisherId();
      Parse.Cloud.run("updateGood", {
        idNumber: gameIdNumber,
        publisherId: publisherId || null,
      })
        .then((result) => {
          console.log("updateGood Cloud Update successful");
        })
        .catch((error) => {
          console.error("updateGood Cloud Error updating:", error);
        });
    } else {
      // Custom WordHit: increment customNumbersPlayed
      Parse.Cloud.run("incrementCustomNumbersPlayed", {
        idNumber: gameIdNumber,
      })
        .then((result) => {
          console.log("incrementCustomNumbersPlayed Cloud Update successful");
        })
        .catch((error) => {
          console.error("incrementCustomNumbersPlayed Cloud Error updating:", error);
        });
    }

    setHasWon(true);
    if (isTutorialGame(gameIdNumber)) setTutorialResultPopupDismissed(false);
    // Save locally first (instant)
    const { nextScores, monthlyIncrement } = saveScoreLocally({
      wordsFound: solvedWordCount,
      clicksRemaining: nextClicksLeft,
    });
    // Mark as first time showing result (for animation)
    setIsFirstTimeShowingResult(true);
    // Fix: set words-found for popup immediately so last word is never missing (race with setScoreDictionary)
    setResultWordsFound(solvedWordCount);
    // Toon de win-popup pas nadat de grid-animatie klaar is,
    // en wacht daarna nog 1,5 seconde voor extra rust.
    const popupDelay = (gridAnimationDelayRef.current || 0) + 1500;
    if (popupDelay > 0) {
      setTimeout(() => {
        setShowWinPopup(true);
        gridAnimationDelayRef.current = 0;
      }, popupDelay);
    } else {
      setShowWinPopup(true);
    }
    // Update Parse in background (slow) and refresh leaderboard when done
    // Pass isWin=true so lastWonId is saved
    // CRITICAL: Only mark game as finished AFTER score is successfully saved
    // This prevents race condition where markGameFinished adds ID to server before saveScoreToParse checks
    saveScoreToParse({ nextScores, monthlyIncrement, isWin: true }).then(() => {
      // Only mark as finished if score was successfully saved
      if (localStorage.getItem("finishedGameidNummer") != gameIdNumber) {
        markGameFinished("win", nextClicksLeft, solvedWordCount);
      }
      if (refreshCompetitionLeaderboard) {
        refreshCompetitionLeaderboard();
      }
    }).catch((error) => {
      console.warn("Failed to save score or refresh leaderboard", error);
      // Don't mark as finished if score save failed
    });
    
    // Save play sequence data (all actions in chronological order)
    // Use setTimeout to ensure the ref is fully updated before saving
    // This is especially important when the game ends with a guess
    if (currentUser && !game?.creator && gameIdNumber !== undefined && gameIdNumber !== null) {
      // Use setTimeout with 0 delay to ensure ref is updated in next event loop tick
      // This handles cases where the last guess that wins the game might not be in the ref yet
      setTimeout(() => {
        // Read ref directly (it's updated synchronously, so should be most up-to-date)
        let currentActions = [...playSequenceActionsRef.current];
        
        // Also check state as fallback to ensure we have the complete sequence
        const stateActions = playSequenceActions;
        if (stateActions.length > currentActions.length) {
          // State has more actions, use it and sync ref
          currentActions = [...stateActions];
          playSequenceActionsRef.current = currentActions;
        } else if (stateActions.length === currentActions.length && stateActions.length > 0) {
          // Same length, check if state has a newer last action
          const lastStateAction = stateActions[stateActions.length - 1];
          const lastCurrentAction = currentActions[currentActions.length - 1];
          if (lastStateAction && lastCurrentAction && lastStateAction.timestamp > lastCurrentAction.timestamp) {
            // State has newer action, use it and sync ref
            currentActions = [...stateActions];
            playSequenceActionsRef.current = currentActions;
          }
        }
        
        // Final check: read ref one more time just before saving to ensure we have the absolute latest
        const finalRefCheck = playSequenceActionsRef.current;
        if (finalRefCheck.length > currentActions.length) {
          currentActions = [...finalRefCheck];
        } else if (finalRefCheck.length === currentActions.length && finalRefCheck.length > 0) {
          const lastFinalRefAction = finalRefCheck[finalRefCheck.length - 1];
          const lastCurrentAction = currentActions[currentActions.length - 1];
          if (lastFinalRefAction && lastCurrentAction && lastFinalRefAction.timestamp > lastCurrentAction.timestamp) {
            currentActions = [...finalRefCheck];
          }
        }
        
        // Upload to Parse and clear local storage
        savePlaySequence(
          gameIdNumber,
          currentActions
        ).then(() => {
          // Clear local playSequence after successful upload
          clearPlaySequenceLocal(gameIdNumber);
          console.log("Play sequence uploaded to Parse and local storage cleared for idNumber:", gameIdNumber);
        }).catch((error) => {
          console.warn("Failed to save play sequence:", error);
          // Keep local storage if upload fails, so it can be retried later
        });
      }, 0);
    }
    // Confetti pas starten na de grid-animatie,
    // en net als de popup nog 1,5s wachten voor extra rust.
    const confettiDelay = Math.max(0, (gridAnimationDelayRef.current || 0) + 1500);
    setTimeout(() => {
      setShowConfetti(true);
      if (confettiTimeoutRef.current) {
        clearTimeout(confettiTimeoutRef.current);
      }
      confettiTimeoutRef.current = setTimeout(() => {
        setShowConfetti(false);
        confettiTimeoutRef.current = null;
      }, 10000);
    }, confettiDelay);

    return;
  }

  // loss detected first time
  if (nextClicksLeft < 0 && !hasWon && !hasLost) {
    const fullyRevealed = revealEntireBoard(game.board);
    setRevealed(fullyRevealed);

    const isDailyPuzzle = !game?.creator;

    if (isDailyPuzzle) {
      const publisherId = getPublisherId();
      Parse.Cloud.run("updateWrong", {
        idNumber: gameIdNumber,
        publisherId: publisherId || null,
      })
        .then((result) => {
          console.log("updateWrong Cloud Update successful");
        })
        .catch((error) => {
          console.error("updateWrong Cloud Error updating:", error);
        });
    } else {
      // Custom WordHit: increment customNumbersPlayed
      Parse.Cloud.run("incrementCustomNumbersPlayed", {
        idNumber: gameIdNumber,
      })
        .then((result) => {
          console.log("incrementCustomNumbersPlayed Cloud Update successful");
        })
        .catch((error) => {
          console.error("incrementCustomNumbersPlayed Cloud Error updating:", error);
        });
    }
    
    setHasLost(true);
    // Fix: set words-found for popup immediately so last word is never missing (race with setScoreDictionary)
    setResultWordsFound(solvedWordCount);
    // Show confetti for tutorial games regardless of win/loss,
    // maar ook hier pas na de grid-animatie + 1,5s (indien aanwezig).
    if (isTutorialGame(gameIdNumber)) {
      const confettiDelay = Math.max(0, (gridAnimationDelayRef.current || 0) + 1500);
      setTimeout(() => {
        setShowConfetti(true);
        if (confettiTimeoutRef.current) {
          clearTimeout(confettiTimeoutRef.current);
        }
        confettiTimeoutRef.current = setTimeout(() => {
          setShowConfetti(false);
          confettiTimeoutRef.current = null;
        }, 10000);
      }, confettiDelay);
    }
    // Save locally first (instant)
    const { nextScores, monthlyIncrement } = saveScoreLocally({
      wordsFound: solvedWordCount,
      clicksRemaining: nextClicksLeft,
    });
    // Mark as first time showing result (for animation)
    setIsFirstTimeShowingResult(true);
    // Show modal immediately
    if (isTutorialGame(gameIdNumber)) setTutorialResultPopupDismissed(false);
    setShowLosePopup(true);
    // Update Parse in background (slow) and refresh leaderboard when done
    // Pass isWin=false so lastWonId is NOT saved (preserve existing server value)
    // CRITICAL: Only mark game as finished AFTER score is successfully saved
    // This prevents race condition where markGameFinished adds ID to server before saveScoreToParse checks
    saveScoreToParse({ nextScores, monthlyIncrement, isWin: false }).then(() => {
      // Only mark as finished if score was successfully saved
      if (localStorage.getItem("finishedGameidNummer") != gameIdNumber) {
        markGameFinished("lose", nextClicksLeft, solvedWordCount);
      }
      if (refreshCompetitionLeaderboard) {
        refreshCompetitionLeaderboard();
      }
    }).catch((error) => {
      console.warn("Failed to save score or refresh leaderboard", error);
      // Don't mark as finished if score save failed
    });
    
    // Save play sequence data (all actions in chronological order)
    // Use setTimeout to ensure the ref is fully updated before saving
    // This is especially important when the game ends with a guess
    if (currentUser && !game?.creator && gameIdNumber !== undefined && gameIdNumber !== null) {
      // Use setTimeout with 0 delay to ensure ref is updated in next event loop tick
      // This handles cases where the last guess that ends the game might not be in the ref yet
      setTimeout(() => {
        // Read ref directly (it's updated synchronously, so should be most up-to-date)
        let currentActions = [...playSequenceActionsRef.current];
        
        // Also check state as fallback to ensure we have the complete sequence
        const stateActions = playSequenceActions;
        if (stateActions.length > currentActions.length) {
          // State has more actions, use it and sync ref
          currentActions = [...stateActions];
          playSequenceActionsRef.current = currentActions;
        } else if (stateActions.length === currentActions.length && stateActions.length > 0) {
          // Same length, check if state has a newer last action
          const lastStateAction = stateActions[stateActions.length - 1];
          const lastCurrentAction = currentActions[currentActions.length - 1];
          if (lastStateAction && lastCurrentAction && lastStateAction.timestamp > lastCurrentAction.timestamp) {
            // State has newer action, use it and sync ref
            currentActions = [...stateActions];
            playSequenceActionsRef.current = currentActions;
          }
        }
        
        // Final check: read ref one more time just before saving to ensure we have the absolute latest
        const finalRefCheck = playSequenceActionsRef.current;
        if (finalRefCheck.length > currentActions.length) {
          currentActions = [...finalRefCheck];
        } else if (finalRefCheck.length === currentActions.length && finalRefCheck.length > 0) {
          const lastFinalRefAction = finalRefCheck[finalRefCheck.length - 1];
          const lastCurrentAction = currentActions[currentActions.length - 1];
          if (lastFinalRefAction && lastCurrentAction && lastFinalRefAction.timestamp > lastCurrentAction.timestamp) {
            currentActions = [...finalRefCheck];
          }
        }
        
        // Upload to Parse and clear local storage
        savePlaySequence(
          gameIdNumber,
          currentActions
        ).then(() => {
          // Clear local playSequence after successful upload
          clearPlaySequenceLocal(gameIdNumber);
          console.log("Play sequence uploaded to Parse and local storage cleared for idNumber:", gameIdNumber);
        }).catch((error) => {
          console.warn("Failed to save play sequence:", error);
          // Keep local storage if upload fails, so it can be retried later
        });
      }, 0);
    }

    return;
  }


}

// Ensure guessedWords also contains any words that have become fully visible via clicks
function syncGuessedWithVisibility(nextRevealed) {

  const newlySolved = [];
  for (const w of game.words) {
    if (isWordFullyVisible(w, game.placements, nextRevealed)) {
      newlySolved.push(w);
    }
  }
  if (newlySolved.length > 0) {
    setGuessedWords((prev) => Array.from(new Set([...prev, ...newlySolved])));
  }
}

// Save to local storage immediately (synchronous, instant)
function saveScoreLocally({ wordsFound, clicksRemaining }) {
  const isDailyPuzzle = !game?.creator;
  // Use game.idNumber instead of local idNumber to ensure we use the correct game ID
  const gameIdNumber = game?.idNumber ?? (isDailyPuzzle ? idNumber : scoreDictionary.idNumber);

  // Tutorial Check: Never update scores for tutorial game
  if (isTutorialGame(gameIdNumber)) {
    return getStoredScores();
  }

  const baseScoreData = {
    idNumber: gameIdNumber,
    clicksLeft: clicksRemaining,
    wordsFound,
  };

  let updatedScoreValues = {};
  try {
    if (isDailyPuzzle) {
      // Ensure gameIdNumber is valid before calling updateScores
      if (typeof gameIdNumber === "number" && Number.isFinite(gameIdNumber)) {
        updatedScoreValues = updateScores({
          idNumber: gameIdNumber,
          clicksLeft: clicksRemaining,
          wordsFound,
        });
      } else {
        console.warn("Invalid idNumber for score update:", gameIdNumber);
        // Fallback: get stored scores but preserve streak logic manually
        const stored = getStoredScores();
        const isWin = wordsFound >= 3;
        if (isWin && typeof stored.lastWonId === "number") {
          const diff = gameIdNumber - stored.lastWonId;
          if (diff === 1) {
            updatedScoreValues = {
              ...stored,
              streak: (stored.streak || 0) + 1,
              maxStreak: Math.max(stored.maxStreak || 0, (stored.streak || 0) + 1),
              lastWonId: gameIdNumber,
            };
          } else {
            updatedScoreValues = {
              ...stored,
              streak: diff === 0 ? stored.streak : 1,
              maxStreak: Math.max(stored.maxStreak || 0, diff === 0 ? stored.streak : 1),
              lastWonId: gameIdNumber,
            };
          }
        } else if (isWin) {
          updatedScoreValues = {
            ...stored,
            streak: 1,
            maxStreak: Math.max(stored.maxStreak || 0, 1),
            lastWonId: gameIdNumber,
          };
        } else {
          // Loss: reset streak but keep lastWonId unchanged
          updatedScoreValues = {
            ...stored,
            streak: 0,
            lastWonId: stored.lastWonId ?? null, // Explicitly preserve lastWonId
          };
        }
      }
    } else {
      updatedScoreValues = getStoredScores();
    }
  } catch (error) {
    console.warn("Score update failed", error);
    // On error, try to preserve streak if possible
    const stored = getStoredScores();
    const isWin = wordsFound >= 3;
    if (isDailyPuzzle && typeof idNumber === "number" && Number.isFinite(idNumber) && isWin) {
      // Try to update streak even on error
      const diff = typeof stored.lastWonId === "number" ? idNumber - stored.lastWonId : null;
      if (diff === 1) {
        updatedScoreValues = {
          ...stored,
          streak: (stored.streak || 0) + 1,
          maxStreak: Math.max(stored.maxStreak || 0, (stored.streak || 0) + 1),
          lastWonId: idNumber,
        };
      } else if (diff === null || diff > 1) {
        updatedScoreValues = {
          ...stored,
          streak: 1,
          maxStreak: Math.max(stored.maxStreak || 0, 1),
          lastWonId: idNumber,
        };
      } else {
        // Playing older puzzle or loss - preserve existing lastWonId
        updatedScoreValues = {
          ...stored,
          lastWonId: stored.lastWonId ?? null,
        };
      }
    } else {
      // Not a win or not daily puzzle - preserve existing lastWonId
      updatedScoreValues = {
        ...stored,
        lastWonId: stored.lastWonId ?? null,
      };
    }
  }

  // Ensure lastWonId is always included in nextScores
  // Get it from updatedScoreValues if available, otherwise from stored scores
  const storedForLastWonId = getStoredScores();
  const nextScores = {
    ...baseScoreData,
    ...updatedScoreValues,
    numbersPlayed:
      (updatedScoreValues?.numbersPlayed ??
        scoreDictionary.numbersPlayed ??
        0),
    lastWonId: updatedScoreValues?.lastWonId ?? storedForLastWonId?.lastWonId ?? null,
  };

  // Store old score before updating (for animation)
  if (nextScores.score !== scoreDictionary.score) {
    setOldScore(scoreDictionary.score ?? 0);
  }

  setScoreDictionary(nextScores);

  return {
    nextScores,
    monthlyIncrement: typeof updatedScoreValues?.pointsEarned === "number"
      ? updatedScoreValues.pointsEarned
      : 0,
  };
}

// Save to Parse in background (async, slow)
async function saveScoreToParse({ nextScores, monthlyIncrement, isWin = false }) {
  if (currentUser && !game?.creator) {
    // Tutorial Check: Never save scores to server for tutorial game
    const gameIdNumber = game?.idNumber;
    if (gameIdNumber !== undefined && isTutorialGame(gameIdNumber)) {
        return;
    }

    // CRITICAL: Check if game is already finished on another device before saving
    
    // Validate gameIdNumber
    if (typeof gameIdNumber !== "number" || !Number.isFinite(gameIdNumber)) {
      console.warn("[Sync] Invalid gameIdNumber, skipping check:", gameIdNumber);
      // Continue with save if gameIdNumber is invalid (might be custom game)
    } else {
      // Check if this game was already finished locally on THIS device
      // If so, we don't need to check the server (user is just reopening the app)
      const finishedLocal = typeof window !== "undefined" &&
        String(localStorage.getItem("finishedGameidNummer")) === String(gameIdNumber);
      
      // Only check server if game is NOT finished locally on this device
      // This prevents false positives when the user finishes a game and then reopens the app
      if (!finishedLocal) {
        const alreadyFinished = await checkIfGameAlreadyFinished(gameIdNumber);
        if (alreadyFinished) {
          // Game was already finished on another device - don't save score
          // BUT: Double-check by verifying the game ID matches the current game
          // This prevents false positives if there's any timing issue
          const currentGameId = game?.idNumber;
          if (currentGameId === gameIdNumber) {
            console.log("[Sync] ⚠️ Game already finished on another device, showing alert and skipping score save");
            
            const message = langString === "nl"
              ? "Deze WordHit is al gespeeld op een ander apparaat. Je score wordt niet opgeslagen."
              : "This WordHit was already played on another device. Your score will not be saved.";
            
            // Show alert popup - works on both web and iOS
            // In Capacitor iOS, alert() uses the native iOS alert dialog
            alert(message);
            
            console.log("[Sync] Score not saved - game already finished on another device");
            return; // Don't save the score
          } else {
            console.warn("[Sync] Game ID mismatch during check, allowing save:", {
              checkedId: gameIdNumber,
              currentGameId: currentGameId,
            });
            // Game ID doesn't match - might be a timing issue, allow save to proceed
          }
        }
      } else {
        console.log("[Sync] Game already finished locally on this device, skipping server check");
      }
    }
    
    try {
      // Only save lastWonId if it's a win (to update it)
      // On a loss, don't send lastWonId to avoid overwriting the existing server value with null
      const lastWonIdToSave = isWin ? (nextScores.lastWonId ?? null) : undefined;
      
      // Save lastScore for both win and loss
      // lastScore is the clicksLeft value (0-10) when the user wins, or 0 when the user loses
      const clicksLeft = nextScores.clicksLeft;
      let lastScoreToSave;
      if (isWin) {
        // Win: use actual clicksLeft if valid (0-10), otherwise undefined
        lastScoreToSave = typeof clicksLeft === "number" && Number.isFinite(clicksLeft) && clicksLeft >= 0 && clicksLeft <= 10
          ? clicksLeft
          : undefined;
      } else {
        // Loss: always save 0
        lastScoreToSave = 0;
      }
      
      // Always save lastPlayedId when a game is finished (win or loss)
      // Use the game's idNumber to track when the user last played
      const gameIdNumber = game?.idNumber;
      const lastPlayedIdToSave = (typeof gameIdNumber === "number" && Number.isFinite(gameIdNumber)) 
        ? gameIdNumber 
        : undefined;
      
      // Debug: log what we're saving
      console.log("saveScoreToParse - nextScores:", {
        score: nextScores.score,
        streak: nextScores.streak,
        lastWonId: lastWonIdToSave,
        lastScore: lastScoreToSave,
        lastPlayedId: lastPlayedIdToSave,
        isWin,
      });
      
      const saveData = {
        score: nextScores.score ?? 0,
        streak: nextScores.streak ?? 0,
        maxStreak: nextScores.maxStreak ?? 0,
        numbersPlayed: nextScores.numbersPlayed ?? 0,
        monthlyIncrement,
        lastWonId: lastWonIdToSave, // undefined on loss = don't update, number/null on win = update
        lastScore: lastScoreToSave, // number (0-10) on win, 0 on loss, undefined if invalid
        lastPlayedId: lastPlayedIdToSave, // always update when game is finished
        incrementPlayedCount: true, // Increment played count when finishing a game
      };
      
      await saveUserScores(saveData);
    } catch (error) {
      console.warn("Failed to save user scores, storing for retry:", error);
      // Store the save data locally to retry later when connection is restored
      const gameIdNumber = game?.idNumber;
      const lastPlayedIdToStore = (typeof gameIdNumber === "number" && Number.isFinite(gameIdNumber)) 
        ? gameIdNumber 
        : undefined;
      const clicksLeftToStore = nextScores.clicksLeft;
      let lastScoreToStore;
      if (isWin) {
        // Win: use actual clicksLeft if valid (0-10), otherwise undefined
        lastScoreToStore = typeof clicksLeftToStore === "number" && Number.isFinite(clicksLeftToStore) && clicksLeftToStore >= 0 && clicksLeftToStore <= 10
          ? clicksLeftToStore
          : undefined;
      } else {
        // Loss: always save 0
        lastScoreToStore = 0;
      }
      
      const saveDataToStore = {
        score: nextScores.score ?? 0,
        streak: nextScores.streak ?? 0,
        maxStreak: nextScores.maxStreak ?? 0,
        numbersPlayed: nextScores.numbersPlayed ?? 0,
        monthlyIncrement,
        lastWonId: isWin ? (nextScores.lastWonId ?? null) : undefined,
        lastScore: lastScoreToStore, // number (0-10) on win, 0 on loss, undefined if invalid
        lastPlayedId: lastPlayedIdToStore,
        incrementPlayedCount: true,
        timestamp: Date.now(),
      };
      storePendingSave(saveDataToStore);
    }
  }
}
  /*
    Click on a cell:
    - If already revealed -> no cost
    - Else:
      * If cell has a letter -> reveal that letter everywhere
      * If empty -> reveal just that one (red miss)
      * Spend 1 click
    - Then check win/lose
  */
 function clickCell(r, c) {
  // als popup nog open staat, niet klikken
  if (showWinPopup || showLosePopup) return;

  // als balloon open staat, niet klikken
  if (balloon.visible) return;

  // Tijdens grid-animaties geen nieuwe clicks toelaten
  if (isGridAnimating) return;

  if (hasWon || hasLost) {
    console.log("Game finished (no browser refreshed)");

    // Not first time - game was already finished, no animation
    setIsFirstTimeShowingResult(false);
    
    if (hasWon) {
      setShowWinPopup(true);
    }else{
      setShowLosePopup(true);
    }
    return;
  }

  //localStorage.removeItem("finishedGameidNummer"); //FOR TESTING PURPOSES ONLY

  // Use game.idNumber instead of local idNumber to ensure we check the correct game
  const gameIdNumber = game?.idNumber;
  const isCustomGame = Boolean(game?.creator);
  
  // For custom games, allow clicks even without idNumber
  // For regular games, idNumber is required to check if finished
  if (!isCustomGame && (gameIdNumber === undefined || gameIdNumber === null)) {
    // If game doesn't have idNumber, can't check if finished
    return;
  }

  const alreadyFinished =
    !game?.creator &&
    gameIdNumber !== undefined &&
    gameIdNumber !== null &&
    (String(localStorage.getItem("finishedGameidNummer")) === String(gameIdNumber) ||
      finishedIdNumbers.includes(gameIdNumber));

  if (alreadyFinished) {
    const fullyRevealed = revealEntireBoard(game.board);
    setRevealed(fullyRevealed);

    // Not first time - already finished game, no animation
    setIsFirstTimeShowingResult(false);
    
    const outcome = getStoredFinishedOutcomeValue(gameIdNumber);
    const wordsFound = getStoredFinishedWordsFound(gameIdNumber) ?? scoreDictionary.wordsFound ?? 0;
    setResultWordsFound(wordsFound);
    if (outcome === "lose") {
      setHasWon(false);
      setHasLost(true);
      setShowLosePopup(true);
    } else {
      setHasLost(false);
      setHasWon(true);
      setShowWinPopup(true);
    }
    
    // Restore clicksLeft from storage if available
    const storedClicksLeft = getStoredFinishedClicksLeft(gameIdNumber);
    if (storedClicksLeft !== null && typeof storedClicksLeft === "number") {
      setClicksLeft(storedClicksLeft);
    }
    
    return;
  }

  // Advanced tutorial: Check guided clicks
  // For tutorial 9999, only apply guided clicks after tooltip 1 is dismissed
  const shouldApplyGuidedClicks = game?.guidedClicks && Array.isArray(game.guidedClicks) && game.guidedClicks.length > 0 && (
    game.idNumber !== TUTORIAL_GAME_ID || 
    (!showTutorialTooltip1 && tutorialTooltip1Shown)
  );
  
  if (shouldApplyGuidedClicks) {
    // Parse current guided click (format: "r1c6" -> row 1, col 6)
    const currentGuidedClick = game.guidedClicks[currentGuidedClickIndex];
    console.log('[GuidedClicks] Click check:', {
      clicked: `r${r}c${c}`,
      currentGuidedClick,
      currentGuidedClickIndex,
      totalGuidedClicks: game.guidedClicks.length,
    });
    
    if (currentGuidedClick) {
      const match = currentGuidedClick.match(/^r(\d+)c(\d+)$/);
      if (match) {
        // guidedClicks uses 1-indexed format (like playSequence), convert to 0-indexed
        const guidedRow = parseInt(match[1], 10) - 1;
        const guidedCol = parseInt(match[2], 10) - 1;
        
        // Block clicks on non-guided cells
        if (r !== guidedRow || c !== guidedCol) {
          console.log('[GuidedClicks] Blocked click on non-guided cell');
          return;
        }
        
        console.log('[GuidedClicks] Correct guided cell clicked, advancing...');
        // Hand direct verbergen tijdens de flip-animatie
        setShowGuidedHand(false);
        // Duur van de flip-animatie voor deze klik (zelfde formule als bij setLocalRevealDelays)
        const letterAtCell = game.board[r][c];
        let flipCount = 0;
        if (letterAtCell && letterAtCell !== "") {
          for (let rr = 0; rr < GRID_SIZE; rr++) {
            for (let cc = 0; cc < GRID_SIZE; cc++) {
              if (game.board[rr][cc] === letterAtCell && !revealed[rr][cc]) flipCount++;
            }
          }
        }
        const BASE_DELAY_MS = 1100;
        const FLIP_DURATION_MS = 1100;
        const flipAnimationMs = flipCount > 0 ? (flipCount - 1) * BASE_DELAY_MS + FLIP_DURATION_MS : 0;

        // Volgende hand pas tonen na afloop van de flip-animatie (ref voorkomt dat het effect revealed→index meteen overschrijft)
        guidedAdvanceScheduledRef.current = true;
        if (currentGuidedClickIndex < game.guidedClicks.length - 1) {
          setTimeout(() => {
            guidedAdvanceScheduledRef.current = false;
            setCurrentGuidedClickIndex(currentGuidedClickIndex + 1);
          }, flipAnimationMs);
        } else {
          // All guided clicks completed, set index beyond array to hide hand
          console.log('[GuidedClicks] All guided clicks completed');
          setTimeout(() => {
            guidedAdvanceScheduledRef.current = false;
            setCurrentGuidedClickIndex(game.guidedClicks.length);
            setShowGuidedHand(false);

            // Show tooltip 2 na de flip-animatie wanneer alle guided clicks klaar zijn
            if (game && isTutorialGame(game.idNumber) && isFirstTimeTutorial && game.idNumber !== PRACTICE_GAME_ID_3) {
              setTimeout(() => {
                setShowTutorialTooltip2(true);
              }, 1000);
            }
          }, flipAnimationMs);
        }
      } else {
        console.warn('[GuidedClicks] Invalid format:', currentGuidedClick);
      }
    }
  }

  const already = revealed[r][c];
  const letter = game.board[r][c];

  // Track click for playSequences (track all clicks, even if already revealed)
  const clickTimestamp = Date.now();
  const newAction = { type: 'click', r, c, timestamp: clickTimestamp };
  setPlaySequenceActions(prev => {
    const updated = [...prev, newAction];
    playSequenceActionsRef.current = updated;
    // Save playSequence locally after each action
    if (gameIdNumber !== undefined && gameIdNumber !== null && !hasWon && !hasLost) {
      storePlaySequenceLocal(gameIdNumber, updated);
    }
    return updated;
  });

  // Track which words were visible before the click (for share result tracking)
  const wordsVisibleBefore = game.words.filter(word => 
    isWordFullyVisible(word, game.placements, revealed)
  );

  let newRev = revealed.map((row) => row.slice());
  let nextClicks = clicksLeft;

  if (already) {
    // setMessage("Dat vak had je al geklikt.");
    // Don't track share result for already revealed cells
  } else {
    if (letter && letter !== "") {
      newRev = revealAllOfLetter(letter, newRev, game.board);
    } else {
      newRev[r][c] = true;
    }
    nextClicks = clicksLeft - 1;

    // Flip/miss-animatie: delays voor net gerevealde cellen (alleen bij click)
    const beforeClick = revealed.map((row) => row.slice());
    if (letter && letter !== "") {
      const delays = Array.from({ length: GRID_SIZE }, () =>
        Array.from({ length: GRID_SIZE }, () => null)
      );
      let idx = 0;
      const BASE_LOCAL_DELAY_MS = 1100;

      // 1) Eerst: de daadwerkelijk aangeklikte cel (r, c), als die net nieuw zichtbaar is geworden.
      const clickedIsNewlyRevealed =
        newRev[r][c] && !beforeClick[r][c] && game.board[r][c] === letter;
      if (clickedIsNewlyRevealed) {
        delays[r][c] = 0;
        idx = 1;
      }

      // 2) Verzamel andere nieuwe instanties van dezelfde letter.
      const otherCells = [];
      for (let rr = 0; rr < GRID_SIZE; rr++) {
        for (let cc = 0; cc < GRID_SIZE; cc++) {
          if (rr === r && cc === c) continue;
          const isNewlyRevealed = newRev[rr][cc] && !beforeClick[rr][cc];
          if (isNewlyRevealed && game.board[rr][cc] === letter) {
            otherCells.push({ rr, cc });
          }
        }
      }
      // Woorden die nu volledig zichtbaar zijn (na deze klik)
      const placements = game.placements || [];
      const wordsNowVisible = (game.words || []).filter((w) =>
        isWordFullyVisible(w, placements, newRev)
      );
      const cellsInRevealedWords = new Set();
      for (const w of wordsNowVisible) {
        const cells = getWordCells(w, placements);
        for (const { r: cr, c: cc } of cells) {
          cellsInRevealedWords.add(`${cr},${cc}`);
        }
      }
      // Eerst: cellen die onderdeel zijn van een nu zichtbaar woord (scanvolgorde)
      const partOfRevealedWord = otherCells
        .filter(({ rr, cc }) => cellsInRevealedWords.has(`${rr},${cc}`))
        .sort((a, b) => (a.rr !== b.rr ? a.rr - b.rr : a.cc - b.cc));
      // Daarna: de rest (scanvolgorde)
      const partOfRevealedSet = new Set(partOfRevealedWord.map(({ rr, cc }) => `${rr},${cc}`));
      const rest = otherCells
        .filter(({ rr, cc }) => !partOfRevealedSet.has(`${rr},${cc}`))
        .sort((a, b) => (a.rr !== b.rr ? a.rr - b.rr : a.cc - b.cc));
      for (const { rr, cc } of [...partOfRevealedWord, ...rest]) {
        delays[rr][cc] = idx * BASE_LOCAL_DELAY_MS;
        idx += 1;
      }
      setLocalRevealDelays(idx > 0 ? delays : null);
      // Totale duur van deze klik-animatie (laatste letter-start + flipduur).
      if (idx > 0) {
        const FLIP_DURATION_MS = 1100;
        const totalMs = (idx - 1) * BASE_LOCAL_DELAY_MS + FLIP_DURATION_MS;
        startGridAnimation(totalMs);
      } else {
        startGridAnimation(0);
      }
    } else {
      const missDelays = Array.from({ length: GRID_SIZE }, () =>
        Array.from({ length: GRID_SIZE }, () => null)
      );
      missDelays[r][c] = 0;
      setLocalRevealDelays(missDelays);
      // Miss-animatie: enkel deze cel; grid hoeft niet gedeactiveerd te worden.
      startGridAnimation(0);
    }
    
    // Track share result action
    if (gameIdNumber !== undefined && gameIdNumber !== null && !hasWon && !hasLost) {
      // Check which words are visible after the click
      const wordsVisibleAfter = game.words.filter(word => 
        isWordFullyVisible(word, game.placements, newRev)
      );
      
      // Check if any new word was revealed
      const newWordsRevealed = wordsVisibleAfter.filter(word => !wordsVisibleBefore.includes(word));
      
      if (newWordsRevealed.length > 0) {
        // Entire word(s) got revealed by this click
        addShareResultAction(gameIdNumber, nextClicks, 'click-word');
      } else if (letter && letter !== "") {
        // Letter revealed but no complete word
        addShareResultAction(gameIdNumber, nextClicks, 'click-letter');
      } else {
        // Empty cell clicked (no letter)
        addShareResultAction(gameIdNumber, nextClicks, 'click-empty');
      }
    }
    // setMessage("");
  }

  // eerst direct state bijwerken
  setRevealed(newRev);
  setClicksLeft(nextClicks);
  syncGuessedWithVisibility(newRev);
  maybeShowNoClicksBalloon(nextClicks);
  
  // Track tutorial clicks for tooltip 2 (only during first-time tutorial)
  // If no guided clicks, show tooltip 2 after 2nd click
  // (If there are guided clicks, tooltip 2 is shown in the guided clicks completion handler above)
  // Don't show tooltips for 9997
  if (game && isTutorialGame(game.idNumber) && !already && isFirstTimeTutorial && game.idNumber !== PRACTICE_GAME_ID_3) {
    const hasGuidedClicks = game?.guidedClicks && Array.isArray(game.guidedClicks) && game.guidedClicks.length > 0;
    
    // Only count clicks for tooltip 2 if there are no guided clicks
    if (!hasGuidedClicks) {
      const newClickCount = tutorialClickCount + 1;
      setTutorialClickCount(newClickCount);
      if (newClickCount === 2) {
        // Show tooltip 2 after 1 second delay
        setTimeout(() => {
          setShowTutorialTooltip2(true);
        }, 1000);
      }
    }
  }

  // Save game state (only if game is not finished)
  if (gameIdNumber !== undefined && gameIdNumber !== null && !hasWon && !hasLost) {
    // Calculate guessedWords based on new revealed state
    const currentGuessedWords = game.words.filter(word => 
      isWordFullyVisible(word, game.placements, newRev)
    );
    storeGameState(gameIdNumber, {
      revealed: newRev,
      clicksLeft: nextClicks,
      guessedWords: currentGuessedWords,
      wrongGuessedWords: wrongGuessedWords,
    });
  }

  // check win/lose en eventueel alles onthullen
  evaluateEndConditions(newRev, nextClicks);
}

  /*
    submitGuess:
    - wrong word:
        * spend 1 click
    - correct word:
        * reveal entire word
        * give +1 click back
        * flash ✅+1 overlay
    - after updating state, also evaluate win/lose
  */

  function showUnknownWordFeedback() {
    if (guessFeedbackTimerRef.current) {
      window.clearTimeout(guessFeedbackTimerRef.current);
      guessFeedbackTimerRef.current = null;
    }
    setGuessFeedback(languageString.textUnknownWord || (langString === "nl" ? "Onbekend woord" : "Unknown word"));
    setGuessShake(true);
    window.setTimeout(() => setGuessShake(false), 400);
    guessFeedbackTimerRef.current = window.setTimeout(() => {
      setGuessFeedback("");
      guessFeedbackTimerRef.current = null;
    }, 2000);
  }

  function showMaxLengthFeedback() {
    if (guessFeedbackTimerRef.current) {
      window.clearTimeout(guessFeedbackTimerRef.current);
      guessFeedbackTimerRef.current = null;
    }
    setGuessFeedback(languageString.textMaxGuessLength || (langString === "nl" ? "Max. 7 letters" : "Max 7 letters"));
    setGuessShake(true);
    window.setTimeout(() => setGuessShake(false), 400);
    guessFeedbackTimerRef.current = window.setTimeout(() => {
      setGuessFeedback("");
      guessFeedbackTimerRef.current = null;
    }, 2000);
  }

  function handleGuessChange(e) {
    const next = e.target.value;
    if (next.length > MAX_GUESS_WORD_LENGTH) {
      showMaxLengthFeedback();
      setGuess(next.slice(0, MAX_GUESS_WORD_LENGTH));
      return;
    }
    setGuess(next);
  }

  async function submitGuess(e) {
    e.preventDefault();
    e.stopPropagation();
    if (showWinPopup || showLosePopup) return;
    if (hasWon || hasLost) return;
    // Buiten tutorial: tijdens grid-animatie geen guess. In tutorial: altijd guess toestaan (voorkomt vastlopen ref/animatie).
    const isTutorial = game && isTutorialGame(game.idNumber);
    if (!isTutorial && isGridAnimating) return;
    if (!guess.trim()) return;

    // Use game.idNumber for saving game state
    const gameIdNumber = game?.idNumber;

    const trimmedGuess = guess.trim();
    const guessUp = trimmedGuess.toUpperCase();

    if (trimmedGuess === "qazx") {
      if (isCheatRevealActive) {
        disableCheatMode();
      } else {
        enableCheatMode();
      }
      setGuess("");
      return;
    }

    if (visibleWords.includes(guessUp) || wrongGuessedWords.includes(guessUp)) {
      console.log("Word already guessed");
      return
    }

    const dictionaryGuessEnabled =
      !isTutorialGame(gameIdNumber) &&
      isDictionaryGuessEnabled(gameIdNumber, {
        custom: Boolean(game?.creator),
      });

    const isOnGrid = game.words.includes(guessUp);

    if (dictionaryGuessEnabled && !isOnGrid) {
      let dictionaryReady = isDictionaryReady(langString);
      try {
        await ensureDictionaryLoaded(langString);
        dictionaryReady = isDictionaryReady(langString);
      } catch (error) {
        console.warn("Failed to load word dictionary", error);
      }
      if (dictionaryReady && !isValidWord(guessUp, langString)) {
        showUnknownWordFeedback();
        return;
      }
    }
    const revealsLetters =
      dictionaryGuessEnabled &&
      isDictionaryReady(langString) &&
      !isOnGrid &&
      isValidWord(guessUp, langString);

    // Track guess for playSequences
    const guessTimestamp = Date.now();
    const newAction = {
      type: 'guess',
      word: guessUp,
      timestamp: guessTimestamp,
      correct: isOnGrid,
      revealsLetters,
    };
    setPlaySequenceActions(prev => {
      const updated = [...prev, newAction];
      playSequenceActionsRef.current = updated;
      // Save playSequence locally after each action
      if (gameIdNumber !== undefined && gameIdNumber !== null && !hasWon && !hasLost) {
        storePlaySequenceLocal(gameIdNumber, updated);
      }
      return updated;
    });

    let newRev = revealed.map((row) => row.slice());
    const beforeGuess = revealed.map((row) => row.slice());
    let nextClicks = clicksLeft;

    // Track which words were visible before the guess (for share result tracking)
    const wordsVisibleBefore = game.words.filter(word => 
      isWordFullyVisible(word, game.placements, revealed)
    );

    if (!isOnGrid) {
      setWrongGuessedWords((prev) => {
        if (prev.includes(guessUp)) return prev;
        return [...prev, guessUp];
      });

      if (revealsLetters) {
        for (let i = 0; i < guessUp.length; i++) {
          const letter = guessUp[i];
          newRev = revealAllOfLetter(letter, newRev, game.board);
        }

        const delays = Array.from({ length: GRID_SIZE }, () =>
          Array.from({ length: GRID_SIZE }, () => null)
        );
        let idx = 0;
        const BASE_LOCAL_DELAY_MS = 1100;
        for (let rr = 0; rr < GRID_SIZE; rr++) {
          for (let cc = 0; cc < GRID_SIZE; cc++) {
            if (newRev[rr][cc] && !beforeGuess[rr][cc]) {
              delays[rr][cc] = idx * BASE_LOCAL_DELAY_MS;
              idx += 1;
            }
          }
        }
        const FLIP_DURATION_MS = 1100;
        const totalMs = idx > 0 ? (idx - 1) * BASE_LOCAL_DELAY_MS + FLIP_DURATION_MS : 0;
        if (idx > 0) {
          setLocalRevealDelays(delays);
          if (guessFlipEndTimerRef.current) window.clearTimeout(guessFlipEndTimerRef.current);
          guessFlipEndTimerRef.current = window.setTimeout(() => {
            setLocalRevealDelays(null);
            guessFlipEndTimerRef.current = null;
          }, totalMs);
        }
        startGridAnimation(totalMs);
      } else {
        startGridAnimation(0);
      }

      const wordsVisibleAfter = game.words.filter((word) =>
        isWordFullyVisible(word, game.placements, newRev)
      );
      const newWordsRevealed = wordsVisibleAfter.filter((word) => !wordsVisibleBefore.includes(word));
      const completedBoardWord = newWordsRevealed.length > 0;

      const overlayDelay = Math.max(0, gridAnimationDelayRef.current || 0);
      const OVERLAY_DURATION_MS = 1800;

      if (completedBoardWord) {
        const clicksToAdd = rewardForGuess(newWordsRevealed.length, false);
        nextClicks = clicksLeft + clicksToAdd;
        setClicksToShow(clicksToAdd);
        if (gameIdNumber !== undefined && gameIdNumber !== null && !hasWon && !hasLost) {
          addShareResultAction(gameIdNumber, nextClicks, 'word-revealed');
          if (newWordsRevealed.length > 1) {
            addShareResultAction(gameIdNumber, nextClicks, 'word-revealed');
          }
        }
        setTimeout(() => {
          setShowCheckOverlay(true);
          setTimeout(() => {
            setShowCheckOverlay(false);
          }, OVERLAY_DURATION_MS);
        }, overlayDelay);
      } else {
        nextClicks = clicksLeft - 1;
        if (gameIdNumber !== undefined && gameIdNumber !== null && !hasWon && !hasLost) {
          addShareResultAction(gameIdNumber, nextClicks, 'guess-wrong');
        }
        setTimeout(() => {
          setShowCrossOverlay(true);
          setTimeout(() => {
            setShowCrossOverlay(false);
          }, OVERLAY_DURATION_MS);
        }, overlayDelay);
      }

    } else {
      setGuessedWords(prev => [...prev, guessUp]);
      // good answer, show entire word
      newRev = revealWord(guessUp, game.placements, newRev);
      
      // Also reveal all other occurrences of each letter in the guessed word
      // (same behavior as clicking on a letter)
      for (let i = 0; i < guessUp.length; i++) {
        const letter = guessUp[i];
        newRev = revealAllOfLetter(letter, newRev, game.board);
      }

      // Per-letter flip bij correcte guess: eerst letters van het geraden woord, daarna overige nieuw zichtbare letters.
      if (game?.placements) {
        const delays = Array.from({ length: GRID_SIZE }, () =>
          Array.from({ length: GRID_SIZE }, () => null)
        );
        let idx = 0;
        const BASE_LOCAL_DELAY_MS = 1100;
        const placements = game.placements || [];
        const wordCells = getWordCells(guessUp, placements);
        const wordCellsSet = new Set(wordCells.map(({ r, c }) => `${r},${c}`));
        // 1) Eerst: letters van het geraden woord (woordvolgorde)
        let wordRevealCount = 0;
        for (const { r, c } of wordCells) {
          const isNewlyRevealed = newRev[r][c] && !beforeGuess[r][c];
          if (isNewlyRevealed) {
            delays[r][c] = idx * BASE_LOCAL_DELAY_MS;
            idx += 1;
            wordRevealCount += 1;
          }
        }
        // 2) Overige nieuw zichtbare cellen (door revealAllOfLetter): eerst deel van een revealed woord, daarna rest (scan)
        const otherCells = [];
        for (let rr = 0; rr < GRID_SIZE; rr++) {
          for (let cc = 0; cc < GRID_SIZE; cc++) {
            if (wordCellsSet.has(`${rr},${cc}`)) continue;
            const isNewlyRevealed = newRev[rr][cc] && !beforeGuess[rr][cc];
            if (isNewlyRevealed) otherCells.push({ rr, cc });
          }
        }
        const wordsNowVisible = (game.words || []).filter((w) =>
          isWordFullyVisible(w, placements, newRev)
        );
        const cellsInRevealedWords = new Set();
        for (const w of wordsNowVisible) {
          const cells = getWordCells(w, placements);
          for (const { r: cr, c: cc } of cells) {
            cellsInRevealedWords.add(`${cr},${cc}`);
          }
        }
        const partOfRevealedWord = otherCells
          .filter(({ rr, cc }) => cellsInRevealedWords.has(`${rr},${cc}`))
          .sort((a, b) => (a.rr !== b.rr ? a.rr - b.rr : a.cc - b.cc));
        const partOfRevealedSet = new Set(partOfRevealedWord.map(({ rr, cc }) => `${rr},${cc}`));
        const rest = otherCells
          .filter(({ rr, cc }) => !partOfRevealedSet.has(`${rr},${cc}`))
          .sort((a, b) => (a.rr !== b.rr ? a.rr - b.rr : a.cc - b.cc));
        for (const { rr, cc } of [...partOfRevealedWord, ...rest]) {
          delays[rr][cc] = idx * BASE_LOCAL_DELAY_MS;
          idx += 1;
        }
        setLocalRevealDelays(idx > 0 ? delays : null);

        // Tijdens deze sequentiële flips moet het hele woord blauw blijven;
        // zodra alle letters van het geraden woord geflipt zijn gaat dat woord op groen;
        // daarna flippen eventuele bonusletters; aan het eind delays opruimen.
        const FLIP_DURATION_MS = 1100;
        const totalMs = idx > 0 ? (idx - 1) * BASE_LOCAL_DELAY_MS + FLIP_DURATION_MS : 0;
        const wordGreenMs = wordRevealCount > 0
          ? (wordRevealCount - 1) * BASE_LOCAL_DELAY_MS + FLIP_DURATION_MS
          : 0;
        // Bewaar totale duur van de woord-flip-animatie en markeer grid als animerend.
        startGridAnimation(totalMs);
        const timers = pendingSolvedWordTimersRef.current;
        if (timers[guessUp]) window.clearTimeout(timers[guessUp]);
        setPendingSolvedWords((prev) => (prev.includes(guessUp) ? prev : [...prev, guessUp]));
        // Woord direct groen zodra alle letters van dat woord geflipt zijn (niet wachten op bonusletters)
        timers[guessUp] = window.setTimeout(() => {
          setPendingSolvedWords((prev) => prev.filter((w) => w !== guessUp));
          timers[guessUp] = null;
        }, wordGreenMs);
        // Aan het eind van alle flips (incl. bonusletters): delays opruimen
        if (guessFlipEndTimerRef.current) window.clearTimeout(guessFlipEndTimerRef.current);
        guessFlipEndTimerRef.current = window.setTimeout(() => {
          setLocalRevealDelays(null);
          setPendingSolvedWords((prev) => prev.filter((w) => w !== guessUp));
          guessFlipEndTimerRef.current = null;
        }, totalMs);
      }

      // Check if any additional words were revealed by revealing the guessed word
      const wordsVisibleAfter = game.words.filter(word => 
        isWordFullyVisible(word, game.placements, newRev)
      );
      const newWordsRevealed = wordsVisibleAfter.filter(word => !wordsVisibleBefore.includes(word));
      
      // 1 click for one completed board word, 2 when a second word is completed too
      const clicksToAdd = rewardForGuess(newWordsRevealed.length, true);
      nextClicks = clicksLeft + clicksToAdd;

      // Track share result action for correct guess
      if (gameIdNumber !== undefined && gameIdNumber !== null && !hasWon && !hasLost) {
        addShareResultAction(gameIdNumber, nextClicks, 'guess-correct');
        
        // If more than just the guessed word was revealed, track the additional word(s)
        if (newWordsRevealed.length > 1 || (newWordsRevealed.length === 1 && newWordsRevealed[0] !== guessUp)) {
          addShareResultAction(gameIdNumber, nextClicks, 'word-revealed');
        }
      }

      // Show overlay with the correct number of clicks,
      // maar pas nadat de woord-flip-animatie volledig klaar is.
      setClicksToShow(clicksToAdd);
      const overlayDelay = Math.max(0, gridAnimationDelayRef.current || 0);
      const OVERLAY_DURATION_MS = 1800;
      setTimeout(() => {
        setShowCheckOverlay(true);
        setTimeout(() => {
          setShowCheckOverlay(false);
        }, OVERLAY_DURATION_MS);
      }, overlayDelay);

    }
    console.log("guessedWords", guessedWords);
    setGuess("");
    scrollGameViewToTopAfterGuess();
    setRevealed(newRev);
    // clicksLeft bijwerken na de flip-animatie (zelfde moment als de overlay)
    const clicksUpdateDelay = Math.max(0, gridAnimationDelayRef.current || 0);
    setTimeout(() => {
      setClicksLeft(nextClicks);
    }, clicksUpdateDelay);
    syncGuessedWithVisibility(newRev);
    maybeShowNoClicksBalloon(nextClicks);

    // Save game state (only if game is not finished)
    if (gameIdNumber !== undefined && gameIdNumber !== null && !hasWon && !hasLost) {
      // Calculate guessedWords based on new revealed state
      const currentGuessedWords = game.words.filter(word => 
        isWordFullyVisible(word, game.placements, newRev)
      );
      // Calculate updated wrongGuessedWords (add new wrong guess if applicable)
      const updatedWrongGuessedWords = !isOnGrid && !wrongGuessedWords.includes(guessUp)
        ? [...wrongGuessedWords, guessUp]
        : wrongGuessedWords;
      storeGameState(gameIdNumber, {
        revealed: newRev,
        clicksLeft: nextClicks,
        guessedWords: currentGuessedWords,
        wrongGuessedWords: updatedWrongGuessedWords,
      });
    }

    // check win/lose after guessing
    evaluateEndConditions(newRev, nextClicks);
  }

  /*
    Count how many letters are in each row / column (for the hints at right/bottom)
  */
  const rowCounts = game.board.map(
    (row) => row.filter((cell) => cell !== "").length
  );

  const colCounts = Array.from({ length: GRID_SIZE }, (_, c) => {
    let count = 0;
    for (let r = 0; r < GRID_SIZE; r++) {
      if (game.board[r][c] !== "") count++;
    }
    return count;
  });

  /*
    Render each cell with correct color class:
    - not revealed -> cell-hidden (yellow)
    - revealed && empty -> cell-miss (red) [unless board is fully revealed, then cell-hidden]
    - revealed && letter:
        * if that letter belongs to a word that is fully visible -> cell-solved (green)
        * else -> cell-revealed (blue)
  */
  function getCellClass(r, c) {
    const vis = revealed[r][c];
    const letter = game.board[r][c];

    if (!vis) {
      if (isHintActive && letter) {
        return "cell cell-hidden cell-hint";
      }
      return "cell cell-hidden";
    }

    // Check if entire board is revealed (game finished)
    const isBoardFullyRevealed = revealed.every(row => row.every(cell => cell === true));

    if (!letter) {
      // If board is fully revealed, hide empty cells instead of showing them as red
      if (isBoardFullyRevealed) {
        return "cell cell-hidden";
      }
      return "cell cell-miss";
    }

  let solved = isCellInFullyVisibleWord(r, c, game.placements, revealed);
  if (solved && pendingSolvedWords && pendingSolvedWords.length > 0) {
    const wordsHere = getWordsForCell(r, c, game.placements);
    const solvedWordsHere = wordsHere.filter((w) =>
      isWordFullyVisible(w, game.placements, revealed)
    );
    const hasSolvedNonPendingWord = solvedWordsHere.some(
      (w) => !pendingSolvedWords.includes(w)
    );
    // Alleen cellen die alléén door een "pending" woord solved zijn, blijven blauw;
    // cellen die al groen waren door een ander (niet-pending) woord blijven groen.
    if (!hasSolvedNonPendingWord) {
      solved = false;
    }
  }
    if (solved) {

      return "cell cell-solved";
    }

    return "cell cell-revealed";
  }

  /* SHARE SCORE */

const shareScore = async () => {
  console.log("share_score_clicked");

  const clicks = Math.max(0, clicksLeft || 0);
  const theme = game?.theme ?? "WordHit";
  const gameIdNumber = game?.idNumber;

  // Get the share result actions array
  const shareActions = gameIdNumber !== undefined && gameIdNumber !== null
    ? getShareResultActions(gameIdNumber)
    : [];

  // Format the actions array into a string (all emojis without spaces)
  const actionsText = shareActions.length > 0
    ? shareActions.join('')
    : '';

  // Format: WordHit - {thema}
  //         {emojis zonder spaties}
  //         {clicks} kliks over
  const header = `WordHit - ${theme}`;
  const clicksText = langString === "nl"
    ? `${clicks} klik${clicks === 1 ? "" : "s"} over`
    : `${clicks} click${clicks === 1 ? "" : "s"} left`;
  
  const text = actionsText.length > 0
    ? `${header}\n${actionsText}\n${clicksText}`
    : `${header}\n${clicksText}`;
  //  const url = window.location.href;

  try {
    // Use platform-specific share implementation
    // Set event name globally so TO JS listener knows which event to track
    if (typeof window !== 'undefined') {
      window.__currentShareEventName = "share_score_clicked";
      window.__shareAmplitudeLogged = false;
    }
    
    const shareOptions = {
      title: "WordHit",
      text: text,
      dialogTitle: langString === "nl" ? "Deel je score" : "Share your score",
      amplitudeEventName: "share_score_clicked", // Tell native code which event to track
    };
    
    // Add iOS-specific excludedActivityTypes
    if (isIOS()) {
      shareOptions.excludedActivityTypes = [
        ActivityTypes.PRINT,
        ActivityTypes.ASSIGN_TO_CONTACT,
        ActivityTypes.ADD_TO_READING_LIST,
        ActivityTypes.OPEN_IN_IBOOKS,
        ActivityTypes.MARKUP_AS_PDF,
      ];
    }
    
    const shareResult = await platformShare(shareOptions);
    
    // Debug: log the full shareResult to see what we're getting
    console.log("[Share Score] Full shareResult:", JSON.stringify(shareResult));
    console.log("[Share Score] shareResult.activityType:", shareResult?.activityType);
    console.log("[Share Score] typeof shareResult.activityType:", typeof shareResult?.activityType);
    
    // Check if activityType might come later via global variable (workaround for bridge timing issue)
    let finalActivityType = shareResult?.activityType;
    if (!finalActivityType && typeof window !== 'undefined' && window.__lastShareActivityType) {
      finalActivityType = window.__lastShareActivityType;
      console.log("[Share Score] ⚠️ Using activityType from global variable (late arrival):", finalActivityType);
      // Update shareResult for consistency
      if (shareResult) {
        shareResult.activityType = finalActivityType;
      }
    }
    
    // Track share event with platform information
    let sharePlatform = 'unknown';
    
    // If activityType exists, we're definitely on iOS (only iOS CustomShare plugin returns it)
    // Use activityType as the primary indicator, then fall back to platform detection
    const hasActivityType = finalActivityType && 
      (typeof finalActivityType === 'string' ? finalActivityType.trim() !== "" : finalActivityType);
    
    if (hasActivityType) {
      // We're on iOS and have activityType - map it to platform
      const activityTypeStr = String(finalActivityType);
      sharePlatform = mapActivityTypeToPlatform(activityTypeStr);
      console.log("[Share Score] Detected iOS via activityType:", activityTypeStr, "-> platform:", sharePlatform);
    } else if (isIOS()) {
      // iOS but no activityType (fallback to Capacitor Share or cancelled)
      sharePlatform = 'ios_share';
      console.log("[Share Score] iOS detected but no activityType, using ios_share");
    } else if (isAndroid()) {
      // Android doesn't provide which app was selected
      sharePlatform = 'android_share';
    } else {
      // Web or other platforms
      sharePlatform = 'web_share';
    }
    
    // Check if Amplitude was already logged by native code or share.js
    // This prevents double logging
    const alreadyLogged = shareResult?.__amplitudeLogged || 
                         (typeof window !== 'undefined' && window.__shareAmplitudeLogged);
    
    if (alreadyLogged) {
      console.log("[Share Score] ⏭️ Skipping Amplitude log (already logged by native/share.js)");
    } else {
      // Log to Amplitude with platform information
      const eventData = {
        platform: sharePlatform,
      };
      // Only include activityType if it exists and is not empty (iOS with CustomShare plugin only)
      if (hasActivityType) {
        const activityTypeStr = String(finalActivityType);
        eventData.activityType = activityTypeStr;
        console.log("[Share Score] Tracking with activityType:", activityTypeStr);
      } else {
        console.log("[Share Score] No activityType available (platform:", sharePlatform + ")");
      }
      amplitude.track("share_score_clicked", eventData);
    }
    
    // Optionally copy to clipboard after successful share (silently)
    try {
      await navigator.clipboard.writeText(`${text}`);
    } catch (clipboardError) {
      // Ignore clipboard errors - share was successful
    }
    return; // Success, exit early
  } catch (shareError) {
    // If share fails (user cancelled, etc.), fallback to clipboard
    // Note: AbortError means user cancelled, which is fine
    if (shareError.name === 'AbortError' || shareError.message?.includes('cancel')) {
      // User cancelled, track cancellation but don't show error
      amplitude.track("share_score_clicked", {
        platform: 'cancelled',
      });
      return;
    }
    
    // Fallback: copy to clipboard
    try {
      await navigator.clipboard.writeText(`${text}`);
      const string = langString === "nl"
        ? "Deze tekst is gekopieerd naar je klembord, je kunt hem nu delen!" + text
        : "This text has been copied to your clipboard, you can now share it!" + text;
      alert(string);
      
      // Track clipboard fallback
      amplitude.track("share_score_clicked", {
        platform: 'clipboard_fallback',
      });
    } catch (clipboardError) {
      // Both share and clipboard failed
      console.warn("Share and clipboard both failed", shareError, clipboardError);
      
      // Track failure
      amplitude.track("share_score_clicked", {
        platform: 'failed',
      });
    }
  }
};

function showBalloonOrDelay(type, text, willOpenAuthModal = false) {
  // If auth modal will be opened, delay the balloon
  if (willOpenAuthModal) {
    pendingBalloonRef.current = { type, text };
    return;
  }
  // Otherwise show immediately
  showBalloon(type, text);
}

function showBalloon(type, text) {
  if (localStorage.getItem("hasSeenBalloonExplanation") && type === "tomorrow") {
    return;
  }
  requestAnimationFrame(() => {
    let anchor;
    if (type === "tomorrow") {
      // Try to find countdown timer first (more specific), fallback to widget-header
      anchor = document.querySelector(".countdown-timer") || document.querySelector(".widget-header");
    } else if (type === "battleInvite") {
      anchor = document.querySelector(".battle-mode-button");
    } else {
      anchor = document.querySelector(".game-logo");
    }

    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let tip = "up";

    if (anchor) {
      const r = anchor.getBoundingClientRect();
      if (type === "battleInvite") {
        // Place balloon to the right of the battle button, arrow pointing left
        x = r.right + 18;
        y = r.top + r.height / 2;
        tip = "left";
      } else {
        x = r.left + r.width / 2;
        y = r.bottom + 0;
      }
    }

    setBalloon({ visible: true, x, y, text, tip, closeable: false, type });
    localStorage.setItem("hasSeenBalloonExplanation", "true");

    function handleClick() {
      closeBalloon();
      document.removeEventListener("click", handleClick);
    }

    document.addEventListener("click", handleClick, { once: true });
  });
}

function showBalloonAt(selector, text) {
  requestAnimationFrame(() => {
    const anchor = document.querySelector(selector);
    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    if (anchor) {
      const r = anchor.getBoundingClientRect();
      x = r.left + r.width / 2;
      // Place the balloon so its bottom (incl. arrow) net iets boven de button hangt
      y = r.top - 12;
    }
    setBalloon({ visible: true, x, y, text, tip: "down", closeable: false, type: "hint" });
    function handleClick() {
      closeBalloon();
      document.removeEventListener("click", handleClick);
    }
    document.addEventListener("click", handleClick, { once: true });
  });
}

function showCenteredBalloon(text) {
  requestAnimationFrame(() => {
    const x = window.innerWidth / 2;
    const viewportHeight = window.innerHeight || 800;
    const y = Math.max(viewportHeight * 0.25, 100);
    setBalloon({ visible: true, x, y, text, tip: "none", closeable: true, type: "centered" });
    function handleClick(e) {
      const balloonElement = document.querySelector('.widget-balloon');
      
      // Check if click is on the balloon itself - if so, let the balloon's own onClick handle it
      if (balloonElement && balloonElement.contains(e.target)) {
        // Don't close here, let the balloon's onClick handler close it
        // But stop propagation to prevent the result modal from closing
        e.stopPropagation();
        // Remove listener since balloon will close via its own onClick
        document.removeEventListener("click", handleClick, { capture: true });
        return;
      }
      
      // Click is outside the balloon
      // Stop propagation to prevent closing the result modal
      e.stopPropagation();
      
      // Only close if balloon is still visible
      if (balloonElement) {
        closeBalloon();
      }
      
      // Remove listener after handling
      document.removeEventListener("click", handleClick, { capture: true });
    }
    // Use capture phase to catch the event before it reaches the result modal overlay
    document.addEventListener("click", handleClick, { capture: true });
  });
}

// Show the no-clicks-left hint at most twice lifetime (persisted)
function maybeShowNoClicksBalloon(nextClicks) {
  if (nextClicks !== 0 || shownNoClicksBalloon || hasWon || hasLost) return;
  // Only show for tutorial games (9999, 9998, 9997)
  if (!game || !isTutorialGame(game.idNumber)) return;
  try {
    const key = "noClicksGuessTipCount";
    const current = parseInt(localStorage.getItem(key) || "0", 10) || 0;
    if (current >= 2) return;
    const text = langString === "nl"
      ? "Geen kliks meer, maar je kunt wel nog raden."
      : "No clicks left, but you can still guess.";
    // Point to guess input field (same as Tooltip 2 "weet je een woord")
    const anchorRef = guessInputRef.current ?? guessFormRowRef.current;
    requestAnimationFrame(() => {
      if (anchorRef) {
        const r = anchorRef.getBoundingClientRect();
        const x = r.left + r.width / 2;
        const y = r.top - 10;
        setBalloon({ visible: true, x, y, text, tip: "down", closeable: false, type: "hint" });
        function handleClick() {
          closeBalloon();
          document.removeEventListener("click", handleClick);
        }
        document.addEventListener("click", handleClick, { once: true });
      } else {
        showBalloonAt('.guess-input', text);
      }
    });
    localStorage.setItem(key, String(current + 1));
    setShownNoClicksBalloon(true);
  } catch (_) {
    // Fallback without persistence if localStorage fails
    const text = langString === "nl"
      ? "Geen kliks meer, maar je kunt wel nog raden."
      : "No clicks left, but you can still guess.";
    const anchorRef = guessInputRef.current ?? guessFormRowRef.current;
    requestAnimationFrame(() => {
      if (anchorRef) {
        const r = anchorRef.getBoundingClientRect();
        const x = r.left + r.width / 2;
        const y = r.top - 10;
        setBalloon({ visible: true, x, y, text, tip: "down", closeable: false, type: "hint" });
        function handleClick() {
          closeBalloon();
          document.removeEventListener("click", handleClick);
        }
        document.addEventListener("click", handleClick, { once: true });
      } else {
        showBalloonAt('.guess-input', text);
      }
    });
    setShownNoClicksBalloon(true);
  }
}

// A cell is considered solved (green) only if it belongs to a word the player guessed
function isCellInGuessedWord(r, c, placements, guessedWords) {
  for (const p of placements) {
    if (!guessedWords.includes(p.word)) continue;
    for (let i = 0; i < p.word.length; i++) {
      let rr = p.r;
      let cc = p.c;
      if (p.dir === "H") {
        cc = p.c + i;
      } else if (p.dir === "V") {
        rr = p.r + i;
      } else if (p.dir === "DR") {
        rr = p.r + i; cc = p.c + i;
      } else if (p.dir === "DL") {
        rr = p.r + i; cc = p.c - i;
      } else if (p.dir === "UR") {
        rr = p.r - i; cc = p.c + i;
      } else if (p.dir === "UL") {
        rr = p.r - i; cc = p.c - i;
      }
      if (rr === r && cc === c) return true;
    }
  }
  return false;
}


  /*
    resetGame(): rebuild today's puzzle fresh and reset everything
  */
  // async function resetGame() {
  //   try {
  //     const built = await buildGameForToday();
  //     setGame(built);
  //     setRevealed(
  //       Array.from({ length: GRID_SIZE }, () =>
  //         Array.from({ length: GRID_SIZE }, () => false)
  //       )
  //     );
  //     setClicksLeft(MAX_CLICKS);
  //     setGuess("");
  //     setMessage("");
  //     setShowRules(false);
  //     setShowCheckOverlay(false);
  //     setShowWinPopup(false);
  //     setShowLosePopup(false);
  //     setErrorText("");
  //   } catch (err) {
  //     console.error("Fatal reload error:", err);
  //     setErrorText("Kon spel niet herladen.");
  //   }
  // }

  // clicksLeft label color (red if <3) — gebruik displayClicksLeft zodat kleur bij getoonde waarde hoort
  const clicksNumberClass =
    displayClicksLeft < 3
      ? `clicks-counter-number low${animateClicks ? ` animate animate--${animateClicksDirection}` : ""}`
      : `clicks-counter-number${animateClicks ? ` animate animate--${animateClicksDirection}` : ""}`;

  const isCustomGame = Boolean(game.creator);
  const headerLogo = isCustomGame ? mainLogo : hasLost || hasWon ? nextLogo : mainLogo;
  const headerSubtitle = isCustomGame
    ? (langString === "nl" ? "Maker: " + game.creator : "Creator: " + game.creator) || WidgetHeaderDate()
    : hasLost || hasWon
    ? countDownTimer
    : WidgetHeaderDate();

  const closeFaqModal = () => {
    setShowFaqModal(false);
    setOpenFaqIndex(null);
    // Don't reopen menu modal - close everything when subpage closes
    setShowMenuModal(false);
  };

  const closeAboutModal = () => {
    setShowAboutModal(false);
    // Don't reopen menu modal - close everything when subpage closes
    setShowMenuModal(false);
  };

  const toggleFaqItem = (index) => {
    setOpenFaqIndex((prev) => (prev === index ? null : index));
  };

const closeBalloon = () => {
  // Chain: after dismissing the "tomorrow" balloon (first normal WordHit),
  // show a battle invite balloon anchored to the battle button.
  try {
    if (
      balloon?.visible &&
      balloon?.type === "tomorrow" &&
      !localStorage.getItem("hasSeenBattleInviteBalloon") &&
      isBattleModeAvailableOnPlatform() &&
      document.querySelector(".battle-mode-button")
    ) {
      localStorage.setItem("hasSeenBattleInviteBalloon", "true");
      setTimeout(() => {
        showBalloon(
          "battleInvite",
          langString === "nl"
            ? "Meer spelen?\n\nStart een 1 op 1 battle tegen een vriend of willekeurige speler."
            : "Want to play more?\n\nStart a 1-on-1 battle against a friend or random opponent."
        );
      }, 220);
    }
  } catch (_) {}
  setBalloon((b) => ({ ...b, visible: false }));
};

  const URL_REGEX = /(https?:\/\/[^\s]+)/g;

  const renderTextWithLinks = (text) => {
    if (!text) return null;
    const parts = text.split(URL_REGEX);
    return parts.map((part, idx) => {
      if (idx % 2 === 1) {
        return (
          <a key={`link-${idx}-${part}`} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return <React.Fragment key={`text-${idx}`}>{part}</React.Fragment>;
    });
  };

  const renderScoreExplanation = (text) => {
    if (!text) return null;
    // Split text by lines (double newline = paragraph break)
    const paragraphs = text.split(/\n\n+/);
    return paragraphs.map((paragraph, pIdx) => {
      // Split each paragraph by single newline to handle line breaks
      const lines = paragraph.split(/\n/);
      return (
        <div key={`para-${pIdx}`} className="balloon-paragraph">
          {lines.map((line, lIdx) => {
            // Match labels like "Score:", "Gespeeld:", "Played:", etc.
            const labelMatch = line.match(/^([^:]+):\s*(.*)$/);
            if (labelMatch) {
              const [, label, explanation] = labelMatch;
              // Capitalize first letter of explanation
              const capitalizedExplanation = explanation.charAt(0).toUpperCase() + explanation.slice(1);
              return (
                <div key={`line-${pIdx}-${lIdx}`} className="balloon-item">
                  <div className="balloon-label">{label}</div>
                  <div className="balloon-explanation">{capitalizedExplanation}</div>
                </div>
              );
            }
            // If no label match, render as regular text
            return (
              <div key={`line-${pIdx}-${lIdx}`} className="balloon-line">
                {line}
              </div>
            );
          })}
        </div>
      );
    });
  };

  const renderFaqAnswer = (text) => {
    if (!text) return null;
    return text.split(/\n+/).map((line, idx) => (
      <p key={idx}>{renderTextWithLinks(line)}</p>
    ));
  };

  const scoreLabels =
    langString === "nl"
      ? {
          title: "Jouw totaalscore",
          info: "Informatie over score, gespeeld, reeks en max reeks",
          score: "score",
          played: "gespeeld",
          streak: "reeks",
          maxStreak: "max reeks",
          infoText: `Score: je krijgt 1 punt voor elke klik die je overhoudt.\n\nGespeeld: het aantal dagelijkse WordHits dat je hebt gespeeld.\n\nReeks: het aantal opeenvolgende dagen waarop je hebt gewonnen.\n\nMax reeks: de hoogste reeks die je ooit hebt behaald.`,
        }
      : {
          title: "Your total score",
          info: "About score, played, streak and max streak",
          score: "score",
          played: "played",
          streak: "streak",
          maxStreak: "max streak",
          infoText: `Score: you receive 1 point for every click you have left.\n\nPlayed: how many daily WordHits you have completed.\n\nStreak: the number of consecutive days on which you’ve won.\n\nMax streak: the highest streak you've ever reached.`,
        };
        

  const handleScoreInfoClick = () => {
    showCenteredBalloon(scoreLabels.infoText);
  };

  const popupSummary = {
    title: scoreLabels.title,
    infoLabel: scoreLabels.info,
    onInfo: handleScoreInfoClick,
    rows: [
      { label: scoreLabels.score, value: scoreDictionary.score ?? 0 },
      {
        label: scoreLabels.played,
        value: scoreDictionary.numbersPlayed ?? 0,
      },
      { label: scoreLabels.streak, value: scoreDictionary.streak ?? 0 },
      { label: scoreLabels.maxStreak, value: scoreDictionary.maxStreak ?? 0 },
    ],
  };
  const baseCompetitionText = "";
  const competitionOverlayMessage =
    langString === "nl"
      ? "Log in om je scores op te slaan en mee te doen aan de competitie."
      : "Log in to save your scores and join the competition.";
  const competitionResultBase = {
    entries: competitionEntries,
    oppositeMonthTop3: competitionOppositeMonthTop3 || [],
    loading: competitionLoading,
    error: competitionError,
    monthLabel: competitionMonthLabel,
    texts: competitionTexts,
    tableLabels: competitionTableLabels,
    onRetry: refreshCompetitionLeaderboard,
    profileDefault,
    disabled: !currentUser,
    overlayMessage: competitionOverlayMessage,
    onClick: !currentUser ? () => openAuthModal(AuthModes.SIGN_UP) : undefined,
    lang: langString,
  };
  const resultFootnoteText = "";

  function markGameFinished(result = "win", clicksLeft = null, wordsFound = null) {
    // Use game.idNumber instead of local idNumber to ensure we use the correct game ID
    const gameIdNumber = game?.idNumber ?? idNumber;
    
    // Always mark locally as finished so the board is shown correctly
    try {
      localStorage.setItem("finishedGameidNummer", gameIdNumber);
      storeFinishedOutcomeValue(gameIdNumber, result);
      if (clicksLeft !== null) {
        storeFinishedClicksLeft(gameIdNumber, clicksLeft);
      }
      if (wordsFound !== null) {
        storeFinishedWordsFound(gameIdNumber, wordsFound);
      }
      // Clear in-progress game state since game is now finished
      clearGameState(gameIdNumber);
    } catch (error) {
      console.warn("Failed to persist finished game locally", error);
    }

    // Add to finished list (addUserFinishedId will handle if it's already in the list)
    setFinishedIdNumbers((prev) => {
      if (prev.includes(gameIdNumber)) {
        return prev;
      }
      return [...prev, gameIdNumber];
    });

    // Tutorial Check: If tutorial, stop here (don't save to server or reschedule notifications)
    if (isTutorialGame(gameIdNumber)) {
      // Mark tutorial as complete and permanently disable re-loading tutorial/practice games
      // after the player has finished one, so refresh or reload won't bring them back.
      markTutorialAsShown();
      disableTutorialPermanently();
      // Mark that user has seen the explanation when tutorial 9999 is finished
      if (gameIdNumber === TUTORIAL_GAME_ID) {
        localStorage.setItem("hasSeenExplanation", "true");
      }
      return;
    }

    // Save to server (addUserFinishedId will check if it's already finished)
    if (currentUser) {
      addUserFinishedId(gameIdNumber)
        .then((remote) => {
          if (remote) {
            setFinishedIdNumbers(remote);
          }
        })
        .catch((error) => {
          console.warn("Failed to save finished game remotely", error);
        });
    }

    // Reschedule the repeating notification to start from tomorrow when user plays
    // This preserves the repeat behavior while skipping today's notification
    if (isNative()) {
      rescheduleRepeatFromTomorrow().catch((error) => {
        console.warn("Failed to reschedule notification from tomorrow:", error);
      });
    }
  }

  return (
    <div
      ref={wordhitWrapperRef}
      className="wordhit-wrapper"
      onTouchStart={handleSwipeTouchStart}
      onTouchEnd={handleSwipeTouchEnd}
    >
      {/* Landscape warning - one-time only */}
      {showLandscapeWarning && (
        <div className="landscape-warning">
          <RotateCw size={24} />
          <span>
            {langString === "nl" 
              ? "WordHit werkt het beste in portrait mode" 
              : "WordHit works best in portrait mode"}
          </span>
        </div>
      )}
      <div className="top-header">
        <div className="title-row">
  <div className="logo-column">
   <div className="widget-header">
    <div className="green-line-thin"></div>
  <div className="green-line-thick"></div>
    <div className="yellow-block"></div>
    <div className="blue-square"></div>
    <div className="red-square"></div>
    <div className="green-outline-left"></div>
    <div className="yellow-outline-right"></div>
    <div className="blue-outline-right"></div>

     <img
      src={headerLogo}
      alt="WordHit"
      className="game-logo"
       style={{
  width: hasLost || hasWon ? (isCustomGame ? "187px" : "170px") : "187px",
  height: hasLost || hasWon ? (isCustomGame ? "35px" : "39px") : "35px",
 }}
 />
  {(hasLost || hasWon) && !isCustomGame ? (
    <span className="countdown-timer">{headerSubtitle}</span>
  ) : (
    headerSubtitle
  )}
</div>
<div className="dashes-line">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
        {/* {message && (
          <div className="feedback-message">{message}</div>
        )}
        {errorText && (
          <div className="feedback-message" style={{ color: "red" }}>
            {errorText}
          </div>
        )} */}
      </div>

      {/* THEMA linksonder boven bord */}
      <div className="theme-inline">
        <span className="theme-label">{languageString.textTheme} </span>
        <span className="theme-name">{game.theme}</span>
      </div>

{/* Board + counters + ✅ overlay + clicks badge */}
<div className="board-outer" ref={boardRef}>
 {/* clicks badge rechtsboven (alleen tonen zolang clicksLeft >= 0) */}
{clicksLeft >= 0 && (
  <div className="clicks-counter">
    <div
      className={clicksNumberClass}
      onClick={handleClicksCounterClick}
      style={{ cursor: isCheatRevealActive ? "pointer" : "default" }}
    >
      {displayClicksLeft}
    </div>
    <div className={`clicks-counter-label${animateClicks ? ` animate animate--${animateClicksDirection}` : ""}`}>{clicksLeft === 1
    ? languageString.textClick
    : languageString.textClicks}</div>
  </div>
)}
<div className="header-buttons-row" style={{ position: "absolute", top: "-45px", left: "8px", zIndex: 1, display: "flex", alignItems: "center", gap: "6px" }}>
  <button
    ref={menuButtonRef}
    onClick={() => setShowMenuModal(true)}
    className="explanation-button"
    style={{
      background: "none",
      border: "none",
      padding: 0,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      top: 0,
      left: 0,
    }}
    aria-label="Menu"
    title={menuButtonTitle}
  >
    {/* Custom menu icon: three circles with rectangles */}
    <svg
      width="28"
      height="28"
      viewBox="-2 0 30 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Top circle with rectangle */}
      <circle cx="0" cy="8" r="1.5" fill="#194093" />
      <rect x="3" y="6.5" width="25" height="3" rx="0.5" fill="#194093" />
      {/* Middle circle with rectangle */}
      <circle cx="0" cy="16" r="1.5" fill="#194093" />
      <rect x="3" y="14.5" width="25" height="3" rx="0.5" fill="#194093" />
      {/* Bottom circle with rectangle */}
      <circle cx="0" cy="24" r="1.5" fill="#194093" />
      <rect x="3" y="22.5" width="25" height="3" rx="0.5" fill="#194093" />
    </svg>
  </button>
  {/* Uitleg-knop: vraagteken in rondje - opent uitleg (3 pagina's); verbergen na de eerste normaal gespeelde WordHit */}
  {(scoreDictionary.numbersPlayed ?? 0) === 0 && (
  <button
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      setExplanationStep(1);
      setShowRules(true);
    }}
    className="explanation-button uitleg-button"
    style={{
      background: "none",
      border: "none",
      padding: 0,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      flexShrink: 0,
    }}
    aria-label={langString === "nl" ? "Uitleg" : "How to play"}
    title={langString === "nl" ? "Uitleg" : "How to play"}
  >
    <span className="uitleg-button-circle">?</span>
  </button>
  )}
  {/* Battle-knop op dezelfde plek zodra er minimaal 1 normale WordHit is gespeeld (numbersPlayed >= 1).
      Tonen op native altijd (als Battle aan staat), op web alleen als BATTLE_MODE.enabledOnWeb in featureFlags.js true is. */}
  {(scoreDictionary.numbersPlayed ?? 0) >= 1
    && isBattleModeAvailableOnPlatform() && (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowBattleModeModal(true);
      }}
      className="explanation-button battle-mode-button"
      style={{
        background: "none",
        border: "none",
        padding: 0,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
      aria-label={langString === "nl" ? "Battle Mode" : "Battle Mode"}
      title={langString === "nl" ? "Battle Mode" : "Battle Mode"}
    >
      <Swords size={24} strokeWidth={2.5} color="#194093" />
    </button>
  )}
  {/* END FEATURE: BATTLE_MODE */}
</div>
  {game.board.map((row, r) => (
    <div className="board-row" key={`row-${r}`}>
      {row.map((cell, c) => {
        // Check if this cell should be clickable (guided clicks logic)
        const hasGuidedClicks = game?.guidedClicks && Array.isArray(game.guidedClicks) && game.guidedClicks.length > 0;
        let isClickable = true;
        
        // For tutorial 9999, only apply guided clicks after tooltip 1 is dismissed
        const shouldApplyGuidedClicks = hasGuidedClicks && (
          game.idNumber !== TUTORIAL_GAME_ID || 
          (!showTutorialTooltip1 && tutorialTooltip1Shown)
        );
        
        if (shouldApplyGuidedClicks && currentGuidedClickIndex < game.guidedClicks.length) {
          const currentGuidedClick = game.guidedClicks[currentGuidedClickIndex];
          if (currentGuidedClick) {
            const match = currentGuidedClick.match(/^r(\d+)c(\d+)$/);
            if (match) {
              // guidedClicks uses 1-indexed format (like playSequence), convert to 0-indexed
              const guidedRow = parseInt(match[1], 10) - 1;
              const guidedCol = parseInt(match[2], 10) - 1;
              isClickable = (r === guidedRow && c === guidedCol);
            }
          }
        }
        
        return (
          <div
            key={`${r}-${c}`}
            onClick={() => clickCell(r, c)}
            className={
              getCellClass(r, c) +
              (localRevealDelays?.[r]?.[c] != null ? " cell--local-flip" : "")
            }
            style={{
              cursor: isClickable ? "pointer" : "not-allowed",
              opacity: (() => {
                if (!shouldApplyGuidedClicks) return 1;
                if (!isClickable && !revealed[r][c]) return 0.5;
                const delay = localRevealDelays?.[r]?.[c];
                if (delay != null && !cellsWithFlipStarted.has(`${r},${c}`)) return 0.5;
                return 1;
              })(),
              ...(localRevealDelays?.[r]?.[c] != null
                ? { "--local-reveal-delay": `${localRevealDelays[r][c]}ms` }
                : {}),
            }}
          >
            {revealed[r][c] ? <span className="cell-letter">{cell}</span> : ""}
          </div>
        );
      })}

      {/* rij count rechts */}
      <div 
        className="count-cell"
        ref={r === 0 ? countCellRef : null}
      >
        {rowCounts[r]}
      </div>
    </div>
  ))}

  {/* onder de kolommen: col counts + lege hoekcel */}
  <div className="board-row board-row-counts" ref={colCountsRowRef}>
    {colCounts.map((count, i) => (
      <div className="count-cell" key={`col-${i}`}>
        {count}
      </div>
    ))}
    <div className="count-cell corner-cell"></div>
  </div>

  {/* Advanced tutorial: Animated hand icon for guided clicks */}
  {showGuidedHand && guidedHandPosition.visible && (
    <div
      className="guided-click-hand"
        style={{
          position: "absolute",
          left: `${guidedHandPosition.left - 8}px`,
          top: `${guidedHandPosition.top}px`,
          transform: "translate(-50%, -50%)",
          pointerEvents: "none",
          zIndex: 100,
          width: "40px",
          height: "40px",
        }}
      >
        <Pointer
          size={40}
          color="var(--sf-green)"
          fill="var(--sf-green)"
          strokeWidth={2.5}
        />
    </div>
  )}

{showConfetti && (
  <ConfettiOverlay
    visible
    colors={["var(--sf-green, #28ab64)", "var(--sf-blue, #194093)", "#f5d547", "#e62731"]}
  />
)}

{/* Tutorial Tooltip 1: Cijfers uitleg */}
{showTutorialTooltip1 && colCountsRowRef.current && game && isTutorialGame(game.idNumber) && game.idNumber !== PRACTICE_GAME_ID_3 && (
  <>
    {/* Overlay to close on tap outside */}
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10001,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
      onClick={() => setShowTutorialTooltip1(false)}
    />
    <div
      className="widget-balloon widget-balloon--down widget-balloon--tutorial-1"
      style={{
        position: "fixed",
        left: colCountsRowRef.current.getBoundingClientRect().left + colCountsRowRef.current.getBoundingClientRect().width / 2 - 22,
        top: colCountsRowRef.current.getBoundingClientRect().top - 10,
        transform: "translate(-50%, -100%)",
        zIndex: 10002,
        maxWidth: "280px",
      }}
      onClick={() => setShowTutorialTooltip1(false)}
    >
      {game.idNumber === PRACTICE_GAME_ID_2
        ? (langString === "nl" 
            ? "Tip! Kijk goed naar het aantal letters in iedere rij en kolom. Begin met de hoogste cijfers."
            : "Tip! Look carefully at the number of letters in each row and column. Start with the highest numbers.")
        : (langString === "nl" 
            ? "Cijfers tonen het aantal letters in iedere rij/kolom"
            : "Numbers show how many letters are in each row/column")}
      <span className="widget-balloon-arrow-right"></span>
    </div>
  </>
)}

{/* WIN POPUP */}
{hasWon && showWinPopup && (
  <GameResultModal
    title={
      langString === "nl"
        ? `${clicksLeft} klik${clicksLeft === 1 ? "" : "s"} over!`
        : `${clicksLeft} click${clicksLeft === 1 ? "" : "s"} left!`
    }
    message={(() => {
      const tier = getWinTierLabel(langString, clicksLeft);
      if (worseUsersPct === null) return tier;
      return langString === "nl"
        ? (
          <>
            {tier} - je zit in de top {worseUsersPct}
            <span className="result-message-percent">%</span>
            <br />
            van alle spelers
          </>
        )
        : (
          <>
            {tier} - you're in the top {worseUsersPct}
            <span className="result-message-percent">%</span>
            <br />
            of all players
          </>
        );
    })()}
    color="var(--sf-green)"
    summary={popupSummary}
    oldScore={isFirstTimeShowingResult ? oldScore : null}
    shareLabel={langString === "nl" ? "DEEL" : "SHARE"}
    footnote={resultFootnoteText}
    secondaryLabel={
      currentUser 
        ? (langString === "nl" ? "+ volg" : "+ follow")
        : (langString === "nl" ? "INLOGGEN" : "SIGN IN")
    }
    competition={{ ...competitionResultBase, active: hasWon && showWinPopup }}
    lang={langString}
    onFollow={currentUser ? async (usernameOrEmail) => {
      try {
        await addFriend(usernameOrEmail, langString);
        // Refresh leaderboard to show the new friend
        if (refreshCompetitionLeaderboard) {
          refreshCompetitionLeaderboard();
        }
      } catch (error) {
        throw error; // Let FollowPopup handle the error display
      }
    } : undefined}
    isTutorial={game && isTutorialGame(game.idNumber)}
    onSecondaryAction={() => {
      const wasOpenedByScoreButton = resultModalOpenedByScoreButton;
      if (currentUser) {
        setShowWinPopup(false);
        setResultModalOpenedByScoreButton(false);
        setShowConfetti(false);
        if (game && isTutorialGame(game.idNumber)) setTutorialResultPopupDismissed(true);
        if (confettiTimeoutRef.current) {
          clearTimeout(confettiTimeoutRef.current);
          confettiTimeoutRef.current = null;
        }
        setTimeout(
          () =>
            showBalloon(
              "tomorrow",
              langString === "nl"
                ? "Morgen staat een nieuwe WordHit voor je klaar!"
                : "A new WordHit will be ready for you tomorrow!"
            ),
          250
        );
        // Only pulse if modal was NOT opened by score button (i.e., auto-opened)
        if (!wasOpenedByScoreButton) {
          triggerShareScoreButtonPulse();
        }
        // Show rate popup when modal closes (iOS only, temporary)
        showRatePopupOnModalClose();
        return;
      }
      setShowWinPopup(false);
      setResultModalOpenedByScoreButton(false);
      setShowConfetti(false);
      if (game && isTutorialGame(game.idNumber)) setTutorialResultPopupDismissed(true);
      if (confettiTimeoutRef.current) {
        clearTimeout(confettiTimeoutRef.current);
        confettiTimeoutRef.current = null;
      }
      // Delay balloon if auth modal will be opened
      showBalloonOrDelay(
        "tomorrow",
        langString === "nl"
          ? "Morgen staat een nieuwe WordHit voor je klaar!"
          : "A new WordHit will be ready for you tomorrow!",
        true // willOpenAuthModal
      );
      openAuthModal(AuthModes.SIGN_UP);
      // Only pulse if modal was NOT opened by score button (i.e., auto-opened)
      if (!wasOpenedByScoreButton) {
        triggerShareScoreButtonPulse();
      }
      // Show rate popup when modal closes (iOS only, temporary)
      showRatePopupOnModalClose();
    }}
    isLoggedIn={Boolean(currentUser)}
    currentUser={currentUser}
    onClose={() => {
      const wasOpenedByScoreButton = resultModalOpenedByScoreButton;
      setShowWinPopup(false);
      if (game && isTutorialGame(game.idNumber)) setTutorialResultPopupDismissed(true);
      setResultModalOpenedByScoreButton(false);
      setShowConfetti(false);
      if (confettiTimeoutRef.current) {
        clearTimeout(confettiTimeoutRef.current);
        confettiTimeoutRef.current = null;
      }
      // Show balloon normally when closing without opening auth modal
      // Don't show tomorrow balloon if this was a tutorial game
      if (!(game && isTutorialGame(game.idNumber))) {
      setTimeout(
        () =>
          showBalloon(
            "tomorrow",
            langString === "nl"
              ? "Morgen staat een nieuwe WordHit voor je klaar!"
              : "A new WordHit will be ready for you tomorrow!"
          ),
        250
      );
      }
      // Only pulse if modal was NOT opened by score button (i.e., auto-opened)
      if (!wasOpenedByScoreButton) {
        triggerShareScoreButtonPulse();
      }
      // Show rate popup when modal closes (iOS only, temporary)
      showRatePopupOnModalClose();
    }}
    onShare={shareScore}
  />
)}

{balloon.visible && (
  <>
    <div 
      className="widget-balloon-overlay"
      onClick={(event) => {
        event.stopPropagation();
        closeBalloon();
      }}
    />
  <div
    className={`widget-balloon${
      balloon.tip === "down"
        ? " widget-balloon--down"
        : balloon.tip === "left"
        ? " widget-balloon--left"
        : balloon.tip === "none"
        ? " widget-balloon--no-tip"
        : balloon.tip === "no-arrow"
        ? " widget-balloon--no-arrow"
        : ""
    }${balloon.closeable ? " widget-balloon--closeable" : ""}${balloon.type === "menu" ? " widget-balloon--menu" : ""}`}
    style={{ 
      left: balloon.x, 
      top: balloon.y,
      ...(balloon.type === "hint" && balloon.tip === "down"
        ? { transform: "translate(-50%, -100%)" }
        : {}),
      ...(balloon.type === "hint" &&
        (balloon.text === "Hint nodig?" || balloon.text === "Need a hint?")
        ? {
            maxWidth: 100,
            paddingLeft: 18,
            paddingRight: 18,
            animation: "hintBalloonFadeIn 0.22s ease-out",
          }
        : {}),
      ...(balloon.type === "battleInvite"
        ? {
            maxWidth: 220,
            width: "80vw",
          }
        : {})
    }}
    onClick={(event) => {
      // Don't close if clicking inside balloon content (but allow buttons to handle their own events)
      event.stopPropagation();
    }}
    role="status"
    aria-live="polite"
  >
    {balloon.type === "centered" ? renderScoreExplanation(balloon.text) : balloon.text}
    {balloon.type === "battleInvite" && getPublisherId() === "adv" && (
      <div className="widget-balloon-download-app">
        <div className="widget-balloon-download-app-label">Download de app</div>
        <div className="widget-balloon-download-app-buttons">
          <a
            href="https://apps.apple.com/app/id6755532039"
            target="_blank"
            rel="noopener noreferrer"
            className="widget-balloon-store-link"
            onClick={(e) => e.stopPropagation()}
            aria-label="Download on the App Store"
          >
            <img
              src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=180x60&releaseDate=1609459200"
              alt="Download on the App Store"
              className="widget-balloon-store-badge"
              loading="lazy"
              decoding="async"
              fetchPriority="low"
              width="135"
              height="44"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.wordhit.app"
            target="_blank"
            rel="noopener noreferrer"
            className="widget-balloon-store-link"
            onClick={(e) => e.stopPropagation()}
            aria-label="Get it on Google Play"
          >
            <img
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
              className="widget-balloon-store-badge widget-balloon-store-badge--google"
              loading="lazy"
              decoding="async"
              fetchPriority="low"
              width="135"
              height="44"
            />
          </a>
        </div>
      </div>
    )}
    {balloon.closeable && (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', alignItems: 'center', marginTop: '24px', marginBottom: '8px' }}>
      <button
        type="button"
          className="widget-balloon-ok-button"
        onClick={(event) => {
          event.stopPropagation();
            // First call any custom onClose handler if present
            if (balloon.onClose) {
              balloon.onClose();
            }
            // Then close the balloon
          closeBalloon();
        }}
          style={balloon.type === "tutorial" ? {
            position: 'relative',
            bottom: 'auto',
            left: 'auto',
            transform: 'none',
          } : {}}
          aria-label="OK"
        >
          OK
        </button>
        {balloon.type === "tutorial" && (
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              skipTutorial();
            }}
            style={{
              padding: '8px 16px',
              backgroundColor: 'transparent',
              color: 'var(--text-dark)',
              border: 'none',
              borderRadius: '8px',
              fontSize: '0.9rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'opacity 0.2s ease',
            }}
            onMouseEnter={(e) => e.target.style.opacity = '0.7'}
            onMouseLeave={(e) => e.target.style.opacity = '1'}
            aria-label={langString === "nl" ? "Overslaan" : "Skip"}
          >
            {langString === "nl" ? "Overslaan" : "Skip"}
      </button>
    )}
  </div>
    )}
  </div>
  </>
)}

{/* LOSE POPUP */}
{hasLost && showLosePopup && (
  <GameResultModal
    title={
      langString === "nl"
        ? `${resultWordsFound ?? scoreDictionary.wordsFound ?? 0} woord${
            (resultWordsFound ?? scoreDictionary.wordsFound ?? 0) !== 1 ? "en" : ""
          } gevonden.`
        : `${resultWordsFound ?? scoreDictionary.wordsFound ?? 0} word${
            (resultWordsFound ?? scoreDictionary.wordsFound ?? 0) !== 1 ? "s" : ""
          }.`
    }
    message={
      game && isTutorialGame(game.idNumber)
        ? (langString === "nl"
          ? `Tutorial afgerond! De woorden waren: ${game.words.join(", ")}.`
          : `Practice round completed! The words were: ${game.words.join(", ")}.`
        ) + (langString === "nl"
          ? "\n\nHet is niet makkelijk, maar je zult er steeds meer handigheid in krijgen."
          : "\n\nIt's not easy, but you'll get the hang of it more and more.")
        : langString === "nl"
        ? `Volgende keer beter! De woorden waren: ${game.words.join(", ")}.`
        : `Better luck next time! The words were: ${game.words.join(", ")}.`
    }
    color="var(--sf-blue)"
    summary={popupSummary}
    oldScore={isFirstTimeShowingResult ? oldScore : null}
    shareLabel={langString === "nl" ? "deel" : "share"}
    footnote={resultFootnoteText}
    secondaryLabel={
      currentUser 
        ? (langString === "nl" ? "+ volg" : "+ follow")
        : (langString === "nl" ? "inloggen" : "sign in")
    }
    competition={{ ...competitionResultBase, active: hasLost && showLosePopup }}
    lang={langString}
    onFollow={currentUser ? async (usernameOrEmail) => {
      try {
        await addFriend(usernameOrEmail, langString);
        // Refresh leaderboard to show the new friend
        if (refreshCompetitionLeaderboard) {
          refreshCompetitionLeaderboard();
        }
      } catch (error) {
        throw error; // Let FollowPopup handle the error display
      }
    } : undefined}
    isTutorial={game && isTutorialGame(game.idNumber)}
    onSecondaryAction={() => {
      const wasOpenedByScoreButton = resultModalOpenedByScoreButton;
      if (currentUser) {
        setShowLosePopup(false);
        setResultModalOpenedByScoreButton(false);
        if (game && isTutorialGame(game.idNumber)) setTutorialResultPopupDismissed(true);
        setTimeout(
          () =>
            showBalloon(
              "tomorrow",
              langString === "nl"
                ? "Morgen staat een nieuwe WordHit voor je klaar!"
                : "A new WordHit will be ready for you tomorrow!"
            ),
          250
        );
        // Only pulse if modal was NOT opened by score button (i.e., auto-opened)
        if (!wasOpenedByScoreButton) {
          triggerShareScoreButtonPulse();
        }
        // Show rate popup when modal closes (iOS only, temporary)
        showRatePopupOnModalClose();
        return;
      }
      setShowLosePopup(false);
      setResultModalOpenedByScoreButton(false);
      if (game && isTutorialGame(game.idNumber)) setTutorialResultPopupDismissed(true);
      // Delay balloon if auth modal will be opened
      showBalloonOrDelay(
        "tomorrow",
        langString === "nl"
          ? "Morgen staat een nieuwe WordHit voor je klaar!"
          : "A new WordHit will be ready for you tomorrow!",
        true // willOpenAuthModal
      );
      openAuthModal(AuthModes.SIGN_UP);
      // Only pulse if modal was NOT opened by score button (i.e., auto-opened)
      if (!wasOpenedByScoreButton) {
        triggerShareScoreButtonPulse();
      }
      // Show rate popup when modal closes (iOS only, temporary)
      showRatePopupOnModalClose();
    }}
    isLoggedIn={Boolean(currentUser)}
    currentUser={currentUser}
    onClose={() => {
      const wasOpenedByScoreButton = resultModalOpenedByScoreButton;
      setShowLosePopup(false);
      if (game && isTutorialGame(game.idNumber)) setTutorialResultPopupDismissed(true);
      setResultModalOpenedByScoreButton(false);
      // Show balloon normally when closing without opening auth modal
      // Don't show tomorrow balloon if this was a tutorial game
      if (!(game && isTutorialGame(game.idNumber))) {
      setTimeout(
        () =>
          showBalloon(
            "tomorrow",
            langString === "nl"
              ? "Morgen staat een nieuwe WordHit voor je klaar!"
              : "A new WordHit will be ready for you tomorrow!"
          ),
        250
      );
      }
      // Only pulse if modal was NOT opened by score button (i.e., auto-opened)
      if (!wasOpenedByScoreButton) {
        triggerShareScoreButtonPulse();
      }
      // Show rate popup when modal closes (iOS only, temporary)
      showRatePopupOnModalClose();
    }}
    onShare={shareScore}
  />
)}
</div>

  {/* ✅ overlay after correct guess - covers entire widget */}
{showCheckOverlay && (
  <div style={{
    position: "fixed", 
    top: 0, left: 0, right: 0, bottom: 0,
    width: "100vw", height: "100vh",
    display: "flex", alignItems: "center", justifyContent: "center",
    background: "rgba(255,255,255,0.6)", zIndex: 20,
    pointerEvents: "none"
  }}>
    <div style={{
      fontFamily: "Union, sans-serif",
      fontSize: 150, fontWeight: "bold",
      color: "var(--sf-green)"
    }}>
      +{clicksToShow}
    </div>
  </div>
)}

{/* ❌ overlay after wrong guess - covers entire widget */}
{showCrossOverlay && (
  <div style={{
    position: "fixed", 
    top: 0, left: 0, right: 0, bottom: 0,
    width: "100vw", height: "100vh",
    display: "flex", alignItems: "center", justifyContent: "center",
    background: "rgba(255,255,255,0.6)", zIndex: 20,
    pointerEvents: "none"
  }}>
    <div style={{
      fontFamily: "Union, sans-serif",
      fontSize: 150, fontWeight: "bold",
      color: "var(--sf-red)"
    }}>
      -1
    </div>
  </div>
)}

      {/* Guess form */}
      {(() => {
        // Use game.idNumber instead of local idNumber to ensure we check the correct game
        const gameIdNumber = game?.idNumber ?? idNumber;
        const finishedLocal =
          typeof window !== "undefined" &&
          String(localStorage.getItem("finishedGameidNummer")) === String(gameIdNumber);
        const isAlreadyFinishedToday =
          !game?.creator && (finishedLocal || finishedIdNumbers.includes(gameIdNumber));
        return !hasWon && !hasLost && !isAlreadyFinishedToday;
      })() && (
        <form onSubmit={submitGuess} className="guess-form">

          {/* <div className="guess-label">Raad een woord:</div> */}
          {guessFeedback && (
            <p className="guess-feedback guess-feedback--bad">{guessFeedback}</p>
          )}
          <div className={`guess-form-row${guessShake ? " guess-form-row--shake" : ""}`} ref={guessFormRowRef}>
            {(() => {
              const id = game?.idNumber;
              const isTutorialLikeGame = id === 9999 || id === 9998 || id === 9997;
              const numbersPlayed = scoreDictionary.numbersPlayed ?? 0;
              const allowHintFeature = numbersPlayed <= 5;
              return clicksLeft <= 4 && !isTutorialLikeGame && !isGridAnimating && allowHintFeature;
            })() && (
              <button
                type="button"
                onClick={() => {
                  if (hintTimeoutRef.current) {
                    clearTimeout(hintTimeoutRef.current);
                  }
                  setIsHintActive(true);
                  hintTimeoutRef.current = setTimeout(() => {
                    setIsHintActive(false);
                    hintTimeoutRef.current = null;
                  }, 2000);
                }}
                className={`hint-button${hasHintIntroPlayed ? " hint-button--intro" : ""}`}
                aria-label={langString === "nl" ? "Hint: toon letters" : "Hint: show letters"}
              >
                <Lightbulb size={20} strokeWidth={2.5} />
              </button>
            )}
            {wrongGuessedWords.length > 0 && clicksLeft > 3 && (
              <button
                type="button"
                onClick={() => setShowWrongWordsModal(true)}
                className="wrong-words-button"
                aria-label={langString === "nl" ? "Fout geraden woorden" : "Wrong guessed words"}
              >
                <ListX size={20} strokeWidth={2.5} />
              </button>
            )}
            <input
                ref={guessInputRef}
                value={guess}
                onChange={handleGuessChange}
                className="guess-input"
                placeholder={languageString.textGuessWord}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
  />
            {/* <button type="submit" className="guess-button">
               <img
      src={doneImage}
      alt="done"
      className="check-mark-image"
      style={{ width: "20px", height: "20px",  paddingTop:"0px" }}

    />
            </button> */}
<button
  type="submit"
  className="guess-button"
  // style={{
  //   width: 45,
  //   height: 45,

  // }}
>
  <Check size={20} strokeWidth={2.5} />
</button>
          </div>
        </form>
      )}

{/* Tutorial Tooltip 2: Type mechanic uitleg - alleen op 9999, niet op 9998/9997 zodat overlay geen klikken blokkeert bij snel doorgaan */}
{showTutorialTooltip2 && guessFormRowRef.current && game && game.idNumber === TUTORIAL_GAME_ID && isFirstTimeTutorial && (
  <>
    {/* Overlay to close on tap outside */}
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10001,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
      onClick={() => setShowTutorialTooltip2(false)}
    />
    <div
      className="widget-balloon widget-balloon--down"
      style={{
        position: "fixed",
        left: guessFormRowRef.current.getBoundingClientRect().left + guessFormRowRef.current.getBoundingClientRect().width / 2,
        top: guessFormRowRef.current.getBoundingClientRect().top - 10,
        transform: "translate(-50%, -100%)",
        zIndex: 10002,
        maxWidth: "300px",
        textAlign: "center",
      }}
      onClick={() => setShowTutorialTooltip2(false)}
    >
      <div style={{ marginBottom: "8px", fontSize: "1.4rem" }}>
        {langString === "nl" 
          ? "De 3 woorden passen bij het thema. Weet je een woord? Typ het in!"
          : "The 3 words match the theme. Know a word? Type it in!"}
      </div>
      <div style={{ fontSize: "1.1rem", lineHeight: "1.4" }}>
        {langString === "nl" ? (
          <>
            <span style={{ color: "var(--sf-green)" }}>✓</span> Goed = klik erbij<br />
            <span style={{ color: "var(--sf-red)" }}>✗</span> Fout = klik eraf
          </>
        ) : (
          <>
            <span style={{ color: "var(--sf-green)" }}>✓</span> Correct = +1 click<br />
            <span style={{ color: "var(--sf-red)" }}>✗</span> Wrong = -1 click
          </>
        )}
      </div>
    </div>
  </>
)}

      {/* Share today's score button - shown when game is finished */}
      {(() => {
        // Use game.idNumber instead of local idNumber to ensure we check the correct game
        const gameIdNumber = game?.idNumber ?? idNumber;
        const finishedLocal =
          typeof window !== "undefined" &&
          String(localStorage.getItem("finishedGameidNummer")) === String(gameIdNumber);
        const isAlreadyFinishedToday =
          !game?.creator && (finishedLocal || finishedIdNumbers.includes(gameIdNumber));
        
        if (!(hasWon || hasLost || isAlreadyFinishedToday)) return null;

        // Tutorial: knoppen pas tonen nadat result-popup is gesloten (OK of klik erbuiten)
        if (isTutorialGame(gameIdNumber) && !tutorialResultPopupDismissed) return null;

        // Tutorial: "Nog een tutorial" en "Dagelijkse WordHit" na dismiss van popup
        if (isTutorialGame(gameIdNumber) && tutorialResultPopupDismissed) {
          // Determine next practice game ID
          let nextPracticeId = null;
          if (gameIdNumber === TUTORIAL_GAME_ID) {
            nextPracticeId = PRACTICE_GAME_ID_2;
          } else if (gameIdNumber === PRACTICE_GAME_ID_2) {
            nextPracticeId = PRACTICE_GAME_ID_3;
          }
          
          return (
        <div className="guess-form">
          <div 
            className={`share-score-row${pulseTutorialButton ? " tutorial-buttons-container--pulse" : ""}`}
            style={{ display: 'flex', gap: '8px', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}
          >
            {nextPracticeGameExists && nextPracticeId && (
              <button
                type="button"
                className="custom-share-button"
                onClick={async () => {
                  setTransitioningFromTutorial(true);
                  setCustomLoaderText(langString === "nl" ? "We laden de volgende tutorial..." : "Loading next tutorial...");
                  setIsLoading(true);
                  setGame(null);
                  
                  const loadStart = Date.now();
                  async function loadPracticeGame() {
                    try {
                      console.log(`[Practice] Loading practice game ${nextPracticeId}`);
                      const built = await buildGameForToday(langString, nextPracticeId);
                      setGame(built);
                      gameRef.current = built;
                      
                      // Reset game state
                      setRevealed(Array.from({ length: GRID_SIZE }, () =>
                        Array.from({ length: GRID_SIZE }, () => false)
                      ));
                      setClicksLeft(MAX_CLICKS);
                      setGuessedWords([]);
                      setWrongGuessedWords([]);
                      setPlaySequenceActions([]);
                      playSequenceActionsRef.current = [];
                      setHasWon(false);
                      setHasLost(false);
                      setShowWinPopup(false);
                      setShowLosePopup(false);
                      autoRevealFinishedRef.current = false;
                      setGuess("");
                      
                      const elapsed = Date.now() - loadStart;
                      const remaining = Math.max(LOADER_MIN_DISPLAY_MS - elapsed, 0);
                      await new Promise((r) => setTimeout(r, remaining));
                      setIsLoading(false);
                    } catch (err) {
                      console.error("Error loading practice game:", err);
                      setIsLoading(false);
                    }
                  }
                  loadPracticeGame();
                }}
                style={{
                  flex: 1,
                  maxWidth: '150px',
                  padding: '12px 0',
                  fontSize: '0.95rem',
                  color: 'var(--sf-blue)',
                  background: 'none',
                  border: '2px solid var(--sf-blue)',
                  opacity: 0.7,
                }}
              >
                {langString === "nl" ? "Nog een tutorial" : "Another tutorial"}
              </button>
            )}
            <button
              type="button"
              className="custom-share-button"
              onClick={() => {
                // Close tutorial and reload normal game
                // markTutorialAsShown(); // Already marked in markGameFinished
                setTransitioningFromTutorial(true); // Signal we are transitioning to show correct loader
                setCustomLoaderText(langString === "nl" ? "WordHit van vandaag laden..." : "Loading today's WordHit...");
                setIsLoading(true);
                setGame(null); // Reset game to force reload
                
                // Force reload logic (similar to new day check)
                const loadStart = Date.now();
                async function loadNormalGame() {
                  try {
                    const fromDate = new Date(2022, 0, 1);
                    const currentDate = new Date();
                    const utcCurrent = Date.UTC(
                      currentDate.getFullYear(),
                      currentDate.getMonth(),
                      currentDate.getDate()
                    );
                    const utcFrom = Date.UTC(
                      fromDate.getFullYear(),
                      fromDate.getMonth(),
                      fromDate.getDate()
                    );
                    const currentIdNumber = Math.floor((utcCurrent - utcFrom) / (1000 * 60 * 60 * 24));
                    
                    console.log(`[Tutorial] Closing tutorial, loading normal game ${currentIdNumber}`);
                    const built = await buildGameForToday(langString, currentIdNumber);
                    setGame(built);
                    gameRef.current = built;
                    
                    // Reset game state
                    setRevealed(Array.from({ length: GRID_SIZE }, () =>
                      Array.from({ length: GRID_SIZE }, () => false)
                    ));
                    setClicksLeft(MAX_CLICKS);
                    setGuessedWords([]);
                    setWrongGuessedWords([]);
                    setPlaySequenceActions([]);
                    playSequenceActionsRef.current = [];
                    setHasWon(false);
                    setHasLost(false);
                    setShowWinPopup(false);
                    setShowLosePopup(false);
                    autoRevealFinishedRef.current = false;
                    setGuess("");
                    
                    const elapsed = Date.now() - loadStart;
                    const remaining = Math.max(LOADER_MIN_DISPLAY_MS - elapsed, 0);
                    await new Promise((r) => setTimeout(r, remaining));
                    setIsLoading(false);
                  } catch (err) {
                    console.error("Error loading normal game after tutorial:", err);
                    setIsLoading(false);
                  }
                }
                loadNormalGame();
              }}
              style={{ 
                flex: 1, 
                maxWidth: '200px', 
                padding: '12px 0',
                fontSize: '1rem',
                border: '2px solid var(--sf-blue)',
                boxSizing: 'border-box',
                background: 'var(--sf-blue)',
              }}
            >
              {langString === "nl" ? "Dagelijkse WordHit" : "Daily WordHit"}
            </button>
              </div>
            </div>
          );
        }

        return (
        <div className="guess-form">
          <div className="share-score-row">
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                openResultModal();
              }}
              className="share-score-button share-stats-button"
              aria-label={langString === "nl" ? "Score & Competities" : "Score & Competitions"}
              title={langString === "nl" ? "Score & Competities" : "Score & Competitions"}
            >
              <Trophy size={20} strokeWidth={2.5} />
            </button>
            <button
              type="button"
              onClick={() => setShowStatisticsModal(true)}
              className="share-score-button share-stats-button"
              aria-label={statsButtonTitle}
              title={statsButtonTitle}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  d="M4 19V5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M4 19H20"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M8 16V12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M12 16V9"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M16 16V7"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
            {(() => {
              const currentScore = scoreDictionary.score ?? getStoredScores().score ?? 0;
              const isScore10 = currentScore === 10;
              return (
                <>
                  <button
                    type="button"
                    onClick={shareScore}
                    className={`share-score-button${pulseShareScoreButton ? " share-score-button--pulse" : ""}${isScore10 ? " share-score-button--score-10" : ""}`}
                  >
                    <span>{languageString.textShareTodayScore}</span>
                  </button>
                  <button
                    type="button"
                    onClick={() => setShowShareLegendModal(true)}
                    className={`share-legend-info-button${pulseShareScoreButton ? " share-legend-info-button--pulse" : ""}${isScore10 ? " share-legend-info-button--score-10" : ""}`}
                    aria-label={langString === "nl" ? "Legende" : "Legend"}
                  >
                    <Info size={20} strokeWidth={2.5} />
                  </button>
                </>
              );
            })()}
          </div>
        </div>
        );
      })()}



{showMenuModal && (
  <MenuModal
    onClose={closeMenuModal}
    onIntroductionClick={handleIntroductionClick}
    onCreateCustomClick={handlePrimaryCreateClick}
    onScoreClick={openScoreModal}
    onFaqClick={handleFaqClick}
    onShareClick={handleShareClick}
    onContactClick={handleAboutClick}
    onProfileButtonClick={handleProfileButtonClick}
    onRemindersClick={handleRemindersClick}
    onBattleClick={isBattleModeAvailableOnPlatform()
      ? () => { closeMenuModal(); setShowBattleModeModal(true); }
      : undefined}
    menuTexts={menuTexts}
    langString={langString}
    currentUser={currentUser}
    profileDefault={profileDefault}
    profileAvatarUrl={profileAvatarUrl}
            isNative={isNative()}
    showAboutContact={getPublisherId() !== "max"}
  />
)}

{debugPushResult !== null && (
  <>
    <div className="menu-overlay" onClick={() => setDebugPushResult(null)} aria-hidden="true" />
    <div className="menu-modal debug-push-modal" style={{ maxHeight: "80vh", overflow: "hidden", display: "flex", flexDirection: "column" }}>
      <button className="menu-close" onClick={() => setDebugPushResult(null)} aria-label="Close">✕</button>
      <h3 style={{ margin: "0 0 12px", fontSize: "1.1rem" }}>
        {langString === "nl" ? "Push-installaties (debug)" : "Push installations (debug)"}
      </h3>
      <pre style={{ flex: 1, overflow: "auto", margin: 0, padding: "12px", background: "#f5f5f5", borderRadius: 8, fontSize: "12px", whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
        {debugPushResult}
      </pre>
      <p style={{ margin: "12px 0 0", fontSize: "12px", color: "#666" }}>
        {langString === "nl"
          ? "Boven: summary met token van dit device en of die overeenkomt met een installatie. Onder: installations (deviceType, GCMSenderId, deviceTokenPrefix)."
          : "Top: summary with this device token and whether it matches an installation. Below: installations (deviceType, GCMSenderId, deviceTokenPrefix)."}
      </p>
    </div>
  </>
)}

{showStatisticsModal && (
  <StatisticsModal
    idNumber={game?.idNumber ?? idNumber}
    langString={langString}
    onClose={() => setShowStatisticsModal(false)}
  />
)}

<AuthModal
  visible={authModalState.visible}
  initialMode={authModalState.mode}
  langString={langString}
  onClose={closeAuthModal}
  onSignInSuccess={(user) => {
    const loggedInUser = user ?? getCurrentUser();
    setCurrentUser(loggedInUser);
    // Set Amplitude user ID when user signs in
    // Use identify() to merge anonymous user (Device ID) with logged-in user (User ID)
    // This ensures events tracked before login are associated with the user
    if (loggedInUser) {
      try {
        amplitude.identify({ user_id: loggedInUser.id });
      } catch (amplitudeError) {
        console.warn('Failed to set Amplitude user ID on sign in:', amplitudeError);
      }
    }
  }}
/>

{showCustomCreator && (
  <CreateCustomWordHit
    onClose={() => {
      setShowCustomCreator(false);
      // Don't reopen menu modal - close everything when subpage closes
      setShowMenuModal(false);
    }}
    langString={langString}
  />
)}

{showFaqModal && (
  <>
    <div className="faq-overlay" onClick={(e) => {
      if (e.target === e.currentTarget) {
        e.stopPropagation();
        closeFaqModal();
      }
    }} />
    <div
      className="faq-modal"
    >
      <button
        className="faq-close"
        onClick={closeFaqModal}
        aria-label="Close FAQ"
      >
        ✕
      </button>
      <div className="faq-title">{langString === "nl" ? "VEELGESTELDE VRAGEN" : "FREQUENTLY ASKED QUESTIONS"}</div>
      {isFaqLoading ? (
        <div className="faq-loading">
          {langString === "nl" ? "Bezig met laden..." : "Loading..."}
        </div>
      ) : faqError ? (
        <div className="faq-error">{faqError}</div>
      ) : (
        <div className="faq-list">
          {faqItems
            .filter((item) => {
              const publisherId = getPublisherId();
              // If no publisherId, show all items
              if (!publisherId) {
                return true;
              }
              // If publisherId is in ignoreForPublishers array, hide this item
              const ignoreForPublishers = item.ignoreForPublishers || [];
              return !ignoreForPublishers.includes(publisherId);
            })
            .map((item, index) => {
            const question =
              langString === "nl" && item.questionNL
                ? item.questionNL
                : item.question;
            const answer =
              langString === "nl" && item.answerNL
                ? item.answerNL
                : item.answer;
            const isOpen = openFaqIndex === index;
            return (
              <div className="faq-item" key={`${item.orderNumber}-${index}`}>
                <button
                  className="faq-question"
                  onClick={() => toggleFaqItem(index)}
                  aria-expanded={isOpen}
                >
                  <span>{question}</span>
                  <span className={`faq-icon ${isOpen ? "open" : ""}`}>
                    {isOpen ? "−" : "+"}
                  </span>
                </button>
                {isOpen && (
                  <div className="faq-answer">
                    {renderFaqAnswer(answer)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  </>
)}

{showAboutModal && (
  <AboutModal
    onClose={closeAboutModal}
    onContactClick={handleContactClick}
    langString={langString}
  />
)}

{showShareLegendModal && (
  <ShareLegendModal
    onClose={() => setShowShareLegendModal(false)}
    langString={langString}
    onShare={shareScore}
  />
)}

{/* Rate Us Popup (iOS and Android) */}
{showRatePopup && (isCapacitorIOS() || isCapacitorAndroid()) && (
  <>
    <div
      className="rules-overlay"
      onClick={handleRateDismiss}
      style={{ zIndex: 10002 }}
    />
    <div
      className="rules-modal"
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 10003,
        background: "var(--sf-bg)",
        borderRadius: "12px",
        boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
        padding: "30px 25px",
        maxWidth: "320px",
        width: "85%",
        textAlign: "center",
      }}
    >
      <h2 style={{
        fontFamily: "Union, sans-serif",
        fontSize: "1.6rem",
        fontWeight: "bold",
        color: "var(--sf-blue)",
        margin: "0 0 15px 0",
      }}>
        {langString === "nl" ? "Vind je WordHit leuk? " : "Enjoying WordHit?"}
      </h2>
      <p style={{
        fontFamily: "Union, sans-serif",
        fontSize: "1.3rem",
        color: "#333",
        margin: "0 0 25px 0",
        lineHeight: "1.5",
      }}>
        {langString === "nl" 
          ? "Een beoordeling helpt ons enorm!"
          : "A review helps us a lot!"}
      </p>
      <div style={{
        display: "flex",
        gap: "12px",
        justifyContent: "center",
      }}>
        <button
          onClick={handleRateDismiss}
          style={{
            padding: "12px 24px",
            fontSize: "1.3rem",
            fontFamily: "Union, sans-serif",
            fontWeight: "bold",
            color: "var(--sf-blue)",
            background: "none",
            border: "2px solid var(--sf-blue)",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          {langString === "nl" ? "Later" : "Later"}
        </button>
        <button
          onClick={handleRateClick}
          style={{
            padding: "12px 24px",
            fontSize: "1.3rem",
            fontFamily: "Union, sans-serif",
            fontWeight: "bold",
            color: "#fff",
            background: "var(--sf-blue)",
            border: "2px solid var(--sf-blue)",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          {langString === "nl" ? "Beoordeel" : "Rate Us"}
        </button>
      </div>
    </div>
  </>
)}

{/* Contact Fallback Popup (when mail app can't be opened) */}
{showContactFallback && (
  <>
    <div
      className="rules-overlay"
      onClick={() => setShowContactFallback(false)}
      style={{ zIndex: 10004 }}
    />
    <div
      className="rules-modal"
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 10005,
        background: "var(--sf-bg)",
        borderRadius: "12px",
        boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
        padding: "25px",
        maxWidth: "500px",
        width: "90%",
        maxHeight: "80vh",
        overflowY: "auto",
      }}
    >
      <button
        onClick={() => setShowContactFallback(false)}
        style={{
          position: "absolute",
          top: "15px",
          right: "15px",
          background: "none",
          border: "none",
          fontSize: "1.8rem",
          cursor: "pointer",
          color: "#666",
          lineHeight: "1",
        }}
        aria-label="Close"
      >
        ✕
      </button>
      
      <h2 style={{
        fontFamily: "Union, sans-serif",
        fontSize: "1.6rem",
        fontWeight: "bold",
        color: "var(--sf-blue)",
        margin: "0 0 15px 0",
      }}>
        {langString === "nl" ? "E-mail ons" : "Email Us"}
      </h2>
      
      <p style={{
        fontFamily: "Union, sans-serif",
        fontSize: "1.1rem",
        color: "#333",
        margin: "0 0 20px 0",
        lineHeight: "1.5",
      }}>
        {langString === "nl" 
          ? "Kopieer onderstaande en email ons:"
          : "Copy the following and email us:"}
      </p>
      
      <div style={{
        background: "#f5f5f5",
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "15px",
        marginBottom: "15px",
        fontFamily: "monospace",
        fontSize: "0.9rem",
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        maxHeight: "300px",
        overflowY: "auto",
      }}>
        <div style={{ marginBottom: "10px", fontWeight: "bold" }}>
          {langString === "nl" ? "Naar:" : "To:"} {contactEmailData.email}
        </div>
        <div style={{ marginBottom: "10px", fontWeight: "bold" }}>
          {langString === "nl" ? "Onderwerp:" : "Subject:"} {contactEmailData.subject}
        </div>
        {contactEmailData.body && (
          <div style={{ borderTop: "1px solid #ddd", paddingTop: "10px", marginTop: "10px" }}>
            {contactEmailData.body}
          </div>
        )}
      </div>
      
      <button
        onClick={async () => {
          try {
            const fullText = `To: ${contactEmailData.email}\nSubject: ${contactEmailData.subject}${contactEmailData.body ? '\n\n' + contactEmailData.body : ''}`;
            await navigator.clipboard.writeText(fullText);
            // Show brief feedback (Android handles this silently, but we can still show feedback)
            if (langString === "nl") {
              alert("Gekopieerd naar klembord!");
            } else {
              alert("Copied to clipboard!");
            }
          } catch (error) {
            console.error("Failed to copy to clipboard:", error);
            if (langString === "nl") {
              alert("Kon niet kopiëren naar klembord. Selecteer de tekst handmatig.");
            } else {
              alert("Could not copy to clipboard. Please select the text manually.");
            }
          }
        }}
        style={{
          width: "100%",
          padding: "12px 24px",
          fontSize: "1.2rem",
          fontFamily: "Union, sans-serif",
          fontWeight: "bold",
          color: "#fff",
          background: "var(--sf-blue)",
          border: "2px solid var(--sf-blue)",
          borderRadius: "8px",
          cursor: "pointer",
        }}
      >
        {langString === "nl" ? "Kopieer naar klembord" : "Copy to Clipboard"}
      </button>
      
      <button
        onClick={() => setShowContactFallback(false)}
        style={{
          width: "100%",
          padding: "12px 24px",
          fontSize: "1.2rem",
          fontFamily: "Union, sans-serif",
          fontWeight: "bold",
          color: "var(--sf-blue)",
          background: "none",
          border: "2px solid var(--sf-blue)",
          borderRadius: "8px",
          cursor: "pointer",
          marginTop: "10px",
        }}
      >
        {langString === "nl" ? "Sluiten" : "Close"}
      </button>
    </div>
  </>
)}

{/* Rules modal */}
{showRules && (
  <>
    <div
      className="rules-overlay"
      onClick={() => { setShowRules(false); setExplanationStep(1); }}
    />
<div
  className="rules-modal"
  style={{
  position: "fixed",
  top: "45%", // was 50%, iets hoger
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 10001,
  background: "var(--sf-bg)",
  borderRadius: "12px",
  boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
  maxHeight: "90vh",
  overflowY: "auto",
  overscrollBehavior: "contain",
  padding: "12px 20px",
  width: windowWidth <= 430 ? "85%" : "90%",
  maxWidth: "360px",
  boxSizing: "border-box",
  // Set minimum height based on preloaded image dimensions to prevent layout shift
  // Use a reasonable default (400px) if images aren't loaded yet, then adjust once loaded
  minHeight: imagesLoaded && imageDimensions.height > 0 
    ? `${imageDimensions.height + 200}px` // Image height + padding for text and buttons
    : "400px", // Default min-height to prevent initial small modal
}}
>
      <div className="rules-header">
        {explanationStep === 1 && (
          <div className="rules-title">{languageString.textExplanationTitle}</div>
        )}

        {/* ✕ knop rechtsboven */}
        <button
          className="rules-close"
          onClick={() => { setShowRules(false); setExplanationStep(1); }}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "none",
            border: "none",
            fontSize: "1.2rem",
            cursor: "pointer",
            color: "var(--sf-blue)",
            lineHeight: 1,
          }}
        >
          ✕
        </button>
      </div>

      <div className="rules-body">


        {/* Then page-specific text */}
        {explanationStep === 1 && (
  <>
    <img
      className="rules-example-image"
      src={langString === "nl" ? exampleNL1 : exampleEN1}
      alt="Example 1"
      style={{
        display: "block",
        marginTop: "0px",
        marginBottom: "0px",
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "340px",
        width: "90%",
        borderRadius: "8px",
        // Reserve space to prevent layout shift
        height: imagesLoaded && imageDimensions.height > 0 ? `${imageDimensions.height}px` : "auto",
        objectFit: "contain",
      }}
    />
    <div
      style={{ marginTop: "2px" }}
      dangerouslySetInnerHTML={{ __html: languageString.textExplanation1 }}
    />
  </>
)}

{explanationStep === 2 && (
  <>
    <img
      className="rules-example-image"
      src={langString === "nl" ? exampleNL2 : exampleEN2}
      alt="Example 2"
      style={{
        display: "block",
        marginTop: "0px",
        marginBottom: "0px",
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "340px",
        width: "90%",
        borderRadius: "8px",
        // Reserve space to prevent layout shift
        height: imagesLoaded && imageDimensions.height > 0 ? `${imageDimensions.height}px` : "auto",
        objectFit: "contain",
      }}
    />
    <div
      style={{ marginTop: "2px" }}
      dangerouslySetInnerHTML={{ __html: languageString.textExplanation2 }}
    />
  </>
)}

{explanationStep === 3 && (
  <>
    <img
      className="rules-example-image"
      src={langString === "nl" ? exampleNL3 : exampleEN3}
      alt="Example 3"
      style={{
        display: "block",
        marginTop: "0px",
        marginBottom: "0px",
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "340px",
        width: "90%",
        borderRadius: "8px",
        // Reserve space to prevent layout shift
        height: imagesLoaded && imageDimensions.height > 0 ? `${imageDimensions.height}px` : "auto",
        objectFit: "contain",
      }}
    />
    <div
      style={{ marginTop: "2px" }}
      dangerouslySetInnerHTML={{ __html: languageString.textExplanation3 }}
    />
  </>
)}
      </div>

      <div className="rules-footer">
        {explanationStep < 3 ? (
          <button
            className="rules-next"
            onClick={() => setExplanationStep((s) => Math.min(3, s + 1))}
          >
            {langString === "nl" ? "Volgende" : "Next"}
          </button>
        ) : (
          <>
            <button
              className="rules-ok"
              onClick={() => { 
                setShowRules(false); 
                setExplanationStep(1);
                // On web, load tutorial when "Let's start" is clicked
                // if (isWeb()) {
                //   loadTutorial();
                // }
              }}
            >
              Ok
            </button>
          </>
        )}
      </div>
    </div>
  </>
)}

{/* First-time intro modal (only shown automatically on first app open) */}
{/* Native-style flow: iOS/Android and pubID=adv (tutorial already loaded, single Start! button, overlay doesn't mark as seen). */}
{showFirstTimeIntroModal && (() => {
  const pubIDParam = typeof window !== "undefined" ? new URLSearchParams(getAppSearchString()).get("pubID") : null;
  const pubIDIsAdv = pubIDParam === "adv";
  const treatAsNativeTutorialFlow = !isWeb() || pubIDIsAdv;
  return (
  <>
    <div
      className="rules-overlay"
      onClick={() => {
        // Web (non-adv): mark as seen when skipping / clicking outside
        // iOS/Android and pubID=adv: same as native – don't mark yet, just close
        if (!treatAsNativeTutorialFlow) {
          localStorage.setItem("hasSeenExplanation", "true");
          markTutorialAsShown();
          setShowFirstTimeIntroModal(false);
        } else {
          setShowFirstTimeIntroModal(false);
        }
      }}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 10000,
        pointerEvents: "auto",
      }}
    />
    <div
      className="rules-modal"
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 10001,
        background: "var(--sf-bg)",
        borderRadius: "12px",
        boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
        padding: "32px 24px",
        width: windowWidth <= 430 ? "85%" : "90%",
        maxWidth: "360px",
        boxSizing: "border-box",
        textAlign: "center",
      }}
    >
      <div style={{ marginBottom: "60px" }}>
        <div style={{
          fontSize: "1.5rem",
          fontWeight: "regular",
          color: "var(--text-dark)",
          marginBottom: "16px",
          fontFamily: '"Bebas Neue Pro", sans-serif',
        }}>
          {langString === "nl" ? "Vind de 3 verborgen woorden." : "Find the 3 hidden words."}
        </div>
        <div style={{
          fontSize: "1.5rem",
          color: "var(--text-dark)",
          fontFamily: '"Bebas Neue Pro", sans-serif',
        }}>
          {langString === "nl" ? (
            <>Klik om letters te onthullen.<br />Je mag 7 keer klikken.</>
          ) : (
            <>Click to reveal letters.<br />You have 7 clicks.</>
          )}
        </div>
      </div>
      
      {!treatAsNativeTutorialFlow ? (
        <>
          <button
            className="rules-ok"
            onClick={() => {
              setShowFirstTimeIntroModal(false);
              loadTutorial();
            }}
            style={{
              width: "auto",
              minWidth: "200px",
              padding: "14px 24px",
              fontSize: "1.2rem",
              fontFamily: '"Bebas Neue Pro", sans-serif',
              fontWeight: "bold",
              color: "var(--sf-bg)",
              background: "var(--sf-blue)",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              marginBottom: "12px",
              marginLeft: "auto",
              marginRight: "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              lineHeight: 1,
              WebkitAppearance: "none",
              appearance: "none",
            }}
          >
            {langString === "nl" ? "Start tutorial" : "Start tutorial"}
          </button>
          <button
            onClick={() => {
              localStorage.setItem("hasSeenExplanation", "true");
              markTutorialAsShown();
              setShowFirstTimeIntroModal(false);
            }}
            style={{
              width: "100%",
              padding: "10px 16px",
              fontSize: "1.2rem",
              fontFamily: '"Bebas Neue Pro", sans-serif',
              fontWeight: "normal",
              color: "var(--sf-blue)",
              background: "transparent",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              opacity: 0.7,
            }}
          >
            {langString === "nl" ? "Overslaan" : "Skip"}
          </button>
        </>
      ) : (
        <button
          className="rules-ok"
          onClick={() => {
            setShowFirstTimeIntroModal(false);
            // Tutorial 9999 already loaded in loadGame (native or pubID=adv)
          }}
          style={{
            width: "100%",
            padding: "14px 24px",
            fontSize: "1.2rem",
            fontFamily: '"Bebas Neue Pro", sans-serif',
            fontWeight: "bold",
            color: "var(--sf-bg)",
            background: "var(--sf-blue)",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1,
            WebkitAppearance: "none",
            appearance: "none",
          }}
        >
          {langString === "nl" ? "Start tutorial" : "Start tutorial"}
        </button>
      )}
    </div>
  </>
  );
})()}

{showProfileModal && currentUser && (
  <ProfileModal
    onClose={closeProfileModal}
    profileTexts={profileTexts}
    currentUser={currentUser}
    profileDefault={profileDefault}
    onUserUpdated={handleProfileUpdated}
    onUserLoggedOut={handleProfileLoggedOut}
    avatarCropLabels={avatarCropLabels}
  />
)}

{showRemindersModal && (
  <RemindersModal
    onClose={() => setShowRemindersModal(false)}
    langString={langString}
    game={game}
  />
)}

{/* FEATURE: BATTLE_MODE */}
{isBattleModeEnabled() && showBattleModeModal && (
  <BattleModeModal
    onClose={() => setShowBattleModeModal(false)}
    onSelectBattle={(battleId, idNumber, battleInfo) => {
      setSelectedBattleGameId(battleId);
      setSelectedBattleInfo(battleInfo);
      // Keep modal open - don't close it when selecting a battle
    }}
    refreshRef={refreshBattleListRef}
    langString={langString}
    onRequireLogin={() => {
      setShowBattleModeModal(false);
      openAuthModal(AuthModes.SIGN_UP);
    }}
  />
)}

{isBattleModeEnabled() && selectedBattleGameId && (
  <WordHitBattle
    key={selectedBattleInfo?.id || selectedBattleGameId}
    battleGameId={selectedBattleGameId}
    battleInfo={selectedBattleInfo}
    onClose={() => {
      refreshBattleListRef.current?.(); // refresh list immediately so "your turn" (green) is correct
      setSelectedBattleGameId(null);
      setSelectedBattleInfo(null);
    }}
    onNavigateToNewBattle={(nextBattleGameId, nextBattleInfo) => {
      refreshBattleListRef.current?.();
      if (nextBattleGameId && nextBattleInfo) {
        setSelectedBattleGameId(nextBattleGameId);
        setSelectedBattleInfo(nextBattleInfo);
      }
    }}
    langString={langString}
  />
)}
{/* END FEATURE: BATTLE_MODE */}

{/* Wrong guessed words modal */}
{showWrongWordsModal && (
  <>
    <div
      className="rules-overlay"
      onClick={() => setShowWrongWordsModal(false)}
      style={{ zIndex: 10000 }}
    />
    <div
      className="wrong-words-modal"
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 10001,
        background: "var(--sf-bg)",
        borderRadius: "12px",
        boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
        padding: "20px 25px",
        maxWidth: "320px",
        width: "85%",
        textAlign: "center",
      }}
    >
      <button
        className="wrong-words-close"
        onClick={() => setShowWrongWordsModal(false)}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          background: "none",
          border: "none",
          fontSize: "1.2rem",
          cursor: "pointer",
          color: "var(--sf-blue)",
          lineHeight: 1,
          padding: "4px",
        }}
        aria-label={langString === "nl" ? "Sluiten" : "Close"}
      >
        ✕
      </button>
      <h2 style={{
        fontFamily: "Union, sans-serif",
        fontSize: "1.6rem",
        fontWeight: "normal",
        color: "var(--sf-blue)",
        margin: "0 0 20px 0",
      }}>
        {langString === "nl" ? "Fout geraden woorden" : "Wrong guessed words"}
      </h2>
      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        alignItems: "center",
        maxHeight: "300px",
        overflowY: "auto",
        overflowX: "hidden",
      }}>
        {wrongGuessedWords.length === 0 ? (
          <p style={{
            fontFamily: "Union, sans-serif",
            fontSize: "1.3rem",
            color: "#666",
            margin: 0,
          }}>
            {langString === "nl" ? "Geen fout geraden woorden" : "No wrong guessed words"}
          </p>
        ) : (
          wrongGuessedWords.map((word, index) => (
            <div
              key={index}
              style={{
                fontFamily: "Union, sans-serif",
                fontSize: "1.4rem",
                fontWeight: "normal",
                color: "var(--sf-red)",
                padding: "8px 16px",
                width: "100%",
                textAlign: "center",
              }}
            >
              {word}
            </div>
          ))
        )}
      </div>
    </div>
  </>
)}

<ScoreCompetitionsModal
  visible={showScoreModal}
  onClose={closeScoreModal}
  scoreLabels={{
    score: scoreLabels.score,
    played: scoreLabels.played,
    streak: scoreLabels.streak,
    maxStreak: scoreLabels.maxStreak,
    info: scoreLabels.info,
  }}
  scoreValues={{
    score: scoreDictionary.score ?? 0,
    played: scoreDictionary.numbersPlayed ?? 0,
    streak: scoreDictionary.streak ?? 0,
    maxStreak: scoreDictionary.maxStreak ?? 0,
  }}
  messageLines={competitionMessageLines}
  competitionEntries={competitionEntries}
  competitionOppositeMonthTop3={competitionOppositeMonthTop3 || []}
  competitionLoading={competitionLoading}
  competitionError={competitionError}
  competitionMonthLabel={competitionMonthLabel}
  competitionTexts={competitionTexts}
  competitionTableLabels={competitionTableLabels}
  onCompetitionRetry={refreshCompetitionLeaderboard}
  competitionDisabled={!currentUser}
  competitionOverlayMessage={competitionOverlayMessage}
  profileDefault={profileDefault}
  onInfo={handleScoreInfoClick}
  lang={langString}
  isLoggedIn={!!currentUser}
  currentUser={currentUser}
  onFollow={currentUser ? async (usernameOrEmail) => {
    try {
      await addFriend(usernameOrEmail, langString);
      // Refresh leaderboard to show the new friend
      if (refreshCompetitionLeaderboard) {
        refreshCompetitionLeaderboard();
      }
    } catch (error) {
      throw error; // Let FollowPopup handle the error display
    }
  } : undefined}
/>

{(() => {
  // Check if game is finished
  const gameIdNumber = game?.idNumber ?? idNumber;
  const finishedLocal =
    typeof window !== "undefined" &&
    String(localStorage.getItem("finishedGameidNummer")) === String(gameIdNumber);
  const isGameFinished = hasWon || hasLost || 
    (!game?.creator && (finishedLocal || finishedIdNumbers.includes(gameIdNumber)));
  
  if (isTutorialGame(gameIdNumber)) {
    return null;
  }
  
  return (
    <Banner 
      key={game?.idNumber ?? 'no-game'} 
      numbersPlayed={scoreDictionary.numbersPlayed ?? 0} 
      langString={langString} 
      currentUser={currentUser}
      isGameFinished={isGameFinished}
      onShareScore={shareScore}
      onOpenCreateCustomWordHit={() => setShowCustomCreator(true)}
      onOpenBattleMenu={() => setShowBattleModeModal(true)}
    />
  );
})()}

    </div>
  );
}

function preloadImages(urls = [], timeoutMs = 800) {
  if (!Array.isArray(urls) || urls.length === 0) {
    return Promise.resolve();
  }
  const controller = { done: false };
  const loadPromises = urls.map((src) => new Promise((resolve) => {
    try {
      const img = new Image();
      img.onload = img.onerror = () => resolve();
      img.src = src;
    } catch (_) {
      resolve();
    }
  }));
  const timeout = new Promise((resolve) => setTimeout(resolve, timeoutMs));
  return Promise.race([Promise.all(loadPromises), timeout]).then(() => {
    controller.done = true;
  });
}